
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire82b6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire82b6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bJlpu", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $88a4814d0a9189f4$export$ffb0004e005737fa, (v) => $88a4814d0a9189f4$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $88a4814d0a9189f4$export$34b9dba7ce09269b, (v) => $88a4814d0a9189f4$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $88a4814d0a9189f4$export$25062201e9e25d76, (v) => $88a4814d0a9189f4$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $88a4814d0a9189f4$export$ffb0004e005737fa;
var $88a4814d0a9189f4$export$34b9dba7ce09269b;
var $88a4814d0a9189f4$export$25062201e9e25d76;
"use strict";
var $88a4814d0a9189f4$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $88a4814d0a9189f4$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $88a4814d0a9189f4$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $88a4814d0a9189f4$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$88a4814d0a9189f4$export$ffb0004e005737fa = $88a4814d0a9189f4$var$REACT_FRAGMENT_TYPE;
$88a4814d0a9189f4$export$34b9dba7ce09269b = $88a4814d0a9189f4$var$jsxProd;
$88a4814d0a9189f4$export$25062201e9e25d76 = $88a4814d0a9189f4$var$jsxProd;

});

parcelRegister("jXpdd", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $e877159a73c8a3d9$export$9c16c1426311996d, (v) => $e877159a73c8a3d9$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $e877159a73c8a3d9$export$dca3b0875bd9a954, (v) => $e877159a73c8a3d9$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $e877159a73c8a3d9$export$16fa2f45be04daa8, (v) => $e877159a73c8a3d9$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $e877159a73c8a3d9$export$ffb0004e005737fa, (v) => $e877159a73c8a3d9$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $e877159a73c8a3d9$export$e2c29f18771995cb, (v) => $e877159a73c8a3d9$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $e877159a73c8a3d9$export$221d75b3f55bb0bd, (v) => $e877159a73c8a3d9$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $e877159a73c8a3d9$export$5f8d39834fd61797, (v) => $e877159a73c8a3d9$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $e877159a73c8a3d9$export$74bf444e3cd11ea5, (v) => $e877159a73c8a3d9$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $e877159a73c8a3d9$export$1ced07cd6b1985ce, (v) => $e877159a73c8a3d9$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $e877159a73c8a3d9$export$abd8e32b826d7ea7, (v) => $e877159a73c8a3d9$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $e877159a73c8a3d9$export$69a3209f1a06c04d, (v) => $e877159a73c8a3d9$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $e877159a73c8a3d9$export$8c538325882c7eec, (v) => $e877159a73c8a3d9$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $e877159a73c8a3d9$export$e530037191fcd5d7, (v) => $e877159a73c8a3d9$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $e877159a73c8a3d9$export$fd42f52fd3ae1109, (v) => $e877159a73c8a3d9$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $e877159a73c8a3d9$export$c8a8987d4410bf2d, (v) => $e877159a73c8a3d9$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $e877159a73c8a3d9$export$7d1e3a5e95ceca43, (v) => $e877159a73c8a3d9$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $e877159a73c8a3d9$export$257a8862b851cb5b, (v) => $e877159a73c8a3d9$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $e877159a73c8a3d9$export$a8257692ac88316c, (v) => $e877159a73c8a3d9$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $e877159a73c8a3d9$export$488013bae63b21da, (v) => $e877159a73c8a3d9$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $e877159a73c8a3d9$export$7c73462e0d25e514, (v) => $e877159a73c8a3d9$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $e877159a73c8a3d9$export$7568632d0d33d16d, (v) => $e877159a73c8a3d9$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $e877159a73c8a3d9$export$f93f40ac0ca7e3a8, (v) => $e877159a73c8a3d9$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $e877159a73c8a3d9$export$1f96ae73734a86cc, (v) => $e877159a73c8a3d9$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $e877159a73c8a3d9$export$9a47ced3238df325, (v) => $e877159a73c8a3d9$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $e877159a73c8a3d9$export$35808ee640e87ca7, (v) => $e877159a73c8a3d9$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $e877159a73c8a3d9$export$fae74005e78b1a27, (v) => $e877159a73c8a3d9$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $e877159a73c8a3d9$export$dc8fbce3eb94dc1e, (v) => $e877159a73c8a3d9$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $e877159a73c8a3d9$export$6a7bc4e911dc01cf, (v) => $e877159a73c8a3d9$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $e877159a73c8a3d9$export$6d9c69b0de29b591, (v) => $e877159a73c8a3d9$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $e877159a73c8a3d9$export$7f54fc3180508a52, (v) => $e877159a73c8a3d9$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $e877159a73c8a3d9$export$f680877a34711e37, (v) => $e877159a73c8a3d9$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $e877159a73c8a3d9$export$d5a552a76deda3c2, (v) => $e877159a73c8a3d9$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $e877159a73c8a3d9$export$aaabe4eda9ed9969, (v) => $e877159a73c8a3d9$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $e877159a73c8a3d9$export$e5c5a5f917a5871c, (v) => $e877159a73c8a3d9$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $e877159a73c8a3d9$export$1538c33de8887b59, (v) => $e877159a73c8a3d9$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $e877159a73c8a3d9$export$fca7f784ae7a249a, (v) => $e877159a73c8a3d9$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $e877159a73c8a3d9$export$13e3392192263954, (v) => $e877159a73c8a3d9$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $e877159a73c8a3d9$export$b8f5890fc79d6aca, (v) => $e877159a73c8a3d9$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $e877159a73c8a3d9$export$60241385465d0a34, (v) => $e877159a73c8a3d9$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $e877159a73c8a3d9$export$306c0aa65ff9ec16, (v) => $e877159a73c8a3d9$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $e877159a73c8a3d9$export$7b286972b8d8ccbf, (v) => $e877159a73c8a3d9$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $e877159a73c8a3d9$export$83d89fbfd8236492, (v) => $e877159a73c8a3d9$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e877159a73c8a3d9$export$9c16c1426311996d;
var $e877159a73c8a3d9$export$dca3b0875bd9a954;
var $e877159a73c8a3d9$export$16fa2f45be04daa8;
var $e877159a73c8a3d9$export$ffb0004e005737fa;
var $e877159a73c8a3d9$export$e2c29f18771995cb;
var $e877159a73c8a3d9$export$221d75b3f55bb0bd;
var $e877159a73c8a3d9$export$5f8d39834fd61797;
var $e877159a73c8a3d9$export$74bf444e3cd11ea5;
var $e877159a73c8a3d9$export$1ced07cd6b1985ce;
var $e877159a73c8a3d9$export$abd8e32b826d7ea7;
var $e877159a73c8a3d9$export$69a3209f1a06c04d;
var $e877159a73c8a3d9$export$8c538325882c7eec;
var $e877159a73c8a3d9$export$e530037191fcd5d7;
var $e877159a73c8a3d9$export$fd42f52fd3ae1109;
var $e877159a73c8a3d9$export$c8a8987d4410bf2d;
var $e877159a73c8a3d9$export$7d1e3a5e95ceca43;
var $e877159a73c8a3d9$export$257a8862b851cb5b;
var $e877159a73c8a3d9$export$a8257692ac88316c;
var $e877159a73c8a3d9$export$488013bae63b21da;
var $e877159a73c8a3d9$export$7c73462e0d25e514;
var $e877159a73c8a3d9$export$7568632d0d33d16d;
var $e877159a73c8a3d9$export$f93f40ac0ca7e3a8;
var $e877159a73c8a3d9$export$1f96ae73734a86cc;
var $e877159a73c8a3d9$export$9a47ced3238df325;
var $e877159a73c8a3d9$export$35808ee640e87ca7;
var $e877159a73c8a3d9$export$fae74005e78b1a27;
var $e877159a73c8a3d9$export$dc8fbce3eb94dc1e;
var $e877159a73c8a3d9$export$6a7bc4e911dc01cf;
var $e877159a73c8a3d9$export$6d9c69b0de29b591;
var $e877159a73c8a3d9$export$7f54fc3180508a52;
var $e877159a73c8a3d9$export$f680877a34711e37;
var $e877159a73c8a3d9$export$d5a552a76deda3c2;
var $e877159a73c8a3d9$export$aaabe4eda9ed9969;
var $e877159a73c8a3d9$export$e5c5a5f917a5871c;
var $e877159a73c8a3d9$export$1538c33de8887b59;
var $e877159a73c8a3d9$export$fca7f784ae7a249a;
var $e877159a73c8a3d9$export$13e3392192263954;
var $e877159a73c8a3d9$export$b8f5890fc79d6aca;
var $e877159a73c8a3d9$export$60241385465d0a34;
var $e877159a73c8a3d9$export$306c0aa65ff9ec16;
var $e877159a73c8a3d9$export$7b286972b8d8ccbf;
var $e877159a73c8a3d9$export$83d89fbfd8236492;
"use strict";
var $e877159a73c8a3d9$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e877159a73c8a3d9$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $e877159a73c8a3d9$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $e877159a73c8a3d9$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $e877159a73c8a3d9$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $e877159a73c8a3d9$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $e877159a73c8a3d9$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $e877159a73c8a3d9$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $e877159a73c8a3d9$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $e877159a73c8a3d9$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $e877159a73c8a3d9$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $e877159a73c8a3d9$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $e877159a73c8a3d9$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $e877159a73c8a3d9$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $e877159a73c8a3d9$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$e877159a73c8a3d9$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $e877159a73c8a3d9$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $e877159a73c8a3d9$var$assign = Object.assign, $e877159a73c8a3d9$var$emptyObject = {};
function $e877159a73c8a3d9$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $e877159a73c8a3d9$var$emptyObject;
    this.updater = updater || $e877159a73c8a3d9$var$ReactNoopUpdateQueue;
}
$e877159a73c8a3d9$var$Component.prototype.isReactComponent = {};
$e877159a73c8a3d9$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$e877159a73c8a3d9$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $e877159a73c8a3d9$var$ComponentDummy() {}
$e877159a73c8a3d9$var$ComponentDummy.prototype = $e877159a73c8a3d9$var$Component.prototype;
function $e877159a73c8a3d9$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $e877159a73c8a3d9$var$emptyObject;
    this.updater = updater || $e877159a73c8a3d9$var$ReactNoopUpdateQueue;
}
var $e877159a73c8a3d9$var$pureComponentPrototype = $e877159a73c8a3d9$var$PureComponent.prototype = new $e877159a73c8a3d9$var$ComponentDummy();
$e877159a73c8a3d9$var$pureComponentPrototype.constructor = $e877159a73c8a3d9$var$PureComponent;
$e877159a73c8a3d9$var$assign($e877159a73c8a3d9$var$pureComponentPrototype, $e877159a73c8a3d9$var$Component.prototype);
$e877159a73c8a3d9$var$pureComponentPrototype.isPureReactComponent = !0;
var $e877159a73c8a3d9$var$isArrayImpl = Array.isArray;
function $e877159a73c8a3d9$var$noop() {}
var $e877159a73c8a3d9$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $e877159a73c8a3d9$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e877159a73c8a3d9$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $e877159a73c8a3d9$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $e877159a73c8a3d9$var$cloneAndReplaceKey(oldElement, newKey) {
    return $e877159a73c8a3d9$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $e877159a73c8a3d9$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $e877159a73c8a3d9$var$REACT_ELEMENT_TYPE;
}
function $e877159a73c8a3d9$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $e877159a73c8a3d9$var$userProvidedKeyEscapeRegex = /\/+/g;
function $e877159a73c8a3d9$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $e877159a73c8a3d9$var$escape("" + element.key) : index.toString(36);
}
function $e877159a73c8a3d9$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($e877159a73c8a3d9$var$noop, $e877159a73c8a3d9$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $e877159a73c8a3d9$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $e877159a73c8a3d9$var$REACT_ELEMENT_TYPE:
                case $e877159a73c8a3d9$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $e877159a73c8a3d9$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $e877159a73c8a3d9$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $e877159a73c8a3d9$var$getElementKey(children, 0) : nameSoFar, $e877159a73c8a3d9$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($e877159a73c8a3d9$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $e877159a73c8a3d9$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($e877159a73c8a3d9$var$isValidElement(callback) && (callback = $e877159a73c8a3d9$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($e877159a73c8a3d9$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($e877159a73c8a3d9$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $e877159a73c8a3d9$var$getElementKey(nameSoFar, i), invokeCallback += $e877159a73c8a3d9$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $e877159a73c8a3d9$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $e877159a73c8a3d9$var$getElementKey(nameSoFar, i++), invokeCallback += $e877159a73c8a3d9$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $e877159a73c8a3d9$var$mapIntoArray($e877159a73c8a3d9$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $e877159a73c8a3d9$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $e877159a73c8a3d9$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $e877159a73c8a3d9$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $e877159a73c8a3d9$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $e877159a73c8a3d9$var$Children = {
    map: $e877159a73c8a3d9$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $e877159a73c8a3d9$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $e877159a73c8a3d9$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $e877159a73c8a3d9$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$e877159a73c8a3d9$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$e877159a73c8a3d9$export$9c16c1426311996d = $e877159a73c8a3d9$var$REACT_ACTIVITY_TYPE;
$e877159a73c8a3d9$export$dca3b0875bd9a954 = $e877159a73c8a3d9$var$Children;
$e877159a73c8a3d9$export$16fa2f45be04daa8 = $e877159a73c8a3d9$var$Component;
$e877159a73c8a3d9$export$ffb0004e005737fa = $e877159a73c8a3d9$var$REACT_FRAGMENT_TYPE;
$e877159a73c8a3d9$export$e2c29f18771995cb = $e877159a73c8a3d9$var$REACT_PROFILER_TYPE;
$e877159a73c8a3d9$export$221d75b3f55bb0bd = $e877159a73c8a3d9$var$PureComponent;
$e877159a73c8a3d9$export$5f8d39834fd61797 = $e877159a73c8a3d9$var$REACT_STRICT_MODE_TYPE;
$e877159a73c8a3d9$export$74bf444e3cd11ea5 = $e877159a73c8a3d9$var$REACT_SUSPENSE_TYPE;
$e877159a73c8a3d9$export$1ced07cd6b1985ce = $e877159a73c8a3d9$var$ReactSharedInternals;
$e877159a73c8a3d9$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $e877159a73c8a3d9$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$e877159a73c8a3d9$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$e877159a73c8a3d9$export$8c538325882c7eec = function() {
    return null;
};
$e877159a73c8a3d9$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $e877159a73c8a3d9$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$e877159a73c8a3d9$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $e877159a73c8a3d9$var$ReactElement(element.type, key, props);
};
$e877159a73c8a3d9$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $e877159a73c8a3d9$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $e877159a73c8a3d9$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$e877159a73c8a3d9$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$e877159a73c8a3d9$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $e877159a73c8a3d9$var$ReactElement(type, key, props);
};
$e877159a73c8a3d9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e877159a73c8a3d9$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $e877159a73c8a3d9$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$e877159a73c8a3d9$export$a8257692ac88316c = $e877159a73c8a3d9$var$isValidElement;
$e877159a73c8a3d9$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $e877159a73c8a3d9$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $e877159a73c8a3d9$var$lazyInitializer
    };
};
$e877159a73c8a3d9$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $e877159a73c8a3d9$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$e877159a73c8a3d9$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $e877159a73c8a3d9$var$ReactSharedInternals.T, currentTransition = {};
    $e877159a73c8a3d9$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $e877159a73c8a3d9$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($e877159a73c8a3d9$var$noop, $e877159a73c8a3d9$var$reportGlobalError);
    } catch (error) {
        $e877159a73c8a3d9$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $e877159a73c8a3d9$var$ReactSharedInternals.T = prevTransition;
    }
};
$e877159a73c8a3d9$export$f93f40ac0ca7e3a8 = function() {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useCacheRefresh();
};
$e877159a73c8a3d9$export$1f96ae73734a86cc = function(usable) {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.use(usable);
};
$e877159a73c8a3d9$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$e877159a73c8a3d9$export$35808ee640e87ca7 = function(callback, deps) {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$e877159a73c8a3d9$export$fae74005e78b1a27 = function(Context) {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useContext(Context);
};
$e877159a73c8a3d9$export$dc8fbce3eb94dc1e = function() {};
$e877159a73c8a3d9$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$e877159a73c8a3d9$export$6d9c69b0de29b591 = function(create, deps) {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useEffect(create, deps);
};
$e877159a73c8a3d9$export$7f54fc3180508a52 = function(callback) {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$e877159a73c8a3d9$export$f680877a34711e37 = function() {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useId();
};
$e877159a73c8a3d9$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$e877159a73c8a3d9$export$aaabe4eda9ed9969 = function(create, deps) {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$e877159a73c8a3d9$export$e5c5a5f917a5871c = function(create, deps) {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$e877159a73c8a3d9$export$1538c33de8887b59 = function(create, deps) {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useMemo(create, deps);
};
$e877159a73c8a3d9$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$e877159a73c8a3d9$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$e877159a73c8a3d9$export$b8f5890fc79d6aca = function(initialValue) {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useRef(initialValue);
};
$e877159a73c8a3d9$export$60241385465d0a34 = function(initialState) {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useState(initialState);
};
$e877159a73c8a3d9$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$e877159a73c8a3d9$export$7b286972b8d8ccbf = function() {
    return $e877159a73c8a3d9$var$ReactSharedInternals.H.useTransition();
};
$e877159a73c8a3d9$export$83d89fbfd8236492 = "19.2.4";

});

parcelRegister("6JwTj", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $4e707583c65f6afa$export$882461b6382ed46c, (v) => $4e707583c65f6afa$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $4e707583c65f6afa$export$757ceba2d55c277e, (v) => $4e707583c65f6afa$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $4e707583c65f6afa$export$83d89fbfd8236492, (v) => $4e707583c65f6afa$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4e707583c65f6afa$export$882461b6382ed46c;
var $4e707583c65f6afa$export$757ceba2d55c277e;
var $4e707583c65f6afa$export$83d89fbfd8236492;
"use strict";

var $eOszH = parcelRequire("eOszH");

var $5jV9H = parcelRequire("5jV9H");

var $7ukom = parcelRequire("7ukom");
function $4e707583c65f6afa$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4e707583c65f6afa$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $4e707583c65f6afa$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $4e707583c65f6afa$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $4e707583c65f6afa$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $4e707583c65f6afa$var$assertIsMounted(fiber) {
    if ($4e707583c65f6afa$var$getNearestMountedFiber(fiber) !== fiber) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(188));
}
function $4e707583c65f6afa$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $4e707583c65f6afa$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $4e707583c65f6afa$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $4e707583c65f6afa$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($4e707583c65f6afa$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $4e707583c65f6afa$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $4e707583c65f6afa$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $4e707583c65f6afa$var$assign = Object.assign, $4e707583c65f6afa$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $4e707583c65f6afa$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $4e707583c65f6afa$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $4e707583c65f6afa$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $4e707583c65f6afa$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $4e707583c65f6afa$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $4e707583c65f6afa$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $4e707583c65f6afa$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $4e707583c65f6afa$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $4e707583c65f6afa$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $4e707583c65f6afa$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $4e707583c65f6afa$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $4e707583c65f6afa$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $4e707583c65f6afa$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $4e707583c65f6afa$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $4e707583c65f6afa$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $4e707583c65f6afa$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $4e707583c65f6afa$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$4e707583c65f6afa$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $4e707583c65f6afa$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $4e707583c65f6afa$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $4e707583c65f6afa$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $4e707583c65f6afa$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $4e707583c65f6afa$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $4e707583c65f6afa$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $4e707583c65f6afa$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $4e707583c65f6afa$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $4e707583c65f6afa$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $4e707583c65f6afa$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $4e707583c65f6afa$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $4e707583c65f6afa$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $4e707583c65f6afa$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $4e707583c65f6afa$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $4e707583c65f6afa$var$getComponentNameFromType(type.type) || "Memo";
        case $4e707583c65f6afa$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $4e707583c65f6afa$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $4e707583c65f6afa$var$isArrayImpl = Array.isArray, $4e707583c65f6afa$var$ReactSharedInternals = $5jV9H.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $4e707583c65f6afa$var$ReactDOMSharedInternals = $7ukom.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $4e707583c65f6afa$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $4e707583c65f6afa$var$valueStack = [], $4e707583c65f6afa$var$index = -1;
function $4e707583c65f6afa$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $4e707583c65f6afa$var$pop(cursor) {
    0 > $4e707583c65f6afa$var$index || (cursor.current = $4e707583c65f6afa$var$valueStack[$4e707583c65f6afa$var$index], $4e707583c65f6afa$var$valueStack[$4e707583c65f6afa$var$index] = null, $4e707583c65f6afa$var$index--);
}
function $4e707583c65f6afa$var$push(cursor, value) {
    $4e707583c65f6afa$var$index++;
    $4e707583c65f6afa$var$valueStack[$4e707583c65f6afa$var$index] = cursor.current;
    cursor.current = value;
}
var $4e707583c65f6afa$var$contextStackCursor = $4e707583c65f6afa$var$createCursor(null), $4e707583c65f6afa$var$contextFiberStackCursor = $4e707583c65f6afa$var$createCursor(null), $4e707583c65f6afa$var$rootInstanceStackCursor = $4e707583c65f6afa$var$createCursor(null), $4e707583c65f6afa$var$hostTransitionProviderCursor = $4e707583c65f6afa$var$createCursor(null);
function $4e707583c65f6afa$var$pushHostContainer(fiber, nextRootInstance) {
    $4e707583c65f6afa$var$push($4e707583c65f6afa$var$rootInstanceStackCursor, nextRootInstance);
    $4e707583c65f6afa$var$push($4e707583c65f6afa$var$contextFiberStackCursor, fiber);
    $4e707583c65f6afa$var$push($4e707583c65f6afa$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $4e707583c65f6afa$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $4e707583c65f6afa$var$getOwnHostContext(nextRootInstance), fiber = $4e707583c65f6afa$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $4e707583c65f6afa$var$pop($4e707583c65f6afa$var$contextStackCursor);
    $4e707583c65f6afa$var$push($4e707583c65f6afa$var$contextStackCursor, fiber);
}
function $4e707583c65f6afa$var$popHostContainer() {
    $4e707583c65f6afa$var$pop($4e707583c65f6afa$var$contextStackCursor);
    $4e707583c65f6afa$var$pop($4e707583c65f6afa$var$contextFiberStackCursor);
    $4e707583c65f6afa$var$pop($4e707583c65f6afa$var$rootInstanceStackCursor);
}
function $4e707583c65f6afa$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $4e707583c65f6afa$var$push($4e707583c65f6afa$var$hostTransitionProviderCursor, fiber);
    var context = $4e707583c65f6afa$var$contextStackCursor.current;
    var JSCompiler_inline_result = $4e707583c65f6afa$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($4e707583c65f6afa$var$push($4e707583c65f6afa$var$contextFiberStackCursor, fiber), $4e707583c65f6afa$var$push($4e707583c65f6afa$var$contextStackCursor, JSCompiler_inline_result));
}
function $4e707583c65f6afa$var$popHostContext(fiber) {
    $4e707583c65f6afa$var$contextFiberStackCursor.current === fiber && ($4e707583c65f6afa$var$pop($4e707583c65f6afa$var$contextStackCursor), $4e707583c65f6afa$var$pop($4e707583c65f6afa$var$contextFiberStackCursor));
    $4e707583c65f6afa$var$hostTransitionProviderCursor.current === fiber && ($4e707583c65f6afa$var$pop($4e707583c65f6afa$var$hostTransitionProviderCursor), $4e707583c65f6afa$var$HostTransitionContext._currentValue = $4e707583c65f6afa$var$sharedNotPendingObject);
}
var $4e707583c65f6afa$var$prefix, $4e707583c65f6afa$var$suffix;
function $4e707583c65f6afa$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $4e707583c65f6afa$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $4e707583c65f6afa$var$prefix = match && match[1] || "";
        $4e707583c65f6afa$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $4e707583c65f6afa$var$prefix + name + $4e707583c65f6afa$var$suffix;
}
var $4e707583c65f6afa$var$reentry = !1;
function $4e707583c65f6afa$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $4e707583c65f6afa$var$reentry) return "";
    $4e707583c65f6afa$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $4e707583c65f6afa$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $4e707583c65f6afa$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $4e707583c65f6afa$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $4e707583c65f6afa$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $4e707583c65f6afa$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $4e707583c65f6afa$var$describeBuiltInComponentFrame("Suspense Fallback") : $4e707583c65f6afa$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $4e707583c65f6afa$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $4e707583c65f6afa$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $4e707583c65f6afa$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $4e707583c65f6afa$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $4e707583c65f6afa$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $4e707583c65f6afa$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $4e707583c65f6afa$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $4e707583c65f6afa$var$hasOwnProperty = Object.prototype.hasOwnProperty, $4e707583c65f6afa$var$scheduleCallback$3 = $eOszH.unstable_scheduleCallback, $4e707583c65f6afa$var$cancelCallback$1 = $eOszH.unstable_cancelCallback, $4e707583c65f6afa$var$shouldYield = $eOszH.unstable_shouldYield, $4e707583c65f6afa$var$requestPaint = $eOszH.unstable_requestPaint, $4e707583c65f6afa$var$now = $eOszH.unstable_now, $4e707583c65f6afa$var$getCurrentPriorityLevel = $eOszH.unstable_getCurrentPriorityLevel, $4e707583c65f6afa$var$ImmediatePriority = $eOszH.unstable_ImmediatePriority, $4e707583c65f6afa$var$UserBlockingPriority = $eOszH.unstable_UserBlockingPriority, $4e707583c65f6afa$var$NormalPriority$1 = $eOszH.unstable_NormalPriority, $4e707583c65f6afa$var$LowPriority = $eOszH.unstable_LowPriority, $4e707583c65f6afa$var$IdlePriority = $eOszH.unstable_IdlePriority, $4e707583c65f6afa$var$log$1 = $eOszH.log, $4e707583c65f6afa$var$unstable_setDisableYieldValue = $eOszH.unstable_setDisableYieldValue, $4e707583c65f6afa$var$rendererID = null, $4e707583c65f6afa$var$injectedHook = null;
function $4e707583c65f6afa$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $4e707583c65f6afa$var$log$1 && $4e707583c65f6afa$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($4e707583c65f6afa$var$injectedHook && "function" === typeof $4e707583c65f6afa$var$injectedHook.setStrictMode) try {
        $4e707583c65f6afa$var$injectedHook.setStrictMode($4e707583c65f6afa$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $4e707583c65f6afa$var$clz32 = Math.clz32 ? Math.clz32 : $4e707583c65f6afa$var$clz32Fallback, $4e707583c65f6afa$var$log = Math.log, $4e707583c65f6afa$var$LN2 = Math.LN2;
function $4e707583c65f6afa$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($4e707583c65f6afa$var$log(x) / $4e707583c65f6afa$var$LN2 | 0) | 0;
}
var $4e707583c65f6afa$var$nextTransitionUpdateLane = 256, $4e707583c65f6afa$var$nextTransitionDeferredLane = 262144, $4e707583c65f6afa$var$nextRetryLane = 4194304;
function $4e707583c65f6afa$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $4e707583c65f6afa$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $4e707583c65f6afa$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $4e707583c65f6afa$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $4e707583c65f6afa$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $4e707583c65f6afa$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $4e707583c65f6afa$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $4e707583c65f6afa$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $4e707583c65f6afa$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $4e707583c65f6afa$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4e707583c65f6afa$var$claimNextRetryLane() {
    var lane = $4e707583c65f6afa$var$nextRetryLane;
    $4e707583c65f6afa$var$nextRetryLane <<= 1;
    0 === ($4e707583c65f6afa$var$nextRetryLane & 62914560) && ($4e707583c65f6afa$var$nextRetryLane = 4194304);
    return lane;
}
function $4e707583c65f6afa$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $4e707583c65f6afa$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $4e707583c65f6afa$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $4e707583c65f6afa$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $4e707583c65f6afa$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $4e707583c65f6afa$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $4e707583c65f6afa$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $4e707583c65f6afa$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $4e707583c65f6afa$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $4e707583c65f6afa$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $4e707583c65f6afa$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $4e707583c65f6afa$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $4e707583c65f6afa$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $4e707583c65f6afa$var$resolveUpdatePriority() {
    var updatePriority = $4e707583c65f6afa$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $4e707583c65f6afa$var$getEventPriority(updatePriority.type);
}
function $4e707583c65f6afa$var$runWithPriority(priority, fn) {
    var previousPriority = $4e707583c65f6afa$var$ReactDOMSharedInternals.p;
    try {
        return $4e707583c65f6afa$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $4e707583c65f6afa$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $4e707583c65f6afa$var$randomKey = Math.random().toString(36).slice(2), $4e707583c65f6afa$var$internalInstanceKey = "__reactFiber$" + $4e707583c65f6afa$var$randomKey, $4e707583c65f6afa$var$internalPropsKey = "__reactProps$" + $4e707583c65f6afa$var$randomKey, $4e707583c65f6afa$var$internalContainerInstanceKey = "__reactContainer$" + $4e707583c65f6afa$var$randomKey, $4e707583c65f6afa$var$internalEventHandlersKey = "__reactEvents$" + $4e707583c65f6afa$var$randomKey, $4e707583c65f6afa$var$internalEventHandlerListenersKey = "__reactListeners$" + $4e707583c65f6afa$var$randomKey, $4e707583c65f6afa$var$internalEventHandlesSetKey = "__reactHandles$" + $4e707583c65f6afa$var$randomKey, $4e707583c65f6afa$var$internalRootNodeResourcesKey = "__reactResources$" + $4e707583c65f6afa$var$randomKey, $4e707583c65f6afa$var$internalHoistableMarker = "__reactMarker$" + $4e707583c65f6afa$var$randomKey;
function $4e707583c65f6afa$var$detachDeletedInstance(node) {
    delete node[$4e707583c65f6afa$var$internalInstanceKey];
    delete node[$4e707583c65f6afa$var$internalPropsKey];
    delete node[$4e707583c65f6afa$var$internalEventHandlersKey];
    delete node[$4e707583c65f6afa$var$internalEventHandlerListenersKey];
    delete node[$4e707583c65f6afa$var$internalEventHandlesSetKey];
}
function $4e707583c65f6afa$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$4e707583c65f6afa$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$4e707583c65f6afa$var$internalContainerInstanceKey] || parentNode[$4e707583c65f6afa$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $4e707583c65f6afa$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$4e707583c65f6afa$var$internalInstanceKey]) return parentNode;
                targetNode = $4e707583c65f6afa$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $4e707583c65f6afa$var$getInstanceFromNode(node) {
    if (node = node[$4e707583c65f6afa$var$internalInstanceKey] || node[$4e707583c65f6afa$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $4e707583c65f6afa$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($4e707583c65f6afa$var$formatProdErrorMessage(33));
}
function $4e707583c65f6afa$var$getResourcesFromRoot(root) {
    var resources = root[$4e707583c65f6afa$var$internalRootNodeResourcesKey];
    resources || (resources = root[$4e707583c65f6afa$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $4e707583c65f6afa$var$markNodeAsHoistable(node) {
    node[$4e707583c65f6afa$var$internalHoistableMarker] = !0;
}
var $4e707583c65f6afa$var$allNativeEvents = new Set(), $4e707583c65f6afa$var$registrationNameDependencies = {};
function $4e707583c65f6afa$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $4e707583c65f6afa$var$registerDirectEvent(registrationName, dependencies);
    $4e707583c65f6afa$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $4e707583c65f6afa$var$registerDirectEvent(registrationName, dependencies) {
    $4e707583c65f6afa$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$4e707583c65f6afa$var$allNativeEvents.add(dependencies[registrationName]);
}
var $4e707583c65f6afa$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $4e707583c65f6afa$var$illegalAttributeNameCache = {}, $4e707583c65f6afa$var$validatedAttributeNameCache = {};
function $4e707583c65f6afa$var$isAttributeNameSafe(attributeName) {
    if ($4e707583c65f6afa$var$hasOwnProperty.call($4e707583c65f6afa$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($4e707583c65f6afa$var$hasOwnProperty.call($4e707583c65f6afa$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($4e707583c65f6afa$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $4e707583c65f6afa$var$validatedAttributeNameCache[attributeName] = !0;
    $4e707583c65f6afa$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $4e707583c65f6afa$var$setValueForAttribute(node, name, value) {
    if ($4e707583c65f6afa$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $4e707583c65f6afa$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $4e707583c65f6afa$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $4e707583c65f6afa$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $4e707583c65f6afa$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $4e707583c65f6afa$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $4e707583c65f6afa$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $4e707583c65f6afa$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $4e707583c65f6afa$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $4e707583c65f6afa$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $4e707583c65f6afa$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $4e707583c65f6afa$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $4e707583c65f6afa$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $4e707583c65f6afa$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($4e707583c65f6afa$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $4e707583c65f6afa$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $4e707583c65f6afa$var$getToStringValue(value);
        } else element.value !== "" + $4e707583c65f6afa$var$getToStringValue(value) && (element.value = "" + $4e707583c65f6afa$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $4e707583c65f6afa$var$setDefaultValue(element, type, $4e707583c65f6afa$var$getToStringValue(value)) : null != defaultValue ? $4e707583c65f6afa$var$setDefaultValue(element, type, $4e707583c65f6afa$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $4e707583c65f6afa$var$getToStringValue(name) : element.removeAttribute("name");
}
function $4e707583c65f6afa$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $4e707583c65f6afa$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $4e707583c65f6afa$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $4e707583c65f6afa$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $4e707583c65f6afa$var$track(element);
}
function $4e707583c65f6afa$var$setDefaultValue(node, type, value) {
    "number" === type && $4e707583c65f6afa$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $4e707583c65f6afa$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $4e707583c65f6afa$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $4e707583c65f6afa$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $4e707583c65f6afa$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $4e707583c65f6afa$var$getToStringValue(defaultValue) : "";
}
function $4e707583c65f6afa$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(92));
            if ($4e707583c65f6afa$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $4e707583c65f6afa$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $4e707583c65f6afa$var$track(element);
}
function $4e707583c65f6afa$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $4e707583c65f6afa$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $4e707583c65f6afa$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $4e707583c65f6afa$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $4e707583c65f6afa$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $4e707583c65f6afa$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $4e707583c65f6afa$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $4e707583c65f6afa$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4e707583c65f6afa$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $4e707583c65f6afa$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $4e707583c65f6afa$var$sanitizeURL(url) {
    return $4e707583c65f6afa$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $4e707583c65f6afa$var$noop$1() {}
var $4e707583c65f6afa$var$currentReplayingEvent = null;
function $4e707583c65f6afa$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $4e707583c65f6afa$var$restoreTarget = null, $4e707583c65f6afa$var$restoreQueue = null;
function $4e707583c65f6afa$var$restoreStateOfTarget(target) {
    var internalInstance = $4e707583c65f6afa$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$4e707583c65f6afa$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $4e707583c65f6afa$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $4e707583c65f6afa$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$4e707583c65f6afa$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(90));
                            $4e707583c65f6afa$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $4e707583c65f6afa$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $4e707583c65f6afa$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $4e707583c65f6afa$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $4e707583c65f6afa$var$isInsideEventHandler = !1;
function $4e707583c65f6afa$var$batchedUpdates$1(fn, a, b) {
    if ($4e707583c65f6afa$var$isInsideEventHandler) return fn(a, b);
    $4e707583c65f6afa$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($4e707583c65f6afa$var$isInsideEventHandler = !1, null !== $4e707583c65f6afa$var$restoreTarget || null !== $4e707583c65f6afa$var$restoreQueue) {
            if ($4e707583c65f6afa$var$flushSyncWork$1(), $4e707583c65f6afa$var$restoreTarget && (a = $4e707583c65f6afa$var$restoreTarget, fn = $4e707583c65f6afa$var$restoreQueue, $4e707583c65f6afa$var$restoreQueue = $4e707583c65f6afa$var$restoreTarget = null, $4e707583c65f6afa$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$4e707583c65f6afa$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $4e707583c65f6afa$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$4e707583c65f6afa$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $4e707583c65f6afa$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4e707583c65f6afa$var$passiveBrowserEventsSupported = !1;
if ($4e707583c65f6afa$var$canUseDOM) try {
    var $4e707583c65f6afa$var$options = {};
    Object.defineProperty($4e707583c65f6afa$var$options, "passive", {
        get: function() {
            $4e707583c65f6afa$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $4e707583c65f6afa$var$options, $4e707583c65f6afa$var$options);
    window.removeEventListener("test", $4e707583c65f6afa$var$options, $4e707583c65f6afa$var$options);
} catch (e) {
    $4e707583c65f6afa$var$passiveBrowserEventsSupported = !1;
}
var $4e707583c65f6afa$var$root = null, $4e707583c65f6afa$var$startText = null, $4e707583c65f6afa$var$fallbackText = null;
function $4e707583c65f6afa$var$getData() {
    if ($4e707583c65f6afa$var$fallbackText) return $4e707583c65f6afa$var$fallbackText;
    var start, startValue = $4e707583c65f6afa$var$startText, startLength = startValue.length, end, endValue = "value" in $4e707583c65f6afa$var$root ? $4e707583c65f6afa$var$root.value : $4e707583c65f6afa$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $4e707583c65f6afa$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $4e707583c65f6afa$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $4e707583c65f6afa$var$functionThatReturnsTrue() {
    return !0;
}
function $4e707583c65f6afa$var$functionThatReturnsFalse() {
    return !1;
}
function $4e707583c65f6afa$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $4e707583c65f6afa$var$functionThatReturnsTrue : $4e707583c65f6afa$var$functionThatReturnsFalse;
        this.isPropagationStopped = $4e707583c65f6afa$var$functionThatReturnsFalse;
        return this;
    }
    $4e707583c65f6afa$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $4e707583c65f6afa$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $4e707583c65f6afa$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $4e707583c65f6afa$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $4e707583c65f6afa$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4e707583c65f6afa$var$SyntheticEvent = $4e707583c65f6afa$var$createSyntheticEvent($4e707583c65f6afa$var$EventInterface), $4e707583c65f6afa$var$UIEventInterface = $4e707583c65f6afa$var$assign({}, $4e707583c65f6afa$var$EventInterface, {
    view: 0,
    detail: 0
}), $4e707583c65f6afa$var$SyntheticUIEvent = $4e707583c65f6afa$var$createSyntheticEvent($4e707583c65f6afa$var$UIEventInterface), $4e707583c65f6afa$var$lastMovementX, $4e707583c65f6afa$var$lastMovementY, $4e707583c65f6afa$var$lastMouseEvent, $4e707583c65f6afa$var$MouseEventInterface = $4e707583c65f6afa$var$assign({}, $4e707583c65f6afa$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4e707583c65f6afa$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $4e707583c65f6afa$var$lastMouseEvent && ($4e707583c65f6afa$var$lastMouseEvent && "mousemove" === event.type ? ($4e707583c65f6afa$var$lastMovementX = event.screenX - $4e707583c65f6afa$var$lastMouseEvent.screenX, $4e707583c65f6afa$var$lastMovementY = event.screenY - $4e707583c65f6afa$var$lastMouseEvent.screenY) : $4e707583c65f6afa$var$lastMovementY = $4e707583c65f6afa$var$lastMovementX = 0, $4e707583c65f6afa$var$lastMouseEvent = event);
        return $4e707583c65f6afa$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $4e707583c65f6afa$var$lastMovementY;
    }
}), $4e707583c65f6afa$var$SyntheticMouseEvent = $4e707583c65f6afa$var$createSyntheticEvent($4e707583c65f6afa$var$MouseEventInterface), $4e707583c65f6afa$var$DragEventInterface = $4e707583c65f6afa$var$assign({}, $4e707583c65f6afa$var$MouseEventInterface, {
    dataTransfer: 0
}), $4e707583c65f6afa$var$SyntheticDragEvent = $4e707583c65f6afa$var$createSyntheticEvent($4e707583c65f6afa$var$DragEventInterface), $4e707583c65f6afa$var$FocusEventInterface = $4e707583c65f6afa$var$assign({}, $4e707583c65f6afa$var$UIEventInterface, {
    relatedTarget: 0
}), $4e707583c65f6afa$var$SyntheticFocusEvent = $4e707583c65f6afa$var$createSyntheticEvent($4e707583c65f6afa$var$FocusEventInterface), $4e707583c65f6afa$var$AnimationEventInterface = $4e707583c65f6afa$var$assign({}, $4e707583c65f6afa$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4e707583c65f6afa$var$SyntheticAnimationEvent = $4e707583c65f6afa$var$createSyntheticEvent($4e707583c65f6afa$var$AnimationEventInterface), $4e707583c65f6afa$var$ClipboardEventInterface = $4e707583c65f6afa$var$assign({}, $4e707583c65f6afa$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $4e707583c65f6afa$var$SyntheticClipboardEvent = $4e707583c65f6afa$var$createSyntheticEvent($4e707583c65f6afa$var$ClipboardEventInterface), $4e707583c65f6afa$var$CompositionEventInterface = $4e707583c65f6afa$var$assign({}, $4e707583c65f6afa$var$EventInterface, {
    data: 0
}), $4e707583c65f6afa$var$SyntheticCompositionEvent = $4e707583c65f6afa$var$createSyntheticEvent($4e707583c65f6afa$var$CompositionEventInterface), $4e707583c65f6afa$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4e707583c65f6afa$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4e707583c65f6afa$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4e707583c65f6afa$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $4e707583c65f6afa$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $4e707583c65f6afa$var$getEventModifierState() {
    return $4e707583c65f6afa$var$modifierStateGetter;
}
var $4e707583c65f6afa$var$KeyboardEventInterface = $4e707583c65f6afa$var$assign({}, $4e707583c65f6afa$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $4e707583c65f6afa$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $4e707583c65f6afa$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $4e707583c65f6afa$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4e707583c65f6afa$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $4e707583c65f6afa$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $4e707583c65f6afa$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $4e707583c65f6afa$var$SyntheticKeyboardEvent = $4e707583c65f6afa$var$createSyntheticEvent($4e707583c65f6afa$var$KeyboardEventInterface), $4e707583c65f6afa$var$PointerEventInterface = $4e707583c65f6afa$var$assign({}, $4e707583c65f6afa$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4e707583c65f6afa$var$SyntheticPointerEvent = $4e707583c65f6afa$var$createSyntheticEvent($4e707583c65f6afa$var$PointerEventInterface), $4e707583c65f6afa$var$TouchEventInterface = $4e707583c65f6afa$var$assign({}, $4e707583c65f6afa$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4e707583c65f6afa$var$getEventModifierState
}), $4e707583c65f6afa$var$SyntheticTouchEvent = $4e707583c65f6afa$var$createSyntheticEvent($4e707583c65f6afa$var$TouchEventInterface), $4e707583c65f6afa$var$TransitionEventInterface = $4e707583c65f6afa$var$assign({}, $4e707583c65f6afa$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4e707583c65f6afa$var$SyntheticTransitionEvent = $4e707583c65f6afa$var$createSyntheticEvent($4e707583c65f6afa$var$TransitionEventInterface), $4e707583c65f6afa$var$WheelEventInterface = $4e707583c65f6afa$var$assign({}, $4e707583c65f6afa$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4e707583c65f6afa$var$SyntheticWheelEvent = $4e707583c65f6afa$var$createSyntheticEvent($4e707583c65f6afa$var$WheelEventInterface), $4e707583c65f6afa$var$ToggleEventInterface = $4e707583c65f6afa$var$assign({}, $4e707583c65f6afa$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $4e707583c65f6afa$var$SyntheticToggleEvent = $4e707583c65f6afa$var$createSyntheticEvent($4e707583c65f6afa$var$ToggleEventInterface), $4e707583c65f6afa$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $4e707583c65f6afa$var$canUseCompositionEvent = $4e707583c65f6afa$var$canUseDOM && "CompositionEvent" in window, $4e707583c65f6afa$var$documentMode = null;
$4e707583c65f6afa$var$canUseDOM && "documentMode" in document && ($4e707583c65f6afa$var$documentMode = document.documentMode);
var $4e707583c65f6afa$var$canUseTextInputEvent = $4e707583c65f6afa$var$canUseDOM && "TextEvent" in window && !$4e707583c65f6afa$var$documentMode, $4e707583c65f6afa$var$useFallbackCompositionData = $4e707583c65f6afa$var$canUseDOM && (!$4e707583c65f6afa$var$canUseCompositionEvent || $4e707583c65f6afa$var$documentMode && 8 < $4e707583c65f6afa$var$documentMode && 11 >= $4e707583c65f6afa$var$documentMode), $4e707583c65f6afa$var$SPACEBAR_CHAR = String.fromCharCode(32), $4e707583c65f6afa$var$hasSpaceKeypress = !1;
function $4e707583c65f6afa$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $4e707583c65f6afa$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4e707583c65f6afa$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $4e707583c65f6afa$var$isComposing = !1;
function $4e707583c65f6afa$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $4e707583c65f6afa$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $4e707583c65f6afa$var$hasSpaceKeypress = !0;
            return $4e707583c65f6afa$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $4e707583c65f6afa$var$SPACEBAR_CHAR && $4e707583c65f6afa$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $4e707583c65f6afa$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($4e707583c65f6afa$var$isComposing) return "compositionend" === domEventName || !$4e707583c65f6afa$var$canUseCompositionEvent && $4e707583c65f6afa$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $4e707583c65f6afa$var$getData(), $4e707583c65f6afa$var$fallbackText = $4e707583c65f6afa$var$startText = $4e707583c65f6afa$var$root = null, $4e707583c65f6afa$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $4e707583c65f6afa$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $4e707583c65f6afa$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4e707583c65f6afa$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$4e707583c65f6afa$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $4e707583c65f6afa$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $4e707583c65f6afa$var$restoreTarget ? $4e707583c65f6afa$var$restoreQueue ? $4e707583c65f6afa$var$restoreQueue.push(target) : $4e707583c65f6afa$var$restoreQueue = [
        target
    ] : $4e707583c65f6afa$var$restoreTarget = target;
    inst = $4e707583c65f6afa$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $4e707583c65f6afa$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $4e707583c65f6afa$var$activeElement$1 = null, $4e707583c65f6afa$var$activeElementInst$1 = null;
function $4e707583c65f6afa$var$runEventInBatch(dispatchQueue) {
    $4e707583c65f6afa$var$processDispatchQueue(dispatchQueue, 0);
}
function $4e707583c65f6afa$var$getInstIfValueChanged(targetInst) {
    var targetNode = $4e707583c65f6afa$var$getNodeFromInstance(targetInst);
    if ($4e707583c65f6afa$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $4e707583c65f6afa$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $4e707583c65f6afa$var$isInputEventSupported = !1;
if ($4e707583c65f6afa$var$canUseDOM) {
    var $4e707583c65f6afa$var$JSCompiler_inline_result$jscomp$286;
    if ($4e707583c65f6afa$var$canUseDOM) {
        var $4e707583c65f6afa$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$4e707583c65f6afa$var$isSupported$jscomp$inline_427) {
            var $4e707583c65f6afa$var$element$jscomp$inline_428 = document.createElement("div");
            $4e707583c65f6afa$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $4e707583c65f6afa$var$isSupported$jscomp$inline_427 = "function" === typeof $4e707583c65f6afa$var$element$jscomp$inline_428.oninput;
        }
        $4e707583c65f6afa$var$JSCompiler_inline_result$jscomp$286 = $4e707583c65f6afa$var$isSupported$jscomp$inline_427;
    } else $4e707583c65f6afa$var$JSCompiler_inline_result$jscomp$286 = !1;
    $4e707583c65f6afa$var$isInputEventSupported = $4e707583c65f6afa$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $4e707583c65f6afa$var$stopWatchingForValueChange() {
    $4e707583c65f6afa$var$activeElement$1 && ($4e707583c65f6afa$var$activeElement$1.detachEvent("onpropertychange", $4e707583c65f6afa$var$handlePropertyChange), $4e707583c65f6afa$var$activeElementInst$1 = $4e707583c65f6afa$var$activeElement$1 = null);
}
function $4e707583c65f6afa$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $4e707583c65f6afa$var$getInstIfValueChanged($4e707583c65f6afa$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $4e707583c65f6afa$var$createAndAccumulateChangeEvent(dispatchQueue, $4e707583c65f6afa$var$activeElementInst$1, nativeEvent, $4e707583c65f6afa$var$getEventTarget(nativeEvent));
        $4e707583c65f6afa$var$batchedUpdates$1($4e707583c65f6afa$var$runEventInBatch, dispatchQueue);
    }
}
function $4e707583c65f6afa$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($4e707583c65f6afa$var$stopWatchingForValueChange(), $4e707583c65f6afa$var$activeElement$1 = target, $4e707583c65f6afa$var$activeElementInst$1 = targetInst, $4e707583c65f6afa$var$activeElement$1.attachEvent("onpropertychange", $4e707583c65f6afa$var$handlePropertyChange)) : "focusout" === domEventName && $4e707583c65f6afa$var$stopWatchingForValueChange();
}
function $4e707583c65f6afa$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $4e707583c65f6afa$var$getInstIfValueChanged($4e707583c65f6afa$var$activeElementInst$1);
}
function $4e707583c65f6afa$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $4e707583c65f6afa$var$getInstIfValueChanged(targetInst);
}
function $4e707583c65f6afa$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $4e707583c65f6afa$var$getInstIfValueChanged(targetInst);
}
function $4e707583c65f6afa$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $4e707583c65f6afa$var$objectIs = "function" === typeof Object.is ? Object.is : $4e707583c65f6afa$var$is;
function $4e707583c65f6afa$var$shallowEqual(objA, objB) {
    if ($4e707583c65f6afa$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$4e707583c65f6afa$var$hasOwnProperty.call(objB, currentKey) || !$4e707583c65f6afa$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $4e707583c65f6afa$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $4e707583c65f6afa$var$getNodeForCharacterOffset(root, offset) {
    var node = $4e707583c65f6afa$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $4e707583c65f6afa$var$getLeafNode(node);
    }
}
function $4e707583c65f6afa$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $4e707583c65f6afa$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $4e707583c65f6afa$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $4e707583c65f6afa$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $4e707583c65f6afa$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $4e707583c65f6afa$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $4e707583c65f6afa$var$skipSelectionChangeEvent = $4e707583c65f6afa$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $4e707583c65f6afa$var$activeElement = null, $4e707583c65f6afa$var$activeElementInst = null, $4e707583c65f6afa$var$lastSelection = null, $4e707583c65f6afa$var$mouseDown = !1;
function $4e707583c65f6afa$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $4e707583c65f6afa$var$mouseDown || null == $4e707583c65f6afa$var$activeElement || $4e707583c65f6afa$var$activeElement !== $4e707583c65f6afa$var$getActiveElement(doc) || (doc = $4e707583c65f6afa$var$activeElement, "selectionStart" in doc && $4e707583c65f6afa$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $4e707583c65f6afa$var$lastSelection && $4e707583c65f6afa$var$shallowEqual($4e707583c65f6afa$var$lastSelection, doc) || ($4e707583c65f6afa$var$lastSelection = doc, doc = $4e707583c65f6afa$var$accumulateTwoPhaseListeners($4e707583c65f6afa$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $4e707583c65f6afa$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $4e707583c65f6afa$var$activeElement)));
}
function $4e707583c65f6afa$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $4e707583c65f6afa$var$vendorPrefixes = {
    animationend: $4e707583c65f6afa$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $4e707583c65f6afa$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $4e707583c65f6afa$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $4e707583c65f6afa$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $4e707583c65f6afa$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $4e707583c65f6afa$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $4e707583c65f6afa$var$makePrefixMap("Transition", "TransitionEnd")
}, $4e707583c65f6afa$var$prefixedEventNames = {}, $4e707583c65f6afa$var$style = {};
$4e707583c65f6afa$var$canUseDOM && ($4e707583c65f6afa$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $4e707583c65f6afa$var$vendorPrefixes.animationend.animation, delete $4e707583c65f6afa$var$vendorPrefixes.animationiteration.animation, delete $4e707583c65f6afa$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $4e707583c65f6afa$var$vendorPrefixes.transitionend.transition);
function $4e707583c65f6afa$var$getVendorPrefixedEventName(eventName) {
    if ($4e707583c65f6afa$var$prefixedEventNames[eventName]) return $4e707583c65f6afa$var$prefixedEventNames[eventName];
    if (!$4e707583c65f6afa$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $4e707583c65f6afa$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $4e707583c65f6afa$var$style) return $4e707583c65f6afa$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $4e707583c65f6afa$var$ANIMATION_END = $4e707583c65f6afa$var$getVendorPrefixedEventName("animationend"), $4e707583c65f6afa$var$ANIMATION_ITERATION = $4e707583c65f6afa$var$getVendorPrefixedEventName("animationiteration"), $4e707583c65f6afa$var$ANIMATION_START = $4e707583c65f6afa$var$getVendorPrefixedEventName("animationstart"), $4e707583c65f6afa$var$TRANSITION_RUN = $4e707583c65f6afa$var$getVendorPrefixedEventName("transitionrun"), $4e707583c65f6afa$var$TRANSITION_START = $4e707583c65f6afa$var$getVendorPrefixedEventName("transitionstart"), $4e707583c65f6afa$var$TRANSITION_CANCEL = $4e707583c65f6afa$var$getVendorPrefixedEventName("transitioncancel"), $4e707583c65f6afa$var$TRANSITION_END = $4e707583c65f6afa$var$getVendorPrefixedEventName("transitionend"), $4e707583c65f6afa$var$topLevelEventsToReactNames = new Map(), $4e707583c65f6afa$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$4e707583c65f6afa$var$simpleEventPluginEvents.push("scrollEnd");
function $4e707583c65f6afa$var$registerSimpleEvent(domEventName, reactName) {
    $4e707583c65f6afa$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $4e707583c65f6afa$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $4e707583c65f6afa$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $4e707583c65f6afa$var$concurrentQueues = [], $4e707583c65f6afa$var$concurrentQueuesIndex = 0, $4e707583c65f6afa$var$concurrentlyUpdatedLanes = 0;
function $4e707583c65f6afa$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $4e707583c65f6afa$var$concurrentQueuesIndex, i = $4e707583c65f6afa$var$concurrentlyUpdatedLanes = $4e707583c65f6afa$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $4e707583c65f6afa$var$concurrentQueues[i];
        $4e707583c65f6afa$var$concurrentQueues[i++] = null;
        var queue = $4e707583c65f6afa$var$concurrentQueues[i];
        $4e707583c65f6afa$var$concurrentQueues[i++] = null;
        var update = $4e707583c65f6afa$var$concurrentQueues[i];
        $4e707583c65f6afa$var$concurrentQueues[i++] = null;
        var lane = $4e707583c65f6afa$var$concurrentQueues[i];
        $4e707583c65f6afa$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $4e707583c65f6afa$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $4e707583c65f6afa$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $4e707583c65f6afa$var$concurrentQueues[$4e707583c65f6afa$var$concurrentQueuesIndex++] = fiber;
    $4e707583c65f6afa$var$concurrentQueues[$4e707583c65f6afa$var$concurrentQueuesIndex++] = queue;
    $4e707583c65f6afa$var$concurrentQueues[$4e707583c65f6afa$var$concurrentQueuesIndex++] = update;
    $4e707583c65f6afa$var$concurrentQueues[$4e707583c65f6afa$var$concurrentQueuesIndex++] = lane;
    $4e707583c65f6afa$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $4e707583c65f6afa$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $4e707583c65f6afa$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $4e707583c65f6afa$var$getRootForUpdatedFiber(fiber);
}
function $4e707583c65f6afa$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $4e707583c65f6afa$var$enqueueUpdate$1(fiber, null, null, lane);
    return $4e707583c65f6afa$var$getRootForUpdatedFiber(fiber);
}
function $4e707583c65f6afa$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $4e707583c65f6afa$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $4e707583c65f6afa$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $4e707583c65f6afa$var$nestedUpdateCount) throw $4e707583c65f6afa$var$nestedUpdateCount = 0, $4e707583c65f6afa$var$rootWithNestedUpdates = null, Error($4e707583c65f6afa$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $4e707583c65f6afa$var$emptyContextObject = {};
function $4e707583c65f6afa$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4e707583c65f6afa$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $4e707583c65f6afa$var$FiberNode(tag, pendingProps, key, mode);
}
function $4e707583c65f6afa$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $4e707583c65f6afa$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $4e707583c65f6afa$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $4e707583c65f6afa$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $4e707583c65f6afa$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $4e707583c65f6afa$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $4e707583c65f6afa$var$isHostHoistableType(type, pendingProps, $4e707583c65f6afa$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $4e707583c65f6afa$var$REACT_ACTIVITY_TYPE:
            return type = $4e707583c65f6afa$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $4e707583c65f6afa$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $4e707583c65f6afa$var$REACT_FRAGMENT_TYPE:
            return $4e707583c65f6afa$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $4e707583c65f6afa$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $4e707583c65f6afa$var$REACT_PROFILER_TYPE:
            return type = $4e707583c65f6afa$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $4e707583c65f6afa$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $4e707583c65f6afa$var$REACT_SUSPENSE_TYPE:
            return type = $4e707583c65f6afa$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $4e707583c65f6afa$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $4e707583c65f6afa$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $4e707583c65f6afa$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $4e707583c65f6afa$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $4e707583c65f6afa$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $4e707583c65f6afa$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $4e707583c65f6afa$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $4e707583c65f6afa$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $4e707583c65f6afa$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($4e707583c65f6afa$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $4e707583c65f6afa$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $4e707583c65f6afa$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $4e707583c65f6afa$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $4e707583c65f6afa$var$createFiberFromText(content, mode, lanes) {
    content = $4e707583c65f6afa$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $4e707583c65f6afa$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $4e707583c65f6afa$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $4e707583c65f6afa$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $4e707583c65f6afa$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $4e707583c65f6afa$var$CapturedStacks = new WeakMap();
function $4e707583c65f6afa$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $4e707583c65f6afa$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $4e707583c65f6afa$var$getStackByFiberInDevAndProd(source)
        };
        $4e707583c65f6afa$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $4e707583c65f6afa$var$getStackByFiberInDevAndProd(source)
    };
}
var $4e707583c65f6afa$var$forkStack = [], $4e707583c65f6afa$var$forkStackIndex = 0, $4e707583c65f6afa$var$treeForkProvider = null, $4e707583c65f6afa$var$treeForkCount = 0, $4e707583c65f6afa$var$idStack = [], $4e707583c65f6afa$var$idStackIndex = 0, $4e707583c65f6afa$var$treeContextProvider = null, $4e707583c65f6afa$var$treeContextId = 1, $4e707583c65f6afa$var$treeContextOverflow = "";
function $4e707583c65f6afa$var$pushTreeFork(workInProgress, totalChildren) {
    $4e707583c65f6afa$var$forkStack[$4e707583c65f6afa$var$forkStackIndex++] = $4e707583c65f6afa$var$treeForkCount;
    $4e707583c65f6afa$var$forkStack[$4e707583c65f6afa$var$forkStackIndex++] = $4e707583c65f6afa$var$treeForkProvider;
    $4e707583c65f6afa$var$treeForkProvider = workInProgress;
    $4e707583c65f6afa$var$treeForkCount = totalChildren;
}
function $4e707583c65f6afa$var$pushTreeId(workInProgress, totalChildren, index) {
    $4e707583c65f6afa$var$idStack[$4e707583c65f6afa$var$idStackIndex++] = $4e707583c65f6afa$var$treeContextId;
    $4e707583c65f6afa$var$idStack[$4e707583c65f6afa$var$idStackIndex++] = $4e707583c65f6afa$var$treeContextOverflow;
    $4e707583c65f6afa$var$idStack[$4e707583c65f6afa$var$idStackIndex++] = $4e707583c65f6afa$var$treeContextProvider;
    $4e707583c65f6afa$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $4e707583c65f6afa$var$treeContextId;
    workInProgress = $4e707583c65f6afa$var$treeContextOverflow;
    var baseLength = 32 - $4e707583c65f6afa$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $4e707583c65f6afa$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $4e707583c65f6afa$var$treeContextId = 1 << 32 - $4e707583c65f6afa$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $4e707583c65f6afa$var$treeContextOverflow = length + workInProgress;
    } else $4e707583c65f6afa$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $4e707583c65f6afa$var$treeContextOverflow = workInProgress;
}
function $4e707583c65f6afa$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($4e707583c65f6afa$var$pushTreeFork(workInProgress, 1), $4e707583c65f6afa$var$pushTreeId(workInProgress, 1, 0));
}
function $4e707583c65f6afa$var$popTreeContext(workInProgress) {
    for(; workInProgress === $4e707583c65f6afa$var$treeForkProvider;)$4e707583c65f6afa$var$treeForkProvider = $4e707583c65f6afa$var$forkStack[--$4e707583c65f6afa$var$forkStackIndex], $4e707583c65f6afa$var$forkStack[$4e707583c65f6afa$var$forkStackIndex] = null, $4e707583c65f6afa$var$treeForkCount = $4e707583c65f6afa$var$forkStack[--$4e707583c65f6afa$var$forkStackIndex], $4e707583c65f6afa$var$forkStack[$4e707583c65f6afa$var$forkStackIndex] = null;
    for(; workInProgress === $4e707583c65f6afa$var$treeContextProvider;)$4e707583c65f6afa$var$treeContextProvider = $4e707583c65f6afa$var$idStack[--$4e707583c65f6afa$var$idStackIndex], $4e707583c65f6afa$var$idStack[$4e707583c65f6afa$var$idStackIndex] = null, $4e707583c65f6afa$var$treeContextOverflow = $4e707583c65f6afa$var$idStack[--$4e707583c65f6afa$var$idStackIndex], $4e707583c65f6afa$var$idStack[$4e707583c65f6afa$var$idStackIndex] = null, $4e707583c65f6afa$var$treeContextId = $4e707583c65f6afa$var$idStack[--$4e707583c65f6afa$var$idStackIndex], $4e707583c65f6afa$var$idStack[$4e707583c65f6afa$var$idStackIndex] = null;
}
function $4e707583c65f6afa$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $4e707583c65f6afa$var$idStack[$4e707583c65f6afa$var$idStackIndex++] = $4e707583c65f6afa$var$treeContextId;
    $4e707583c65f6afa$var$idStack[$4e707583c65f6afa$var$idStackIndex++] = $4e707583c65f6afa$var$treeContextOverflow;
    $4e707583c65f6afa$var$idStack[$4e707583c65f6afa$var$idStackIndex++] = $4e707583c65f6afa$var$treeContextProvider;
    $4e707583c65f6afa$var$treeContextId = suspendedContext.id;
    $4e707583c65f6afa$var$treeContextOverflow = suspendedContext.overflow;
    $4e707583c65f6afa$var$treeContextProvider = workInProgress;
}
var $4e707583c65f6afa$var$hydrationParentFiber = null, $4e707583c65f6afa$var$nextHydratableInstance = null, $4e707583c65f6afa$var$isHydrating = !1, $4e707583c65f6afa$var$hydrationErrors = null, $4e707583c65f6afa$var$rootOrSingletonContext = !1, $4e707583c65f6afa$var$HydrationMismatchException = Error($4e707583c65f6afa$var$formatProdErrorMessage(519));
function $4e707583c65f6afa$var$throwOnHydrationMismatch(fiber) {
    var error = Error($4e707583c65f6afa$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $4e707583c65f6afa$var$queueHydrationError($4e707583c65f6afa$var$createCapturedValueAtFiber(error, fiber));
    throw $4e707583c65f6afa$var$HydrationMismatchException;
}
function $4e707583c65f6afa$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$4e707583c65f6afa$var$internalInstanceKey] = fiber;
    instance[$4e707583c65f6afa$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("cancel", instance);
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $4e707583c65f6afa$var$mediaEventTypes.length; type++)$4e707583c65f6afa$var$listenToNonDelegatedEvent($4e707583c65f6afa$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("error", instance);
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("invalid", instance);
            $4e707583c65f6afa$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("invalid", instance), $4e707583c65f6afa$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $4e707583c65f6afa$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($4e707583c65f6afa$var$listenToNonDelegatedEvent("beforetoggle", instance), $4e707583c65f6afa$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $4e707583c65f6afa$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $4e707583c65f6afa$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $4e707583c65f6afa$var$noop$1), instance = !0) : instance = !1;
    instance || $4e707583c65f6afa$var$throwOnHydrationMismatch(fiber, !0);
}
function $4e707583c65f6afa$var$popToNextHostParent(fiber) {
    for($4e707583c65f6afa$var$hydrationParentFiber = fiber.return; $4e707583c65f6afa$var$hydrationParentFiber;)switch($4e707583c65f6afa$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $4e707583c65f6afa$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $4e707583c65f6afa$var$rootOrSingletonContext = !0;
            return;
        default:
            $4e707583c65f6afa$var$hydrationParentFiber = $4e707583c65f6afa$var$hydrationParentFiber.return;
    }
}
function $4e707583c65f6afa$var$popHydrationState(fiber) {
    if (fiber !== $4e707583c65f6afa$var$hydrationParentFiber) return !1;
    if (!$4e707583c65f6afa$var$isHydrating) return $4e707583c65f6afa$var$popToNextHostParent(fiber), $4e707583c65f6afa$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $4e707583c65f6afa$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $4e707583c65f6afa$var$nextHydratableInstance && $4e707583c65f6afa$var$throwOnHydrationMismatch(fiber);
    $4e707583c65f6afa$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(317));
        $4e707583c65f6afa$var$nextHydratableInstance = $4e707583c65f6afa$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(317));
        $4e707583c65f6afa$var$nextHydratableInstance = $4e707583c65f6afa$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $4e707583c65f6afa$var$nextHydratableInstance, $4e707583c65f6afa$var$isSingletonScope(fiber.type) ? (fiber = $4e707583c65f6afa$var$previousHydratableOnEnteringScopedSingleton, $4e707583c65f6afa$var$previousHydratableOnEnteringScopedSingleton = null, $4e707583c65f6afa$var$nextHydratableInstance = fiber) : $4e707583c65f6afa$var$nextHydratableInstance = tag) : $4e707583c65f6afa$var$nextHydratableInstance = $4e707583c65f6afa$var$hydrationParentFiber ? $4e707583c65f6afa$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $4e707583c65f6afa$var$resetHydrationState() {
    $4e707583c65f6afa$var$nextHydratableInstance = $4e707583c65f6afa$var$hydrationParentFiber = null;
    $4e707583c65f6afa$var$isHydrating = !1;
}
function $4e707583c65f6afa$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $4e707583c65f6afa$var$hydrationErrors;
    null !== queuedErrors && (null === $4e707583c65f6afa$var$workInProgressRootRecoverableErrors ? $4e707583c65f6afa$var$workInProgressRootRecoverableErrors = queuedErrors : $4e707583c65f6afa$var$workInProgressRootRecoverableErrors.push.apply($4e707583c65f6afa$var$workInProgressRootRecoverableErrors, queuedErrors), $4e707583c65f6afa$var$hydrationErrors = null);
    return queuedErrors;
}
function $4e707583c65f6afa$var$queueHydrationError(error) {
    null === $4e707583c65f6afa$var$hydrationErrors ? $4e707583c65f6afa$var$hydrationErrors = [
        error
    ] : $4e707583c65f6afa$var$hydrationErrors.push(error);
}
var $4e707583c65f6afa$var$valueCursor = $4e707583c65f6afa$var$createCursor(null), $4e707583c65f6afa$var$currentlyRenderingFiber$1 = null, $4e707583c65f6afa$var$lastContextDependency = null;
function $4e707583c65f6afa$var$pushProvider(providerFiber, context, nextValue) {
    $4e707583c65f6afa$var$push($4e707583c65f6afa$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $4e707583c65f6afa$var$popProvider(context) {
    context._currentValue = $4e707583c65f6afa$var$valueCursor.current;
    $4e707583c65f6afa$var$pop($4e707583c65f6afa$var$valueCursor);
}
function $4e707583c65f6afa$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $4e707583c65f6afa$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $4e707583c65f6afa$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $4e707583c65f6afa$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $4e707583c65f6afa$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $4e707583c65f6afa$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $4e707583c65f6afa$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($4e707583c65f6afa$var$HostTransitionContext) : current = [
                $4e707583c65f6afa$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $4e707583c65f6afa$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $4e707583c65f6afa$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$4e707583c65f6afa$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $4e707583c65f6afa$var$prepareToReadContext(workInProgress) {
    $4e707583c65f6afa$var$currentlyRenderingFiber$1 = workInProgress;
    $4e707583c65f6afa$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $4e707583c65f6afa$var$readContext(context) {
    return $4e707583c65f6afa$var$readContextForConsumer($4e707583c65f6afa$var$currentlyRenderingFiber$1, context);
}
function $4e707583c65f6afa$var$readContextDuringReconciliation(consumer, context) {
    null === $4e707583c65f6afa$var$currentlyRenderingFiber$1 && $4e707583c65f6afa$var$prepareToReadContext(consumer);
    return $4e707583c65f6afa$var$readContextForConsumer(consumer, context);
}
function $4e707583c65f6afa$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $4e707583c65f6afa$var$lastContextDependency) {
        if (null === consumer) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(308));
        $4e707583c65f6afa$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $4e707583c65f6afa$var$lastContextDependency = $4e707583c65f6afa$var$lastContextDependency.next = context;
    return value;
}
var $4e707583c65f6afa$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $4e707583c65f6afa$var$scheduleCallback$2 = $eOszH.unstable_scheduleCallback, $4e707583c65f6afa$var$NormalPriority = $eOszH.unstable_NormalPriority, $4e707583c65f6afa$var$CacheContext = {
    $$typeof: $4e707583c65f6afa$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $4e707583c65f6afa$var$createCache() {
    return {
        controller: new $4e707583c65f6afa$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $4e707583c65f6afa$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $4e707583c65f6afa$var$scheduleCallback$2($4e707583c65f6afa$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $4e707583c65f6afa$var$currentEntangledListeners = null, $4e707583c65f6afa$var$currentEntangledPendingCount = 0, $4e707583c65f6afa$var$currentEntangledLane = 0, $4e707583c65f6afa$var$currentEntangledActionThenable = null;
function $4e707583c65f6afa$var$entangleAsyncAction(transition, thenable) {
    if (null === $4e707583c65f6afa$var$currentEntangledListeners) {
        var entangledListeners = $4e707583c65f6afa$var$currentEntangledListeners = [];
        $4e707583c65f6afa$var$currentEntangledPendingCount = 0;
        $4e707583c65f6afa$var$currentEntangledLane = $4e707583c65f6afa$var$requestTransitionLane();
        $4e707583c65f6afa$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $4e707583c65f6afa$var$currentEntangledPendingCount++;
    thenable.then($4e707583c65f6afa$var$pingEngtangledActionScope, $4e707583c65f6afa$var$pingEngtangledActionScope);
    return thenable;
}
function $4e707583c65f6afa$var$pingEngtangledActionScope() {
    if (0 === --$4e707583c65f6afa$var$currentEntangledPendingCount && null !== $4e707583c65f6afa$var$currentEntangledListeners) {
        null !== $4e707583c65f6afa$var$currentEntangledActionThenable && ($4e707583c65f6afa$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $4e707583c65f6afa$var$currentEntangledListeners;
        $4e707583c65f6afa$var$currentEntangledListeners = null;
        $4e707583c65f6afa$var$currentEntangledLane = 0;
        $4e707583c65f6afa$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $4e707583c65f6afa$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $4e707583c65f6afa$var$prevOnStartTransitionFinish = $4e707583c65f6afa$var$ReactSharedInternals.S;
$4e707583c65f6afa$var$ReactSharedInternals.S = function(transition, returnValue) {
    $4e707583c65f6afa$var$globalMostRecentTransitionTime = $4e707583c65f6afa$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $4e707583c65f6afa$var$entangleAsyncAction(transition, returnValue);
    null !== $4e707583c65f6afa$var$prevOnStartTransitionFinish && $4e707583c65f6afa$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $4e707583c65f6afa$var$resumedCache = $4e707583c65f6afa$var$createCursor(null);
function $4e707583c65f6afa$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $4e707583c65f6afa$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $4e707583c65f6afa$var$workInProgressRoot.pooledCache;
}
function $4e707583c65f6afa$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $4e707583c65f6afa$var$push($4e707583c65f6afa$var$resumedCache, $4e707583c65f6afa$var$resumedCache.current) : $4e707583c65f6afa$var$push($4e707583c65f6afa$var$resumedCache, prevCachePool.pool);
}
function $4e707583c65f6afa$var$getSuspendedCache() {
    var cacheFromPool = $4e707583c65f6afa$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $4e707583c65f6afa$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $4e707583c65f6afa$var$SuspenseException = Error($4e707583c65f6afa$var$formatProdErrorMessage(460)), $4e707583c65f6afa$var$SuspenseyCommitException = Error($4e707583c65f6afa$var$formatProdErrorMessage(474)), $4e707583c65f6afa$var$SuspenseActionException = Error($4e707583c65f6afa$var$formatProdErrorMessage(542)), $4e707583c65f6afa$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $4e707583c65f6afa$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $4e707583c65f6afa$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($4e707583c65f6afa$var$noop$1, $4e707583c65f6afa$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $4e707583c65f6afa$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($4e707583c65f6afa$var$noop$1, $4e707583c65f6afa$var$noop$1);
            else {
                thenableState = $4e707583c65f6afa$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $4e707583c65f6afa$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $4e707583c65f6afa$var$suspendedThenable = thenable;
            throw $4e707583c65f6afa$var$SuspenseException;
    }
}
function $4e707583c65f6afa$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $4e707583c65f6afa$var$suspendedThenable = x, $4e707583c65f6afa$var$SuspenseException;
        throw x;
    }
}
var $4e707583c65f6afa$var$suspendedThenable = null;
function $4e707583c65f6afa$var$getSuspendedThenable() {
    if (null === $4e707583c65f6afa$var$suspendedThenable) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(459));
    var thenable = $4e707583c65f6afa$var$suspendedThenable;
    $4e707583c65f6afa$var$suspendedThenable = null;
    return thenable;
}
function $4e707583c65f6afa$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $4e707583c65f6afa$var$SuspenseException || rejectedReason === $4e707583c65f6afa$var$SuspenseActionException) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(483));
}
var $4e707583c65f6afa$var$thenableState$1 = null, $4e707583c65f6afa$var$thenableIndexCounter$1 = 0;
function $4e707583c65f6afa$var$unwrapThenable(thenable) {
    var index = $4e707583c65f6afa$var$thenableIndexCounter$1;
    $4e707583c65f6afa$var$thenableIndexCounter$1 += 1;
    null === $4e707583c65f6afa$var$thenableState$1 && ($4e707583c65f6afa$var$thenableState$1 = []);
    return $4e707583c65f6afa$var$trackUsedThenable($4e707583c65f6afa$var$thenableState$1, thenable, index);
}
function $4e707583c65f6afa$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $4e707583c65f6afa$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $4e707583c65f6afa$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($4e707583c65f6afa$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $4e707583c65f6afa$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $4e707583c65f6afa$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $4e707583c65f6afa$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $4e707583c65f6afa$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $4e707583c65f6afa$var$REACT_LAZY_TYPE && $4e707583c65f6afa$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $4e707583c65f6afa$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $4e707583c65f6afa$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $4e707583c65f6afa$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $4e707583c65f6afa$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $4e707583c65f6afa$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $4e707583c65f6afa$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $4e707583c65f6afa$var$REACT_ELEMENT_TYPE:
                    return lanes = $4e707583c65f6afa$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $4e707583c65f6afa$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $4e707583c65f6afa$var$REACT_PORTAL_TYPE:
                    return newChild = $4e707583c65f6afa$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $4e707583c65f6afa$var$REACT_LAZY_TYPE:
                    return newChild = $4e707583c65f6afa$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($4e707583c65f6afa$var$isArrayImpl(newChild) || $4e707583c65f6afa$var$getIteratorFn(newChild)) return newChild = $4e707583c65f6afa$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $4e707583c65f6afa$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $4e707583c65f6afa$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $4e707583c65f6afa$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $4e707583c65f6afa$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $4e707583c65f6afa$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $4e707583c65f6afa$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $4e707583c65f6afa$var$REACT_LAZY_TYPE:
                    return newChild = $4e707583c65f6afa$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($4e707583c65f6afa$var$isArrayImpl(newChild) || $4e707583c65f6afa$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $4e707583c65f6afa$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $4e707583c65f6afa$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $4e707583c65f6afa$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $4e707583c65f6afa$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $4e707583c65f6afa$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $4e707583c65f6afa$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $4e707583c65f6afa$var$REACT_LAZY_TYPE:
                    return newChild = $4e707583c65f6afa$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($4e707583c65f6afa$var$isArrayImpl(newChild) || $4e707583c65f6afa$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $4e707583c65f6afa$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $4e707583c65f6afa$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $4e707583c65f6afa$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $4e707583c65f6afa$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $4e707583c65f6afa$var$isHydrating && $4e707583c65f6afa$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $4e707583c65f6afa$var$isHydrating && $4e707583c65f6afa$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $4e707583c65f6afa$var$isHydrating && $4e707583c65f6afa$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $4e707583c65f6afa$var$isHydrating && $4e707583c65f6afa$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $4e707583c65f6afa$var$isHydrating && $4e707583c65f6afa$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $4e707583c65f6afa$var$isHydrating && $4e707583c65f6afa$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $4e707583c65f6afa$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $4e707583c65f6afa$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $4e707583c65f6afa$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $4e707583c65f6afa$var$REACT_LAZY_TYPE && $4e707583c65f6afa$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $4e707583c65f6afa$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $4e707583c65f6afa$var$REACT_FRAGMENT_TYPE ? (lanes = $4e707583c65f6afa$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $4e707583c65f6afa$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $4e707583c65f6afa$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $4e707583c65f6afa$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $4e707583c65f6afa$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $4e707583c65f6afa$var$REACT_LAZY_TYPE:
                    return newChild = $4e707583c65f6afa$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($4e707583c65f6afa$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($4e707583c65f6afa$var$getIteratorFn(newChild)) {
                key = $4e707583c65f6afa$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $4e707583c65f6afa$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $4e707583c65f6afa$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $4e707583c65f6afa$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $4e707583c65f6afa$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $4e707583c65f6afa$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $4e707583c65f6afa$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $4e707583c65f6afa$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $4e707583c65f6afa$var$SuspenseException || x === $4e707583c65f6afa$var$SuspenseActionException) throw x;
            var fiber = $4e707583c65f6afa$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $4e707583c65f6afa$var$reconcileChildFibers = $4e707583c65f6afa$var$createChildReconciler(!0), $4e707583c65f6afa$var$mountChildFibers = $4e707583c65f6afa$var$createChildReconciler(!1), $4e707583c65f6afa$var$hasForceUpdate = !1;
function $4e707583c65f6afa$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $4e707583c65f6afa$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $4e707583c65f6afa$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4e707583c65f6afa$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($4e707583c65f6afa$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $4e707583c65f6afa$var$getRootForUpdatedFiber(fiber);
        $4e707583c65f6afa$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $4e707583c65f6afa$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $4e707583c65f6afa$var$getRootForUpdatedFiber(fiber);
}
function $4e707583c65f6afa$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $4e707583c65f6afa$var$markRootEntangled(root, lane);
    }
}
function $4e707583c65f6afa$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $4e707583c65f6afa$var$didReadFromEntangledAsyncAction = !1;
function $4e707583c65f6afa$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($4e707583c65f6afa$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $4e707583c65f6afa$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $4e707583c65f6afa$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $4e707583c65f6afa$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $4e707583c65f6afa$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($4e707583c65f6afa$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $4e707583c65f6afa$var$currentEntangledLane && ($4e707583c65f6afa$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $4e707583c65f6afa$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $4e707583c65f6afa$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $4e707583c65f6afa$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $4e707583c65f6afa$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $4e707583c65f6afa$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$4e707583c65f6afa$var$callCallback(callbacks[updateQueue], context);
}
var $4e707583c65f6afa$var$currentTreeHiddenStackCursor = $4e707583c65f6afa$var$createCursor(null), $4e707583c65f6afa$var$prevEntangledRenderLanesCursor = $4e707583c65f6afa$var$createCursor(0);
function $4e707583c65f6afa$var$pushHiddenContext(fiber, context) {
    fiber = $4e707583c65f6afa$var$entangledRenderLanes;
    $4e707583c65f6afa$var$push($4e707583c65f6afa$var$prevEntangledRenderLanesCursor, fiber);
    $4e707583c65f6afa$var$push($4e707583c65f6afa$var$currentTreeHiddenStackCursor, context);
    $4e707583c65f6afa$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $4e707583c65f6afa$var$reuseHiddenContextOnStack() {
    $4e707583c65f6afa$var$push($4e707583c65f6afa$var$prevEntangledRenderLanesCursor, $4e707583c65f6afa$var$entangledRenderLanes);
    $4e707583c65f6afa$var$push($4e707583c65f6afa$var$currentTreeHiddenStackCursor, $4e707583c65f6afa$var$currentTreeHiddenStackCursor.current);
}
function $4e707583c65f6afa$var$popHiddenContext() {
    $4e707583c65f6afa$var$entangledRenderLanes = $4e707583c65f6afa$var$prevEntangledRenderLanesCursor.current;
    $4e707583c65f6afa$var$pop($4e707583c65f6afa$var$currentTreeHiddenStackCursor);
    $4e707583c65f6afa$var$pop($4e707583c65f6afa$var$prevEntangledRenderLanesCursor);
}
var $4e707583c65f6afa$var$suspenseHandlerStackCursor = $4e707583c65f6afa$var$createCursor(null), $4e707583c65f6afa$var$shellBoundary = null;
function $4e707583c65f6afa$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $4e707583c65f6afa$var$push($4e707583c65f6afa$var$suspenseStackCursor, $4e707583c65f6afa$var$suspenseStackCursor.current & 1);
    $4e707583c65f6afa$var$push($4e707583c65f6afa$var$suspenseHandlerStackCursor, handler);
    null === $4e707583c65f6afa$var$shellBoundary && (null === current || null !== $4e707583c65f6afa$var$currentTreeHiddenStackCursor.current ? $4e707583c65f6afa$var$shellBoundary = handler : null !== current.memoizedState && ($4e707583c65f6afa$var$shellBoundary = handler));
}
function $4e707583c65f6afa$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $4e707583c65f6afa$var$push($4e707583c65f6afa$var$suspenseStackCursor, $4e707583c65f6afa$var$suspenseStackCursor.current);
    $4e707583c65f6afa$var$push($4e707583c65f6afa$var$suspenseHandlerStackCursor, fiber);
    null === $4e707583c65f6afa$var$shellBoundary && ($4e707583c65f6afa$var$shellBoundary = fiber);
}
function $4e707583c65f6afa$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($4e707583c65f6afa$var$push($4e707583c65f6afa$var$suspenseStackCursor, $4e707583c65f6afa$var$suspenseStackCursor.current), $4e707583c65f6afa$var$push($4e707583c65f6afa$var$suspenseHandlerStackCursor, fiber), null === $4e707583c65f6afa$var$shellBoundary && ($4e707583c65f6afa$var$shellBoundary = fiber)) : $4e707583c65f6afa$var$reuseSuspenseHandlerOnStack(fiber);
}
function $4e707583c65f6afa$var$reuseSuspenseHandlerOnStack() {
    $4e707583c65f6afa$var$push($4e707583c65f6afa$var$suspenseStackCursor, $4e707583c65f6afa$var$suspenseStackCursor.current);
    $4e707583c65f6afa$var$push($4e707583c65f6afa$var$suspenseHandlerStackCursor, $4e707583c65f6afa$var$suspenseHandlerStackCursor.current);
}
function $4e707583c65f6afa$var$popSuspenseHandler(fiber) {
    $4e707583c65f6afa$var$pop($4e707583c65f6afa$var$suspenseHandlerStackCursor);
    $4e707583c65f6afa$var$shellBoundary === fiber && ($4e707583c65f6afa$var$shellBoundary = null);
    $4e707583c65f6afa$var$pop($4e707583c65f6afa$var$suspenseStackCursor);
}
var $4e707583c65f6afa$var$suspenseStackCursor = $4e707583c65f6afa$var$createCursor(0);
function $4e707583c65f6afa$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $4e707583c65f6afa$var$isSuspenseInstancePending(state) || $4e707583c65f6afa$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $4e707583c65f6afa$var$renderLanes = 0, $4e707583c65f6afa$var$currentlyRenderingFiber = null, $4e707583c65f6afa$var$currentHook = null, $4e707583c65f6afa$var$workInProgressHook = null, $4e707583c65f6afa$var$didScheduleRenderPhaseUpdate = !1, $4e707583c65f6afa$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $4e707583c65f6afa$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $4e707583c65f6afa$var$localIdCounter = 0, $4e707583c65f6afa$var$thenableIndexCounter = 0, $4e707583c65f6afa$var$thenableState = null, $4e707583c65f6afa$var$globalClientIdCounter = 0;
function $4e707583c65f6afa$var$throwInvalidHookError() {
    throw Error($4e707583c65f6afa$var$formatProdErrorMessage(321));
}
function $4e707583c65f6afa$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$4e707583c65f6afa$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $4e707583c65f6afa$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $4e707583c65f6afa$var$renderLanes = nextRenderLanes;
    $4e707583c65f6afa$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $4e707583c65f6afa$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $4e707583c65f6afa$var$HooksDispatcherOnMount : $4e707583c65f6afa$var$HooksDispatcherOnUpdate;
    $4e707583c65f6afa$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $4e707583c65f6afa$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $4e707583c65f6afa$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $4e707583c65f6afa$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $4e707583c65f6afa$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $4e707583c65f6afa$var$finishRenderingHooks(current) {
    $4e707583c65f6afa$var$ReactSharedInternals.H = $4e707583c65f6afa$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $4e707583c65f6afa$var$currentHook && null !== $4e707583c65f6afa$var$currentHook.next;
    $4e707583c65f6afa$var$renderLanes = 0;
    $4e707583c65f6afa$var$workInProgressHook = $4e707583c65f6afa$var$currentHook = $4e707583c65f6afa$var$currentlyRenderingFiber = null;
    $4e707583c65f6afa$var$didScheduleRenderPhaseUpdate = !1;
    $4e707583c65f6afa$var$thenableIndexCounter = 0;
    $4e707583c65f6afa$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(300));
    null === current || $4e707583c65f6afa$var$didReceiveUpdate || (current = current.dependencies, null !== current && $4e707583c65f6afa$var$checkIfContextChanged(current) && ($4e707583c65f6afa$var$didReceiveUpdate = !0));
}
function $4e707583c65f6afa$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $4e707583c65f6afa$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $4e707583c65f6afa$var$didScheduleRenderPhaseUpdateDuringThisPass && ($4e707583c65f6afa$var$thenableState = null);
        $4e707583c65f6afa$var$thenableIndexCounter = 0;
        $4e707583c65f6afa$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $4e707583c65f6afa$var$workInProgressHook = $4e707583c65f6afa$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $4e707583c65f6afa$var$ReactSharedInternals.H = $4e707583c65f6afa$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($4e707583c65f6afa$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $4e707583c65f6afa$var$TransitionAwareHostComponent() {
    var dispatcher = $4e707583c65f6afa$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $4e707583c65f6afa$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $4e707583c65f6afa$var$currentHook ? $4e707583c65f6afa$var$currentHook.memoizedState : null) !== dispatcher && ($4e707583c65f6afa$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $4e707583c65f6afa$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $4e707583c65f6afa$var$localIdCounter;
    $4e707583c65f6afa$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $4e707583c65f6afa$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $4e707583c65f6afa$var$resetHooksOnUnwind(workInProgress) {
    if ($4e707583c65f6afa$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $4e707583c65f6afa$var$didScheduleRenderPhaseUpdate = !1;
    }
    $4e707583c65f6afa$var$renderLanes = 0;
    $4e707583c65f6afa$var$workInProgressHook = $4e707583c65f6afa$var$currentHook = $4e707583c65f6afa$var$currentlyRenderingFiber = null;
    $4e707583c65f6afa$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $4e707583c65f6afa$var$thenableIndexCounter = $4e707583c65f6afa$var$localIdCounter = 0;
    $4e707583c65f6afa$var$thenableState = null;
}
function $4e707583c65f6afa$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4e707583c65f6afa$var$workInProgressHook ? $4e707583c65f6afa$var$currentlyRenderingFiber.memoizedState = $4e707583c65f6afa$var$workInProgressHook = hook : $4e707583c65f6afa$var$workInProgressHook = $4e707583c65f6afa$var$workInProgressHook.next = hook;
    return $4e707583c65f6afa$var$workInProgressHook;
}
function $4e707583c65f6afa$var$updateWorkInProgressHook() {
    if (null === $4e707583c65f6afa$var$currentHook) {
        var nextCurrentHook = $4e707583c65f6afa$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $4e707583c65f6afa$var$currentHook.next;
    var nextWorkInProgressHook = null === $4e707583c65f6afa$var$workInProgressHook ? $4e707583c65f6afa$var$currentlyRenderingFiber.memoizedState : $4e707583c65f6afa$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $4e707583c65f6afa$var$workInProgressHook = nextWorkInProgressHook, $4e707583c65f6afa$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $4e707583c65f6afa$var$currentlyRenderingFiber.alternate) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(467));
            throw Error($4e707583c65f6afa$var$formatProdErrorMessage(310));
        }
        $4e707583c65f6afa$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $4e707583c65f6afa$var$currentHook.memoizedState,
            baseState: $4e707583c65f6afa$var$currentHook.baseState,
            baseQueue: $4e707583c65f6afa$var$currentHook.baseQueue,
            queue: $4e707583c65f6afa$var$currentHook.queue,
            next: null
        };
        null === $4e707583c65f6afa$var$workInProgressHook ? $4e707583c65f6afa$var$currentlyRenderingFiber.memoizedState = $4e707583c65f6afa$var$workInProgressHook = nextCurrentHook : $4e707583c65f6afa$var$workInProgressHook = $4e707583c65f6afa$var$workInProgressHook.next = nextCurrentHook;
    }
    return $4e707583c65f6afa$var$workInProgressHook;
}
function $4e707583c65f6afa$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $4e707583c65f6afa$var$useThenable(thenable) {
    var index = $4e707583c65f6afa$var$thenableIndexCounter;
    $4e707583c65f6afa$var$thenableIndexCounter += 1;
    null === $4e707583c65f6afa$var$thenableState && ($4e707583c65f6afa$var$thenableState = []);
    thenable = $4e707583c65f6afa$var$trackUsedThenable($4e707583c65f6afa$var$thenableState, thenable, index);
    index = $4e707583c65f6afa$var$currentlyRenderingFiber;
    null === (null === $4e707583c65f6afa$var$workInProgressHook ? index.memoizedState : $4e707583c65f6afa$var$workInProgressHook.next) && (index = index.alternate, $4e707583c65f6afa$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $4e707583c65f6afa$var$HooksDispatcherOnMount : $4e707583c65f6afa$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $4e707583c65f6afa$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $4e707583c65f6afa$var$useThenable(usable);
        if (usable.$$typeof === $4e707583c65f6afa$var$REACT_CONTEXT_TYPE) return $4e707583c65f6afa$var$readContext(usable);
    }
    throw Error($4e707583c65f6afa$var$formatProdErrorMessage(438, String(usable)));
}
function $4e707583c65f6afa$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $4e707583c65f6afa$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $4e707583c65f6afa$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $4e707583c65f6afa$var$createFunctionComponentUpdateQueue(), $4e707583c65f6afa$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $4e707583c65f6afa$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $4e707583c65f6afa$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $4e707583c65f6afa$var$updateReducer(reducer) {
    var hook = $4e707583c65f6afa$var$updateWorkInProgressHook();
    return $4e707583c65f6afa$var$updateReducerImpl(hook, $4e707583c65f6afa$var$currentHook, reducer);
}
function $4e707583c65f6afa$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($4e707583c65f6afa$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($4e707583c65f6afa$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $4e707583c65f6afa$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($4e707583c65f6afa$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $4e707583c65f6afa$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $4e707583c65f6afa$var$currentlyRenderingFiber.lanes |= revertLane, $4e707583c65f6afa$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $4e707583c65f6afa$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $4e707583c65f6afa$var$currentlyRenderingFiber.lanes |= updateLane, $4e707583c65f6afa$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$4e707583c65f6afa$var$objectIs(pendingQueue, hook.memoizedState) && ($4e707583c65f6afa$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $4e707583c65f6afa$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $4e707583c65f6afa$var$rerenderReducer(reducer) {
    var hook = $4e707583c65f6afa$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $4e707583c65f6afa$var$objectIs(newState, hook.memoizedState) || ($4e707583c65f6afa$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $4e707583c65f6afa$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $4e707583c65f6afa$var$currentlyRenderingFiber, hook = $4e707583c65f6afa$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $4e707583c65f6afa$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$4e707583c65f6afa$var$objectIs(($4e707583c65f6afa$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $4e707583c65f6afa$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $4e707583c65f6afa$var$updateEffect($4e707583c65f6afa$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $4e707583c65f6afa$var$workInProgressHook && $4e707583c65f6afa$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $4e707583c65f6afa$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $4e707583c65f6afa$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $4e707583c65f6afa$var$workInProgressRoot) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($4e707583c65f6afa$var$renderLanes & 127) || $4e707583c65f6afa$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $4e707583c65f6afa$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $4e707583c65f6afa$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $4e707583c65f6afa$var$createFunctionComponentUpdateQueue(), $4e707583c65f6afa$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $4e707583c65f6afa$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $4e707583c65f6afa$var$checkIfSnapshotChanged(inst) && $4e707583c65f6afa$var$forceStoreRerender(fiber);
}
function $4e707583c65f6afa$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $4e707583c65f6afa$var$checkIfSnapshotChanged(inst) && $4e707583c65f6afa$var$forceStoreRerender(fiber);
    });
}
function $4e707583c65f6afa$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$4e707583c65f6afa$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $4e707583c65f6afa$var$forceStoreRerender(fiber) {
    var root = $4e707583c65f6afa$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $4e707583c65f6afa$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $4e707583c65f6afa$var$mountStateImpl(initialState) {
    var hook = $4e707583c65f6afa$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($4e707583c65f6afa$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $4e707583c65f6afa$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $4e707583c65f6afa$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4e707583c65f6afa$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $4e707583c65f6afa$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $4e707583c65f6afa$var$updateReducerImpl(hook, $4e707583c65f6afa$var$currentHook, "function" === typeof reducer ? reducer : $4e707583c65f6afa$var$basicStateReducer);
}
function $4e707583c65f6afa$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($4e707583c65f6afa$var$isRenderPhaseUpdate(fiber)) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $4e707583c65f6afa$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $4e707583c65f6afa$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $4e707583c65f6afa$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $4e707583c65f6afa$var$ReactSharedInternals.T, currentTransition = {};
        $4e707583c65f6afa$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $4e707583c65f6afa$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $4e707583c65f6afa$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $4e707583c65f6afa$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $4e707583c65f6afa$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $4e707583c65f6afa$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $4e707583c65f6afa$var$onActionError(actionQueue, node, error$66);
    }
}
function $4e707583c65f6afa$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $4e707583c65f6afa$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $4e707583c65f6afa$var$onActionError(actionQueue, node, error);
    }) : $4e707583c65f6afa$var$onActionSuccess(actionQueue, node, returnValue);
}
function $4e707583c65f6afa$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $4e707583c65f6afa$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $4e707583c65f6afa$var$runActionStateAction(actionQueue, nextState)));
}
function $4e707583c65f6afa$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $4e707583c65f6afa$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $4e707583c65f6afa$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $4e707583c65f6afa$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $4e707583c65f6afa$var$mountActionState(action, initialStateProp) {
    if ($4e707583c65f6afa$var$isHydrating) {
        var ssrFormState = $4e707583c65f6afa$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $4e707583c65f6afa$var$currentlyRenderingFiber;
                if ($4e707583c65f6afa$var$isHydrating) {
                    if ($4e707583c65f6afa$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $4e707583c65f6afa$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $4e707583c65f6afa$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $4e707583c65f6afa$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $4e707583c65f6afa$var$nextHydratableInstance = $4e707583c65f6afa$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $4e707583c65f6afa$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $4e707583c65f6afa$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4e707583c65f6afa$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $4e707583c65f6afa$var$dispatchSetState.bind(null, $4e707583c65f6afa$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $4e707583c65f6afa$var$mountStateImpl(!1);
    inRootOrSingleton = $4e707583c65f6afa$var$dispatchOptimisticSetState.bind(null, $4e707583c65f6afa$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $4e707583c65f6afa$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $4e707583c65f6afa$var$dispatchActionState.bind(null, $4e707583c65f6afa$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $4e707583c65f6afa$var$updateActionState(action) {
    var stateHook = $4e707583c65f6afa$var$updateWorkInProgressHook();
    return $4e707583c65f6afa$var$updateActionStateImpl(stateHook, $4e707583c65f6afa$var$currentHook, action);
}
function $4e707583c65f6afa$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $4e707583c65f6afa$var$updateReducerImpl(stateHook, currentStateHook, $4e707583c65f6afa$var$actionStateReducer)[0];
    stateHook = $4e707583c65f6afa$var$updateReducer($4e707583c65f6afa$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $4e707583c65f6afa$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $4e707583c65f6afa$var$SuspenseException) throw $4e707583c65f6afa$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $4e707583c65f6afa$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($4e707583c65f6afa$var$currentlyRenderingFiber.flags |= 2048, $4e707583c65f6afa$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $4e707583c65f6afa$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $4e707583c65f6afa$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $4e707583c65f6afa$var$rerenderActionState(action) {
    var stateHook = $4e707583c65f6afa$var$updateWorkInProgressHook(), currentStateHook = $4e707583c65f6afa$var$currentHook;
    if (null !== currentStateHook) return $4e707583c65f6afa$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $4e707583c65f6afa$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $4e707583c65f6afa$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $4e707583c65f6afa$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $4e707583c65f6afa$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $4e707583c65f6afa$var$createFunctionComponentUpdateQueue(), $4e707583c65f6afa$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $4e707583c65f6afa$var$updateRef() {
    return $4e707583c65f6afa$var$updateWorkInProgressHook().memoizedState;
}
function $4e707583c65f6afa$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $4e707583c65f6afa$var$mountWorkInProgressHook();
    $4e707583c65f6afa$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $4e707583c65f6afa$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $4e707583c65f6afa$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $4e707583c65f6afa$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $4e707583c65f6afa$var$currentHook && null !== deps && $4e707583c65f6afa$var$areHookInputsEqual(deps, $4e707583c65f6afa$var$currentHook.memoizedState.deps) ? hook.memoizedState = $4e707583c65f6afa$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($4e707583c65f6afa$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $4e707583c65f6afa$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $4e707583c65f6afa$var$mountEffect(create, deps) {
    $4e707583c65f6afa$var$mountEffectImpl(8390656, 8, create, deps);
}
function $4e707583c65f6afa$var$updateEffect(create, deps) {
    $4e707583c65f6afa$var$updateEffectImpl(2048, 8, create, deps);
}
function $4e707583c65f6afa$var$useEffectEventImpl(payload) {
    $4e707583c65f6afa$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $4e707583c65f6afa$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $4e707583c65f6afa$var$createFunctionComponentUpdateQueue(), $4e707583c65f6afa$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $4e707583c65f6afa$var$updateEvent(callback) {
    var ref = $4e707583c65f6afa$var$updateWorkInProgressHook().memoizedState;
    $4e707583c65f6afa$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($4e707583c65f6afa$var$executionContext & 2)) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $4e707583c65f6afa$var$updateInsertionEffect(create, deps) {
    return $4e707583c65f6afa$var$updateEffectImpl(4, 2, create, deps);
}
function $4e707583c65f6afa$var$updateLayoutEffect(create, deps) {
    return $4e707583c65f6afa$var$updateEffectImpl(4, 4, create, deps);
}
function $4e707583c65f6afa$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $4e707583c65f6afa$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $4e707583c65f6afa$var$updateEffectImpl(4, 4, $4e707583c65f6afa$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $4e707583c65f6afa$var$mountDebugValue() {}
function $4e707583c65f6afa$var$updateCallback(callback, deps) {
    var hook = $4e707583c65f6afa$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $4e707583c65f6afa$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $4e707583c65f6afa$var$updateMemo(nextCreate, deps) {
    var hook = $4e707583c65f6afa$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $4e707583c65f6afa$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($4e707583c65f6afa$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $4e707583c65f6afa$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $4e707583c65f6afa$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $4e707583c65f6afa$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($4e707583c65f6afa$var$renderLanes & 1073741824) && 0 === ($4e707583c65f6afa$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $4e707583c65f6afa$var$requestDeferredLane();
    $4e707583c65f6afa$var$currentlyRenderingFiber.lanes |= hook;
    $4e707583c65f6afa$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $4e707583c65f6afa$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($4e707583c65f6afa$var$objectIs(value, prevValue)) return value;
    if (null !== $4e707583c65f6afa$var$currentTreeHiddenStackCursor.current) return hook = $4e707583c65f6afa$var$mountDeferredValueImpl(hook, value, initialValue), $4e707583c65f6afa$var$objectIs(hook, prevValue) || ($4e707583c65f6afa$var$didReceiveUpdate = !0), hook;
    if (0 === ($4e707583c65f6afa$var$renderLanes & 42) || 0 !== ($4e707583c65f6afa$var$renderLanes & 1073741824) && 0 === ($4e707583c65f6afa$var$workInProgressRootRenderLanes & 261930)) return $4e707583c65f6afa$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $4e707583c65f6afa$var$requestDeferredLane();
    $4e707583c65f6afa$var$currentlyRenderingFiber.lanes |= hook;
    $4e707583c65f6afa$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $4e707583c65f6afa$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $4e707583c65f6afa$var$ReactDOMSharedInternals.p;
    $4e707583c65f6afa$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $4e707583c65f6afa$var$ReactSharedInternals.T, currentTransition = {};
    $4e707583c65f6afa$var$ReactSharedInternals.T = currentTransition;
    $4e707583c65f6afa$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $4e707583c65f6afa$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $4e707583c65f6afa$var$chainThenableValue(returnValue, finishedState);
            $4e707583c65f6afa$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $4e707583c65f6afa$var$requestUpdateLane(fiber));
        } else $4e707583c65f6afa$var$dispatchSetStateInternal(fiber, queue, finishedState, $4e707583c65f6afa$var$requestUpdateLane(fiber));
    } catch (error) {
        $4e707583c65f6afa$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $4e707583c65f6afa$var$requestUpdateLane());
    } finally{
        $4e707583c65f6afa$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $4e707583c65f6afa$var$ReactSharedInternals.T = prevTransition;
    }
}
function $4e707583c65f6afa$var$noop() {}
function $4e707583c65f6afa$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(476));
    var queue = $4e707583c65f6afa$var$ensureFormComponentIsStateful(formFiber).queue;
    $4e707583c65f6afa$var$startTransition(formFiber, queue, pendingState, $4e707583c65f6afa$var$sharedNotPendingObject, null === action ? $4e707583c65f6afa$var$noop : function() {
        $4e707583c65f6afa$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $4e707583c65f6afa$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $4e707583c65f6afa$var$sharedNotPendingObject,
        baseState: $4e707583c65f6afa$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $4e707583c65f6afa$var$basicStateReducer,
            lastRenderedState: $4e707583c65f6afa$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $4e707583c65f6afa$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $4e707583c65f6afa$var$requestFormReset$1(formFiber) {
    var stateHook = $4e707583c65f6afa$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $4e707583c65f6afa$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $4e707583c65f6afa$var$requestUpdateLane());
}
function $4e707583c65f6afa$var$useHostTransitionStatus() {
    return $4e707583c65f6afa$var$readContext($4e707583c65f6afa$var$HostTransitionContext);
}
function $4e707583c65f6afa$var$updateId() {
    return $4e707583c65f6afa$var$updateWorkInProgressHook().memoizedState;
}
function $4e707583c65f6afa$var$updateRefresh() {
    return $4e707583c65f6afa$var$updateWorkInProgressHook().memoizedState;
}
function $4e707583c65f6afa$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $4e707583c65f6afa$var$requestUpdateLane();
                fiber = $4e707583c65f6afa$var$createUpdate(lane);
                var root$69 = $4e707583c65f6afa$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($4e707583c65f6afa$var$scheduleUpdateOnFiber(root$69, provider, lane), $4e707583c65f6afa$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $4e707583c65f6afa$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $4e707583c65f6afa$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $4e707583c65f6afa$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $4e707583c65f6afa$var$isRenderPhaseUpdate(fiber) ? $4e707583c65f6afa$var$enqueueRenderPhaseUpdate(queue, action) : (action = $4e707583c65f6afa$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($4e707583c65f6afa$var$scheduleUpdateOnFiber(action, fiber, lane), $4e707583c65f6afa$var$entangleTransitionUpdate(action, queue, lane)));
}
function $4e707583c65f6afa$var$dispatchSetState(fiber, queue, action) {
    var lane = $4e707583c65f6afa$var$requestUpdateLane();
    $4e707583c65f6afa$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $4e707583c65f6afa$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4e707583c65f6afa$var$isRenderPhaseUpdate(fiber)) $4e707583c65f6afa$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($4e707583c65f6afa$var$objectIs(eagerState, currentState)) return $4e707583c65f6afa$var$enqueueUpdate$1(fiber, queue, update, 0), null === $4e707583c65f6afa$var$workInProgressRoot && $4e707583c65f6afa$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $4e707583c65f6afa$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $4e707583c65f6afa$var$scheduleUpdateOnFiber(action, fiber, lane), $4e707583c65f6afa$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $4e707583c65f6afa$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $4e707583c65f6afa$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4e707583c65f6afa$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $4e707583c65f6afa$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $4e707583c65f6afa$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $4e707583c65f6afa$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $4e707583c65f6afa$var$currentlyRenderingFiber || null !== alternate && alternate === $4e707583c65f6afa$var$currentlyRenderingFiber;
}
function $4e707583c65f6afa$var$enqueueRenderPhaseUpdate(queue, update) {
    $4e707583c65f6afa$var$didScheduleRenderPhaseUpdateDuringThisPass = $4e707583c65f6afa$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $4e707583c65f6afa$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $4e707583c65f6afa$var$markRootEntangled(root, lane);
    }
}
var $4e707583c65f6afa$var$ContextOnlyDispatcher = {
    readContext: $4e707583c65f6afa$var$readContext,
    use: $4e707583c65f6afa$var$use,
    useCallback: $4e707583c65f6afa$var$throwInvalidHookError,
    useContext: $4e707583c65f6afa$var$throwInvalidHookError,
    useEffect: $4e707583c65f6afa$var$throwInvalidHookError,
    useImperativeHandle: $4e707583c65f6afa$var$throwInvalidHookError,
    useLayoutEffect: $4e707583c65f6afa$var$throwInvalidHookError,
    useInsertionEffect: $4e707583c65f6afa$var$throwInvalidHookError,
    useMemo: $4e707583c65f6afa$var$throwInvalidHookError,
    useReducer: $4e707583c65f6afa$var$throwInvalidHookError,
    useRef: $4e707583c65f6afa$var$throwInvalidHookError,
    useState: $4e707583c65f6afa$var$throwInvalidHookError,
    useDebugValue: $4e707583c65f6afa$var$throwInvalidHookError,
    useDeferredValue: $4e707583c65f6afa$var$throwInvalidHookError,
    useTransition: $4e707583c65f6afa$var$throwInvalidHookError,
    useSyncExternalStore: $4e707583c65f6afa$var$throwInvalidHookError,
    useId: $4e707583c65f6afa$var$throwInvalidHookError,
    useHostTransitionStatus: $4e707583c65f6afa$var$throwInvalidHookError,
    useFormState: $4e707583c65f6afa$var$throwInvalidHookError,
    useActionState: $4e707583c65f6afa$var$throwInvalidHookError,
    useOptimistic: $4e707583c65f6afa$var$throwInvalidHookError,
    useMemoCache: $4e707583c65f6afa$var$throwInvalidHookError,
    useCacheRefresh: $4e707583c65f6afa$var$throwInvalidHookError
};
$4e707583c65f6afa$var$ContextOnlyDispatcher.useEffectEvent = $4e707583c65f6afa$var$throwInvalidHookError;
var $4e707583c65f6afa$var$HooksDispatcherOnMount = {
    readContext: $4e707583c65f6afa$var$readContext,
    use: $4e707583c65f6afa$var$use,
    useCallback: function(callback, deps) {
        $4e707583c65f6afa$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $4e707583c65f6afa$var$readContext,
    useEffect: $4e707583c65f6afa$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $4e707583c65f6afa$var$mountEffectImpl(4194308, 4, $4e707583c65f6afa$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $4e707583c65f6afa$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $4e707583c65f6afa$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $4e707583c65f6afa$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($4e707583c65f6afa$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $4e707583c65f6afa$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $4e707583c65f6afa$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $4e707583c65f6afa$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($4e707583c65f6afa$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $4e707583c65f6afa$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $4e707583c65f6afa$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $4e707583c65f6afa$var$dispatchReducerAction.bind(null, $4e707583c65f6afa$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $4e707583c65f6afa$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $4e707583c65f6afa$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $4e707583c65f6afa$var$dispatchSetState.bind(null, $4e707583c65f6afa$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $4e707583c65f6afa$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $4e707583c65f6afa$var$mountWorkInProgressHook();
        return $4e707583c65f6afa$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $4e707583c65f6afa$var$mountStateImpl(!1);
        stateHook = $4e707583c65f6afa$var$startTransition.bind(null, $4e707583c65f6afa$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $4e707583c65f6afa$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $4e707583c65f6afa$var$currentlyRenderingFiber, hook = $4e707583c65f6afa$var$mountWorkInProgressHook();
        if ($4e707583c65f6afa$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $4e707583c65f6afa$var$workInProgressRoot) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(349));
            0 !== ($4e707583c65f6afa$var$workInProgressRootRenderLanes & 127) || $4e707583c65f6afa$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $4e707583c65f6afa$var$mountEffect($4e707583c65f6afa$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $4e707583c65f6afa$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $4e707583c65f6afa$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $4e707583c65f6afa$var$mountWorkInProgressHook(), identifierPrefix = $4e707583c65f6afa$var$workInProgressRoot.identifierPrefix;
        if ($4e707583c65f6afa$var$isHydrating) {
            var JSCompiler_inline_result = $4e707583c65f6afa$var$treeContextOverflow;
            var idWithLeadingBit = $4e707583c65f6afa$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $4e707583c65f6afa$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $4e707583c65f6afa$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $4e707583c65f6afa$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $4e707583c65f6afa$var$useHostTransitionStatus,
    useFormState: $4e707583c65f6afa$var$mountActionState,
    useActionState: $4e707583c65f6afa$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $4e707583c65f6afa$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $4e707583c65f6afa$var$dispatchOptimisticSetState.bind(null, $4e707583c65f6afa$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $4e707583c65f6afa$var$useMemoCache,
    useCacheRefresh: function() {
        return $4e707583c65f6afa$var$mountWorkInProgressHook().memoizedState = $4e707583c65f6afa$var$refreshCache.bind(null, $4e707583c65f6afa$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $4e707583c65f6afa$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($4e707583c65f6afa$var$executionContext & 2)) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $4e707583c65f6afa$var$HooksDispatcherOnUpdate = {
    readContext: $4e707583c65f6afa$var$readContext,
    use: $4e707583c65f6afa$var$use,
    useCallback: $4e707583c65f6afa$var$updateCallback,
    useContext: $4e707583c65f6afa$var$readContext,
    useEffect: $4e707583c65f6afa$var$updateEffect,
    useImperativeHandle: $4e707583c65f6afa$var$updateImperativeHandle,
    useInsertionEffect: $4e707583c65f6afa$var$updateInsertionEffect,
    useLayoutEffect: $4e707583c65f6afa$var$updateLayoutEffect,
    useMemo: $4e707583c65f6afa$var$updateMemo,
    useReducer: $4e707583c65f6afa$var$updateReducer,
    useRef: $4e707583c65f6afa$var$updateRef,
    useState: function() {
        return $4e707583c65f6afa$var$updateReducer($4e707583c65f6afa$var$basicStateReducer);
    },
    useDebugValue: $4e707583c65f6afa$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $4e707583c65f6afa$var$updateWorkInProgressHook();
        return $4e707583c65f6afa$var$updateDeferredValueImpl(hook, $4e707583c65f6afa$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $4e707583c65f6afa$var$updateReducer($4e707583c65f6afa$var$basicStateReducer)[0], start = $4e707583c65f6afa$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $4e707583c65f6afa$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $4e707583c65f6afa$var$updateSyncExternalStore,
    useId: $4e707583c65f6afa$var$updateId,
    useHostTransitionStatus: $4e707583c65f6afa$var$useHostTransitionStatus,
    useFormState: $4e707583c65f6afa$var$updateActionState,
    useActionState: $4e707583c65f6afa$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $4e707583c65f6afa$var$updateWorkInProgressHook();
        return $4e707583c65f6afa$var$updateOptimisticImpl(hook, $4e707583c65f6afa$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $4e707583c65f6afa$var$useMemoCache,
    useCacheRefresh: $4e707583c65f6afa$var$updateRefresh
};
$4e707583c65f6afa$var$HooksDispatcherOnUpdate.useEffectEvent = $4e707583c65f6afa$var$updateEvent;
var $4e707583c65f6afa$var$HooksDispatcherOnRerender = {
    readContext: $4e707583c65f6afa$var$readContext,
    use: $4e707583c65f6afa$var$use,
    useCallback: $4e707583c65f6afa$var$updateCallback,
    useContext: $4e707583c65f6afa$var$readContext,
    useEffect: $4e707583c65f6afa$var$updateEffect,
    useImperativeHandle: $4e707583c65f6afa$var$updateImperativeHandle,
    useInsertionEffect: $4e707583c65f6afa$var$updateInsertionEffect,
    useLayoutEffect: $4e707583c65f6afa$var$updateLayoutEffect,
    useMemo: $4e707583c65f6afa$var$updateMemo,
    useReducer: $4e707583c65f6afa$var$rerenderReducer,
    useRef: $4e707583c65f6afa$var$updateRef,
    useState: function() {
        return $4e707583c65f6afa$var$rerenderReducer($4e707583c65f6afa$var$basicStateReducer);
    },
    useDebugValue: $4e707583c65f6afa$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $4e707583c65f6afa$var$updateWorkInProgressHook();
        return null === $4e707583c65f6afa$var$currentHook ? $4e707583c65f6afa$var$mountDeferredValueImpl(hook, value, initialValue) : $4e707583c65f6afa$var$updateDeferredValueImpl(hook, $4e707583c65f6afa$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $4e707583c65f6afa$var$rerenderReducer($4e707583c65f6afa$var$basicStateReducer)[0], start = $4e707583c65f6afa$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $4e707583c65f6afa$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $4e707583c65f6afa$var$updateSyncExternalStore,
    useId: $4e707583c65f6afa$var$updateId,
    useHostTransitionStatus: $4e707583c65f6afa$var$useHostTransitionStatus,
    useFormState: $4e707583c65f6afa$var$rerenderActionState,
    useActionState: $4e707583c65f6afa$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $4e707583c65f6afa$var$updateWorkInProgressHook();
        if (null !== $4e707583c65f6afa$var$currentHook) return $4e707583c65f6afa$var$updateOptimisticImpl(hook, $4e707583c65f6afa$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $4e707583c65f6afa$var$useMemoCache,
    useCacheRefresh: $4e707583c65f6afa$var$updateRefresh
};
$4e707583c65f6afa$var$HooksDispatcherOnRerender.useEffectEvent = $4e707583c65f6afa$var$updateEvent;
function $4e707583c65f6afa$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $4e707583c65f6afa$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $4e707583c65f6afa$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $4e707583c65f6afa$var$requestUpdateLane(), update = $4e707583c65f6afa$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $4e707583c65f6afa$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($4e707583c65f6afa$var$scheduleUpdateOnFiber(payload, inst, lane), $4e707583c65f6afa$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $4e707583c65f6afa$var$requestUpdateLane(), update = $4e707583c65f6afa$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $4e707583c65f6afa$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($4e707583c65f6afa$var$scheduleUpdateOnFiber(payload, inst, lane), $4e707583c65f6afa$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $4e707583c65f6afa$var$requestUpdateLane(), update = $4e707583c65f6afa$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $4e707583c65f6afa$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($4e707583c65f6afa$var$scheduleUpdateOnFiber(callback, inst, lane), $4e707583c65f6afa$var$entangleTransitions(callback, inst, lane));
    }
};
function $4e707583c65f6afa$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$4e707583c65f6afa$var$shallowEqual(oldProps, newProps) || !$4e707583c65f6afa$var$shallowEqual(oldState, newState) : !0;
}
function $4e707583c65f6afa$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $4e707583c65f6afa$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $4e707583c65f6afa$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $4e707583c65f6afa$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $4e707583c65f6afa$var$defaultOnUncaughtError(error) {
    $4e707583c65f6afa$var$reportGlobalError(error);
}
function $4e707583c65f6afa$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $4e707583c65f6afa$var$defaultOnRecoverableError(error) {
    $4e707583c65f6afa$var$reportGlobalError(error);
}
function $4e707583c65f6afa$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $4e707583c65f6afa$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $4e707583c65f6afa$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $4e707583c65f6afa$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $4e707583c65f6afa$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $4e707583c65f6afa$var$createClassErrorUpdate(lane) {
    lane = $4e707583c65f6afa$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $4e707583c65f6afa$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $4e707583c65f6afa$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $4e707583c65f6afa$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $4e707583c65f6afa$var$legacyErrorBoundariesThatAlreadyFailed ? $4e707583c65f6afa$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $4e707583c65f6afa$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $4e707583c65f6afa$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $4e707583c65f6afa$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $4e707583c65f6afa$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $4e707583c65f6afa$var$shellBoundary ? $4e707583c65f6afa$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $4e707583c65f6afa$var$workInProgressRootExitStatus && ($4e707583c65f6afa$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $4e707583c65f6afa$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $4e707583c65f6afa$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $4e707583c65f6afa$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $4e707583c65f6afa$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($4e707583c65f6afa$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $4e707583c65f6afa$var$attachPingListener(root, value, rootRenderLanes);
        $4e707583c65f6afa$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($4e707583c65f6afa$var$isHydrating) return returnFiber = $4e707583c65f6afa$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $4e707583c65f6afa$var$HydrationMismatchException && (root = Error($4e707583c65f6afa$var$formatProdErrorMessage(422), {
        cause: value
    }), $4e707583c65f6afa$var$queueHydrationError($4e707583c65f6afa$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $4e707583c65f6afa$var$HydrationMismatchException && (returnFiber = Error($4e707583c65f6afa$var$formatProdErrorMessage(423), {
        cause: value
    }), $4e707583c65f6afa$var$queueHydrationError($4e707583c65f6afa$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $4e707583c65f6afa$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $4e707583c65f6afa$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $4e707583c65f6afa$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $4e707583c65f6afa$var$workInProgressRootExitStatus && ($4e707583c65f6afa$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($4e707583c65f6afa$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $4e707583c65f6afa$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $4e707583c65f6afa$var$workInProgressRootConcurrentErrors ? $4e707583c65f6afa$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $4e707583c65f6afa$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $4e707583c65f6afa$var$workInProgressRootExitStatus && ($4e707583c65f6afa$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $4e707583c65f6afa$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $4e707583c65f6afa$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $4e707583c65f6afa$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $4e707583c65f6afa$var$legacyErrorBoundariesThatAlreadyFailed || !$4e707583c65f6afa$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $4e707583c65f6afa$var$createClassErrorUpdate(rootRenderLanes), $4e707583c65f6afa$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $4e707583c65f6afa$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $4e707583c65f6afa$var$SelectiveHydrationException = Error($4e707583c65f6afa$var$formatProdErrorMessage(461)), $4e707583c65f6afa$var$didReceiveUpdate = !1;
function $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $4e707583c65f6afa$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $4e707583c65f6afa$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $4e707583c65f6afa$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $4e707583c65f6afa$var$prepareToReadContext(workInProgress);
    nextProps = $4e707583c65f6afa$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $4e707583c65f6afa$var$checkDidRenderIdHook();
    if (null !== current && !$4e707583c65f6afa$var$didReceiveUpdate) return $4e707583c65f6afa$var$bailoutHooks(current, workInProgress, renderLanes), $4e707583c65f6afa$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $4e707583c65f6afa$var$isHydrating && key && $4e707583c65f6afa$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $4e707583c65f6afa$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$4e707583c65f6afa$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $4e707583c65f6afa$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $4e707583c65f6afa$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$4e707583c65f6afa$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $4e707583c65f6afa$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $4e707583c65f6afa$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $4e707583c65f6afa$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $4e707583c65f6afa$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($4e707583c65f6afa$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($4e707583c65f6afa$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $4e707583c65f6afa$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($4e707583c65f6afa$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $4e707583c65f6afa$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $4e707583c65f6afa$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $4e707583c65f6afa$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $4e707583c65f6afa$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $4e707583c65f6afa$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $4e707583c65f6afa$var$pushHiddenContext(workInProgress, prevState) : $4e707583c65f6afa$var$reuseHiddenContextOnStack(), $4e707583c65f6afa$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $4e707583c65f6afa$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($4e707583c65f6afa$var$pushTransition(workInProgress, prevState.cachePool), $4e707583c65f6afa$var$pushHiddenContext(workInProgress, prevState), $4e707583c65f6afa$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $4e707583c65f6afa$var$pushTransition(workInProgress, null), $4e707583c65f6afa$var$reuseHiddenContextOnStack(), $4e707583c65f6afa$var$reuseSuspenseHandlerOnStack(workInProgress));
    $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $4e707583c65f6afa$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $4e707583c65f6afa$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $4e707583c65f6afa$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $4e707583c65f6afa$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $4e707583c65f6afa$var$pushTransition(workInProgress, null);
    $4e707583c65f6afa$var$reuseHiddenContextOnStack();
    $4e707583c65f6afa$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $4e707583c65f6afa$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $4e707583c65f6afa$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $4e707583c65f6afa$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $4e707583c65f6afa$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $4e707583c65f6afa$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $4e707583c65f6afa$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $4e707583c65f6afa$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $4e707583c65f6afa$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($4e707583c65f6afa$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $4e707583c65f6afa$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $4e707583c65f6afa$var$bailoutOffscreenComponent(null, current);
            $4e707583c65f6afa$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $4e707583c65f6afa$var$nextHydratableInstance) ? (current = $4e707583c65f6afa$var$canHydrateHydrationBoundary(current, $4e707583c65f6afa$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $4e707583c65f6afa$var$treeContextProvider ? {
                    id: $4e707583c65f6afa$var$treeContextId,
                    overflow: $4e707583c65f6afa$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $4e707583c65f6afa$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $4e707583c65f6afa$var$hydrationParentFiber = workInProgress, $4e707583c65f6afa$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $4e707583c65f6afa$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $4e707583c65f6afa$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $4e707583c65f6afa$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $4e707583c65f6afa$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($4e707583c65f6afa$var$formatProdErrorMessage(558));
        } else if ($4e707583c65f6afa$var$didReceiveUpdate || $4e707583c65f6afa$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $4e707583c65f6afa$var$didReceiveUpdate || didSuspend) {
            nextProps = $4e707583c65f6afa$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $4e707583c65f6afa$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $4e707583c65f6afa$var$enqueueConcurrentRenderForLane(current, dehydrated), $4e707583c65f6afa$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $4e707583c65f6afa$var$SelectiveHydrationException;
            $4e707583c65f6afa$var$renderDidSuspendDelayIfPossible();
            workInProgress = $4e707583c65f6afa$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $4e707583c65f6afa$var$nextHydratableInstance = $4e707583c65f6afa$var$getNextHydratable(dehydrated.nextSibling), $4e707583c65f6afa$var$hydrationParentFiber = workInProgress, $4e707583c65f6afa$var$isHydrating = !0, $4e707583c65f6afa$var$hydrationErrors = null, $4e707583c65f6afa$var$rootOrSingletonContext = !1, null !== current && $4e707583c65f6afa$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $4e707583c65f6afa$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $4e707583c65f6afa$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $4e707583c65f6afa$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $4e707583c65f6afa$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $4e707583c65f6afa$var$prepareToReadContext(workInProgress);
    Component = $4e707583c65f6afa$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $4e707583c65f6afa$var$checkDidRenderIdHook();
    if (null !== current && !$4e707583c65f6afa$var$didReceiveUpdate) return $4e707583c65f6afa$var$bailoutHooks(current, workInProgress, renderLanes), $4e707583c65f6afa$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $4e707583c65f6afa$var$isHydrating && nextProps && $4e707583c65f6afa$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $4e707583c65f6afa$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $4e707583c65f6afa$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $4e707583c65f6afa$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $4e707583c65f6afa$var$finishRenderingHooks(current);
    Component = $4e707583c65f6afa$var$checkDidRenderIdHook();
    if (null !== current && !$4e707583c65f6afa$var$didReceiveUpdate) return $4e707583c65f6afa$var$bailoutHooks(current, workInProgress, renderLanes), $4e707583c65f6afa$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $4e707583c65f6afa$var$isHydrating && Component && $4e707583c65f6afa$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $4e707583c65f6afa$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $4e707583c65f6afa$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $4e707583c65f6afa$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $4e707583c65f6afa$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $4e707583c65f6afa$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $4e707583c65f6afa$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $4e707583c65f6afa$var$readContext(contextType) : $4e707583c65f6afa$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($4e707583c65f6afa$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $4e707583c65f6afa$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $4e707583c65f6afa$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $4e707583c65f6afa$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $4e707583c65f6afa$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $4e707583c65f6afa$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $4e707583c65f6afa$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $4e707583c65f6afa$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $4e707583c65f6afa$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $4e707583c65f6afa$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $4e707583c65f6afa$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $4e707583c65f6afa$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($4e707583c65f6afa$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $4e707583c65f6afa$var$hasForceUpdate || $4e707583c65f6afa$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $4e707583c65f6afa$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $4e707583c65f6afa$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $4e707583c65f6afa$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $4e707583c65f6afa$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $4e707583c65f6afa$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $4e707583c65f6afa$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $4e707583c65f6afa$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $4e707583c65f6afa$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $4e707583c65f6afa$var$hasForceUpdate || null !== current && null !== current.dependencies && $4e707583c65f6afa$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($4e707583c65f6afa$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $4e707583c65f6afa$var$hasForceUpdate || $4e707583c65f6afa$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $4e707583c65f6afa$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $4e707583c65f6afa$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $4e707583c65f6afa$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $4e707583c65f6afa$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $4e707583c65f6afa$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $4e707583c65f6afa$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $4e707583c65f6afa$var$resetHydrationState();
    workInProgress.flags |= 256;
    $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $4e707583c65f6afa$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $4e707583c65f6afa$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $4e707583c65f6afa$var$getSuspendedCache()
    };
}
function $4e707583c65f6afa$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $4e707583c65f6afa$var$workInProgressDeferredLane);
    return current;
}
function $4e707583c65f6afa$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($4e707583c65f6afa$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($4e707583c65f6afa$var$isHydrating) {
            showFallback ? $4e707583c65f6afa$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $4e707583c65f6afa$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $4e707583c65f6afa$var$nextHydratableInstance) ? (current = $4e707583c65f6afa$var$canHydrateHydrationBoundary(current, $4e707583c65f6afa$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $4e707583c65f6afa$var$treeContextProvider ? {
                    id: $4e707583c65f6afa$var$treeContextId,
                    overflow: $4e707583c65f6afa$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $4e707583c65f6afa$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $4e707583c65f6afa$var$hydrationParentFiber = workInProgress, $4e707583c65f6afa$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $4e707583c65f6afa$var$throwOnHydrationMismatch(workInProgress);
            $4e707583c65f6afa$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $4e707583c65f6afa$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $4e707583c65f6afa$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $4e707583c65f6afa$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $4e707583c65f6afa$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $4e707583c65f6afa$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $4e707583c65f6afa$var$SUSPENDED_MARKER, $4e707583c65f6afa$var$bailoutOffscreenComponent(null, nextProps);
        $4e707583c65f6afa$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $4e707583c65f6afa$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($4e707583c65f6afa$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $4e707583c65f6afa$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($4e707583c65f6afa$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($4e707583c65f6afa$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $4e707583c65f6afa$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $4e707583c65f6afa$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $4e707583c65f6afa$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $4e707583c65f6afa$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $4e707583c65f6afa$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $4e707583c65f6afa$var$SUSPENDED_MARKER, workInProgress = $4e707583c65f6afa$var$bailoutOffscreenComponent(null, nextProps));
        else if ($4e707583c65f6afa$var$pushPrimaryTreeSuspenseHandler(workInProgress), $4e707583c65f6afa$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($4e707583c65f6afa$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $4e707583c65f6afa$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $4e707583c65f6afa$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($4e707583c65f6afa$var$didReceiveUpdate || $4e707583c65f6afa$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $4e707583c65f6afa$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $4e707583c65f6afa$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $4e707583c65f6afa$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $4e707583c65f6afa$var$enqueueConcurrentRenderForLane(current, nextProps), $4e707583c65f6afa$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $4e707583c65f6afa$var$SelectiveHydrationException;
            $4e707583c65f6afa$var$isSuspenseInstancePending(nextPrimaryChildren) || $4e707583c65f6afa$var$renderDidSuspendDelayIfPossible();
            workInProgress = $4e707583c65f6afa$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $4e707583c65f6afa$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $4e707583c65f6afa$var$nextHydratableInstance = $4e707583c65f6afa$var$getNextHydratable(nextPrimaryChildren.nextSibling), $4e707583c65f6afa$var$hydrationParentFiber = workInProgress, $4e707583c65f6afa$var$isHydrating = !0, $4e707583c65f6afa$var$hydrationErrors = null, $4e707583c65f6afa$var$rootOrSingletonContext = !1, null !== current && $4e707583c65f6afa$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $4e707583c65f6afa$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $4e707583c65f6afa$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $4e707583c65f6afa$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $4e707583c65f6afa$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $4e707583c65f6afa$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $4e707583c65f6afa$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $4e707583c65f6afa$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $4e707583c65f6afa$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $4e707583c65f6afa$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $4e707583c65f6afa$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $4e707583c65f6afa$var$SUSPENDED_MARKER, $4e707583c65f6afa$var$bailoutOffscreenComponent(current.child, nextProps);
    $4e707583c65f6afa$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $4e707583c65f6afa$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $4e707583c65f6afa$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $4e707583c65f6afa$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $4e707583c65f6afa$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $4e707583c65f6afa$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $4e707583c65f6afa$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $4e707583c65f6afa$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $4e707583c65f6afa$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $4e707583c65f6afa$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $4e707583c65f6afa$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $4e707583c65f6afa$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $4e707583c65f6afa$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $4e707583c65f6afa$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $4e707583c65f6afa$var$push($4e707583c65f6afa$var$suspenseStackCursor, suspenseContext);
    $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $4e707583c65f6afa$var$isHydrating ? $4e707583c65f6afa$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $4e707583c65f6afa$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $4e707583c65f6afa$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $4e707583c65f6afa$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $4e707583c65f6afa$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $4e707583c65f6afa$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $4e707583c65f6afa$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $4e707583c65f6afa$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $4e707583c65f6afa$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $4e707583c65f6afa$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($4e707583c65f6afa$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $4e707583c65f6afa$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $4e707583c65f6afa$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $4e707583c65f6afa$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $4e707583c65f6afa$var$checkIfContextChanged(current) ? !0 : !1;
}
function $4e707583c65f6afa$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $4e707583c65f6afa$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $4e707583c65f6afa$var$pushProvider(workInProgress, $4e707583c65f6afa$var$CacheContext, current.memoizedState.cache);
            $4e707583c65f6afa$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $4e707583c65f6afa$var$pushHostContext(workInProgress);
            break;
        case 4:
            $4e707583c65f6afa$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $4e707583c65f6afa$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $4e707583c65f6afa$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $4e707583c65f6afa$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $4e707583c65f6afa$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $4e707583c65f6afa$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $4e707583c65f6afa$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $4e707583c65f6afa$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($4e707583c65f6afa$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $4e707583c65f6afa$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $4e707583c65f6afa$var$push($4e707583c65f6afa$var$suspenseStackCursor, $4e707583c65f6afa$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $4e707583c65f6afa$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $4e707583c65f6afa$var$pushProvider(workInProgress, $4e707583c65f6afa$var$CacheContext, current.memoizedState.cache);
    }
    return $4e707583c65f6afa$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $4e707583c65f6afa$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $4e707583c65f6afa$var$didReceiveUpdate = !0;
        else {
            if (!$4e707583c65f6afa$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $4e707583c65f6afa$var$didReceiveUpdate = !1, $4e707583c65f6afa$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $4e707583c65f6afa$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $4e707583c65f6afa$var$didReceiveUpdate = !1, $4e707583c65f6afa$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $4e707583c65f6afa$var$pushTreeId(workInProgress, $4e707583c65f6afa$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $4e707583c65f6afa$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $4e707583c65f6afa$var$shouldConstruct(current) ? (props = $4e707583c65f6afa$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $4e707583c65f6afa$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $4e707583c65f6afa$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $4e707583c65f6afa$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $4e707583c65f6afa$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $4e707583c65f6afa$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $4e707583c65f6afa$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $4e707583c65f6afa$var$getComponentNameFromType(current) || current;
                    throw Error($4e707583c65f6afa$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $4e707583c65f6afa$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $4e707583c65f6afa$var$resolveClassComponentProps(props, workInProgress.pendingProps), $4e707583c65f6afa$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $4e707583c65f6afa$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $4e707583c65f6afa$var$cloneUpdateQueue(current, workInProgress);
                $4e707583c65f6afa$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $4e707583c65f6afa$var$pushProvider(workInProgress, $4e707583c65f6afa$var$CacheContext, props);
                props !== prevState.cache && $4e707583c65f6afa$var$propagateContextChanges(workInProgress, [
                    $4e707583c65f6afa$var$CacheContext
                ], renderLanes, !0);
                $4e707583c65f6afa$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $4e707583c65f6afa$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $4e707583c65f6afa$var$createCapturedValueAtFiber(Error($4e707583c65f6afa$var$formatProdErrorMessage(424)), workInProgress);
                        $4e707583c65f6afa$var$queueHydrationError($$typeof);
                        workInProgress = $4e707583c65f6afa$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $4e707583c65f6afa$var$nextHydratableInstance = $4e707583c65f6afa$var$getNextHydratable(current.firstChild);
                        $4e707583c65f6afa$var$hydrationParentFiber = workInProgress;
                        $4e707583c65f6afa$var$isHydrating = !0;
                        $4e707583c65f6afa$var$hydrationErrors = null;
                        $4e707583c65f6afa$var$rootOrSingletonContext = !0;
                        renderLanes = $4e707583c65f6afa$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $4e707583c65f6afa$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $4e707583c65f6afa$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $4e707583c65f6afa$var$markRef(current, workInProgress), null === current ? (renderLanes = $4e707583c65f6afa$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $4e707583c65f6afa$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $4e707583c65f6afa$var$getOwnerDocumentFromRootContainer($4e707583c65f6afa$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$4e707583c65f6afa$var$internalInstanceKey] = workInProgress, props[$4e707583c65f6afa$var$internalPropsKey] = current, $4e707583c65f6afa$var$setInitialProperties(props, renderLanes, current), $4e707583c65f6afa$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $4e707583c65f6afa$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $4e707583c65f6afa$var$pushHostContext(workInProgress), null === current && $4e707583c65f6afa$var$isHydrating && (props = workInProgress.stateNode = $4e707583c65f6afa$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $4e707583c65f6afa$var$rootInstanceStackCursor.current), $4e707583c65f6afa$var$hydrationParentFiber = workInProgress, $4e707583c65f6afa$var$rootOrSingletonContext = !0, $$typeof = $4e707583c65f6afa$var$nextHydratableInstance, $4e707583c65f6afa$var$isSingletonScope(workInProgress.type) ? ($4e707583c65f6afa$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $4e707583c65f6afa$var$nextHydratableInstance = $4e707583c65f6afa$var$getNextHydratable(props.firstChild)) : $4e707583c65f6afa$var$nextHydratableInstance = $$typeof), $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $4e707583c65f6afa$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $4e707583c65f6afa$var$isHydrating) {
                if ($$typeof = props = $4e707583c65f6afa$var$nextHydratableInstance) props = $4e707583c65f6afa$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $4e707583c65f6afa$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $4e707583c65f6afa$var$hydrationParentFiber = workInProgress, $4e707583c65f6afa$var$nextHydratableInstance = $4e707583c65f6afa$var$getNextHydratable(props.firstChild), $4e707583c65f6afa$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $4e707583c65f6afa$var$throwOnHydrationMismatch(workInProgress);
            }
            $4e707583c65f6afa$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $4e707583c65f6afa$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $4e707583c65f6afa$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $4e707583c65f6afa$var$renderWithHooks(current, workInProgress, $4e707583c65f6afa$var$TransitionAwareHostComponent, null, null, renderLanes), $4e707583c65f6afa$var$HostTransitionContext._currentValue = $$typeof);
            $4e707583c65f6afa$var$markRef(current, workInProgress);
            $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $4e707583c65f6afa$var$isHydrating) {
                if (current = renderLanes = $4e707583c65f6afa$var$nextHydratableInstance) renderLanes = $4e707583c65f6afa$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $4e707583c65f6afa$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $4e707583c65f6afa$var$hydrationParentFiber = workInProgress, $4e707583c65f6afa$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $4e707583c65f6afa$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $4e707583c65f6afa$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $4e707583c65f6afa$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $4e707583c65f6afa$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $4e707583c65f6afa$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $4e707583c65f6afa$var$pushProvider(workInProgress, workInProgress.type, props.value), $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $4e707583c65f6afa$var$prepareToReadContext(workInProgress), $$typeof = $4e707583c65f6afa$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $4e707583c65f6afa$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $4e707583c65f6afa$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $4e707583c65f6afa$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $4e707583c65f6afa$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $4e707583c65f6afa$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $4e707583c65f6afa$var$prepareToReadContext(workInProgress), props = $4e707583c65f6afa$var$readContext($4e707583c65f6afa$var$CacheContext), null === current ? ($$typeof = $4e707583c65f6afa$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $4e707583c65f6afa$var$workInProgressRoot, prevState = $4e707583c65f6afa$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $4e707583c65f6afa$var$initializeUpdateQueue(workInProgress), $4e707583c65f6afa$var$pushProvider(workInProgress, $4e707583c65f6afa$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($4e707583c65f6afa$var$cloneUpdateQueue(current, workInProgress), $4e707583c65f6afa$var$processUpdateQueue(workInProgress, null, null, renderLanes), $4e707583c65f6afa$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $4e707583c65f6afa$var$pushProvider(workInProgress, $4e707583c65f6afa$var$CacheContext, props)) : (props = prevState.cache, $4e707583c65f6afa$var$pushProvider(workInProgress, $4e707583c65f6afa$var$CacheContext, props), props !== $$typeof.cache && $4e707583c65f6afa$var$propagateContextChanges(workInProgress, [
                $4e707583c65f6afa$var$CacheContext
            ], renderLanes, !0))), $4e707583c65f6afa$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($4e707583c65f6afa$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $4e707583c65f6afa$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $4e707583c65f6afa$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($4e707583c65f6afa$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $4e707583c65f6afa$var$suspendedThenable = $4e707583c65f6afa$var$noopSuspenseyCommitThenable, $4e707583c65f6afa$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $4e707583c65f6afa$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$4e707583c65f6afa$var$preloadResource(resource)) {
        if ($4e707583c65f6afa$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $4e707583c65f6afa$var$suspendedThenable = $4e707583c65f6afa$var$noopSuspenseyCommitThenable, $4e707583c65f6afa$var$SuspenseyCommitException;
    }
}
function $4e707583c65f6afa$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $4e707583c65f6afa$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $4e707583c65f6afa$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $4e707583c65f6afa$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$4e707583c65f6afa$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $4e707583c65f6afa$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $4e707583c65f6afa$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $4e707583c65f6afa$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4e707583c65f6afa$var$bubbleProperties(workInProgress), null;
        case 1:
            return $4e707583c65f6afa$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $4e707583c65f6afa$var$popProvider($4e707583c65f6afa$var$CacheContext);
            $4e707583c65f6afa$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $4e707583c65f6afa$var$popHydrationState(workInProgress) ? $4e707583c65f6afa$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $4e707583c65f6afa$var$upgradeHydrationErrorsToRecoverable());
            $4e707583c65f6afa$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($4e707583c65f6afa$var$markUpdate(workInProgress), null !== nextResource ? ($4e707583c65f6afa$var$bubbleProperties(workInProgress), $4e707583c65f6afa$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($4e707583c65f6afa$var$bubbleProperties(workInProgress), $4e707583c65f6afa$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($4e707583c65f6afa$var$markUpdate(workInProgress), $4e707583c65f6afa$var$bubbleProperties(workInProgress), $4e707583c65f6afa$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($4e707583c65f6afa$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $4e707583c65f6afa$var$markUpdate(workInProgress), $4e707583c65f6afa$var$bubbleProperties(workInProgress), $4e707583c65f6afa$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $4e707583c65f6afa$var$popHostContext(workInProgress);
            renderLanes = $4e707583c65f6afa$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $4e707583c65f6afa$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(166));
                    $4e707583c65f6afa$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $4e707583c65f6afa$var$contextStackCursor.current;
                $4e707583c65f6afa$var$popHydrationState(workInProgress) ? $4e707583c65f6afa$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $4e707583c65f6afa$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $4e707583c65f6afa$var$markUpdate(workInProgress));
            }
            $4e707583c65f6afa$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $4e707583c65f6afa$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $4e707583c65f6afa$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(166));
                    $4e707583c65f6afa$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $4e707583c65f6afa$var$contextStackCursor.current;
                if ($4e707583c65f6afa$var$popHydrationState(workInProgress)) $4e707583c65f6afa$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $4e707583c65f6afa$var$getOwnerDocumentFromRootContainer($4e707583c65f6afa$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$4e707583c65f6afa$var$internalInstanceKey] = workInProgress;
                    nextResource[$4e707583c65f6afa$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($4e707583c65f6afa$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $4e707583c65f6afa$var$markUpdate(workInProgress);
                }
            }
            $4e707583c65f6afa$var$bubbleProperties(workInProgress);
            $4e707583c65f6afa$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $4e707583c65f6afa$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(166));
                current = $4e707583c65f6afa$var$rootInstanceStackCursor.current;
                if ($4e707583c65f6afa$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $4e707583c65f6afa$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$4e707583c65f6afa$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $4e707583c65f6afa$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $4e707583c65f6afa$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $4e707583c65f6afa$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$4e707583c65f6afa$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $4e707583c65f6afa$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $4e707583c65f6afa$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(557));
                        current[$4e707583c65f6afa$var$internalInstanceKey] = workInProgress;
                    } else $4e707583c65f6afa$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $4e707583c65f6afa$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $4e707583c65f6afa$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $4e707583c65f6afa$var$popSuspenseHandler(workInProgress), workInProgress;
                    $4e707583c65f6afa$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(558));
            }
            $4e707583c65f6afa$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $4e707583c65f6afa$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(317));
                        type[$4e707583c65f6afa$var$internalInstanceKey] = workInProgress;
                    } else $4e707583c65f6afa$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $4e707583c65f6afa$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $4e707583c65f6afa$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $4e707583c65f6afa$var$popSuspenseHandler(workInProgress), workInProgress;
                    $4e707583c65f6afa$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $4e707583c65f6afa$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $4e707583c65f6afa$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $4e707583c65f6afa$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $4e707583c65f6afa$var$popHostContainer(), null === current && $4e707583c65f6afa$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $4e707583c65f6afa$var$bubbleProperties(workInProgress), null;
        case 10:
            return $4e707583c65f6afa$var$popProvider(workInProgress.type), $4e707583c65f6afa$var$bubbleProperties(workInProgress), null;
        case 19:
            $4e707583c65f6afa$var$pop($4e707583c65f6afa$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $4e707583c65f6afa$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $4e707583c65f6afa$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $4e707583c65f6afa$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $4e707583c65f6afa$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $4e707583c65f6afa$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $4e707583c65f6afa$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$4e707583c65f6afa$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $4e707583c65f6afa$var$push($4e707583c65f6afa$var$suspenseStackCursor, $4e707583c65f6afa$var$suspenseStackCursor.current & 1 | 2);
                            $4e707583c65f6afa$var$isHydrating && $4e707583c65f6afa$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $4e707583c65f6afa$var$now() > $4e707583c65f6afa$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $4e707583c65f6afa$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $4e707583c65f6afa$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $4e707583c65f6afa$var$scheduleRetryEffect(workInProgress, current), $4e707583c65f6afa$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$4e707583c65f6afa$var$isHydrating) return $4e707583c65f6afa$var$bubbleProperties(workInProgress), null;
                    } else 2 * $4e707583c65f6afa$var$now() - newProps.renderingStartTime > $4e707583c65f6afa$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $4e707583c65f6afa$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $4e707583c65f6afa$var$now(), current.sibling = null, renderLanes = $4e707583c65f6afa$var$suspenseStackCursor.current, $4e707583c65f6afa$var$push($4e707583c65f6afa$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $4e707583c65f6afa$var$isHydrating && $4e707583c65f6afa$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $4e707583c65f6afa$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $4e707583c65f6afa$var$popSuspenseHandler(workInProgress), $4e707583c65f6afa$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($4e707583c65f6afa$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $4e707583c65f6afa$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $4e707583c65f6afa$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $4e707583c65f6afa$var$pop($4e707583c65f6afa$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $4e707583c65f6afa$var$popProvider($4e707583c65f6afa$var$CacheContext), $4e707583c65f6afa$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($4e707583c65f6afa$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $4e707583c65f6afa$var$unwindWork(current, workInProgress) {
    $4e707583c65f6afa$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $4e707583c65f6afa$var$popProvider($4e707583c65f6afa$var$CacheContext), $4e707583c65f6afa$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $4e707583c65f6afa$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $4e707583c65f6afa$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(340));
                $4e707583c65f6afa$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $4e707583c65f6afa$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(340));
                $4e707583c65f6afa$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $4e707583c65f6afa$var$pop($4e707583c65f6afa$var$suspenseStackCursor), null;
        case 4:
            return $4e707583c65f6afa$var$popHostContainer(), null;
        case 10:
            return $4e707583c65f6afa$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $4e707583c65f6afa$var$popSuspenseHandler(workInProgress), $4e707583c65f6afa$var$popHiddenContext(), null !== current && $4e707583c65f6afa$var$pop($4e707583c65f6afa$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $4e707583c65f6afa$var$popProvider($4e707583c65f6afa$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $4e707583c65f6afa$var$unwindInterruptedWork(current, interruptedWork) {
    $4e707583c65f6afa$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $4e707583c65f6afa$var$popProvider($4e707583c65f6afa$var$CacheContext);
            $4e707583c65f6afa$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $4e707583c65f6afa$var$popHostContext(interruptedWork);
            break;
        case 4:
            $4e707583c65f6afa$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $4e707583c65f6afa$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $4e707583c65f6afa$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $4e707583c65f6afa$var$pop($4e707583c65f6afa$var$suspenseStackCursor);
            break;
        case 10:
            $4e707583c65f6afa$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $4e707583c65f6afa$var$popSuspenseHandler(interruptedWork);
            $4e707583c65f6afa$var$popHiddenContext();
            null !== current && $4e707583c65f6afa$var$pop($4e707583c65f6afa$var$resumedCache);
            break;
        case 24:
            $4e707583c65f6afa$var$popProvider($4e707583c65f6afa$var$CacheContext);
    }
}
function $4e707583c65f6afa$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $4e707583c65f6afa$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $4e707583c65f6afa$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $4e707583c65f6afa$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $4e707583c65f6afa$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $4e707583c65f6afa$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $4e707583c65f6afa$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $4e707583c65f6afa$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $4e707583c65f6afa$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $4e707583c65f6afa$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $4e707583c65f6afa$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $4e707583c65f6afa$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $4e707583c65f6afa$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $4e707583c65f6afa$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $4e707583c65f6afa$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $4e707583c65f6afa$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $4e707583c65f6afa$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $4e707583c65f6afa$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $4e707583c65f6afa$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $4e707583c65f6afa$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$4e707583c65f6afa$var$internalPropsKey] = newProps;
    } catch (error) {
        $4e707583c65f6afa$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $4e707583c65f6afa$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $4e707583c65f6afa$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $4e707583c65f6afa$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $4e707583c65f6afa$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $4e707583c65f6afa$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $4e707583c65f6afa$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $4e707583c65f6afa$var$noop$1));
    else if (4 !== tag && (27 === tag && $4e707583c65f6afa$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($4e707583c65f6afa$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$4e707583c65f6afa$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $4e707583c65f6afa$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $4e707583c65f6afa$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($4e707583c65f6afa$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$4e707583c65f6afa$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $4e707583c65f6afa$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $4e707583c65f6afa$var$setInitialProperties(singleton, type, props);
        singleton[$4e707583c65f6afa$var$internalInstanceKey] = finishedWork;
        singleton[$4e707583c65f6afa$var$internalPropsKey] = props;
    } catch (error) {
        $4e707583c65f6afa$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $4e707583c65f6afa$var$offscreenSubtreeIsHidden = !1, $4e707583c65f6afa$var$offscreenSubtreeWasHidden = !1, $4e707583c65f6afa$var$needsFormReset = !1, $4e707583c65f6afa$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $4e707583c65f6afa$var$nextEffect = null;
function $4e707583c65f6afa$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $4e707583c65f6afa$var$eventsEnabled = $4e707583c65f6afa$var$_enabled;
    root = $4e707583c65f6afa$var$getActiveElementDeep(root);
    if ($4e707583c65f6afa$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $4e707583c65f6afa$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $4e707583c65f6afa$var$_enabled = !1;
    for($4e707583c65f6afa$var$nextEffect = firstChild; null !== $4e707583c65f6afa$var$nextEffect;)if (firstChild = $4e707583c65f6afa$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $4e707583c65f6afa$var$nextEffect = root;
    else for(; null !== $4e707583c65f6afa$var$nextEffect;){
        firstChild = $4e707583c65f6afa$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $4e707583c65f6afa$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $4e707583c65f6afa$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $4e707583c65f6afa$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $4e707583c65f6afa$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $4e707583c65f6afa$var$nextEffect = root;
            break;
        }
        $4e707583c65f6afa$var$nextEffect = firstChild.return;
    }
}
function $4e707583c65f6afa$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $4e707583c65f6afa$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $4e707583c65f6afa$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $4e707583c65f6afa$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $4e707583c65f6afa$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $4e707583c65f6afa$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $4e707583c65f6afa$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $4e707583c65f6afa$var$commitClassCallbacks(finishedWork);
            flags & 512 && $4e707583c65f6afa$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $4e707583c65f6afa$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $4e707583c65f6afa$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $4e707583c65f6afa$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $4e707583c65f6afa$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $4e707583c65f6afa$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $4e707583c65f6afa$var$commitHostMount(finishedWork);
            flags & 512 && $4e707583c65f6afa$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $4e707583c65f6afa$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $4e707583c65f6afa$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $4e707583c65f6afa$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $4e707583c65f6afa$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $4e707583c65f6afa$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $4e707583c65f6afa$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $4e707583c65f6afa$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $4e707583c65f6afa$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $4e707583c65f6afa$var$offscreenSubtreeWasHidden;
                prevProps = $4e707583c65f6afa$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $4e707583c65f6afa$var$offscreenSubtreeWasHidden;
                $4e707583c65f6afa$var$offscreenSubtreeIsHidden = flags;
                ($4e707583c65f6afa$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $4e707583c65f6afa$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $4e707583c65f6afa$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $4e707583c65f6afa$var$offscreenSubtreeIsHidden = prevProps;
                $4e707583c65f6afa$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $4e707583c65f6afa$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $4e707583c65f6afa$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $4e707583c65f6afa$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $4e707583c65f6afa$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $4e707583c65f6afa$var$hostParent = null, $4e707583c65f6afa$var$hostParentIsContainer = !1;
function $4e707583c65f6afa$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$4e707583c65f6afa$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $4e707583c65f6afa$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($4e707583c65f6afa$var$injectedHook && "function" === typeof $4e707583c65f6afa$var$injectedHook.onCommitFiberUnmount) try {
        $4e707583c65f6afa$var$injectedHook.onCommitFiberUnmount($4e707583c65f6afa$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $4e707583c65f6afa$var$offscreenSubtreeWasHidden || $4e707583c65f6afa$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $4e707583c65f6afa$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $4e707583c65f6afa$var$offscreenSubtreeWasHidden || $4e707583c65f6afa$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $4e707583c65f6afa$var$hostParent, prevHostParentIsContainer = $4e707583c65f6afa$var$hostParentIsContainer;
            $4e707583c65f6afa$var$isSingletonScope(deletedFiber.type) && ($4e707583c65f6afa$var$hostParent = deletedFiber.stateNode, $4e707583c65f6afa$var$hostParentIsContainer = !1);
            $4e707583c65f6afa$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $4e707583c65f6afa$var$releaseSingletonInstance(deletedFiber.stateNode);
            $4e707583c65f6afa$var$hostParent = prevHostParent;
            $4e707583c65f6afa$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $4e707583c65f6afa$var$offscreenSubtreeWasHidden || $4e707583c65f6afa$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $4e707583c65f6afa$var$hostParent;
            prevHostParentIsContainer = $4e707583c65f6afa$var$hostParentIsContainer;
            $4e707583c65f6afa$var$hostParent = null;
            $4e707583c65f6afa$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $4e707583c65f6afa$var$hostParent = prevHostParent;
            $4e707583c65f6afa$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $4e707583c65f6afa$var$hostParent) {
                if ($4e707583c65f6afa$var$hostParentIsContainer) try {
                    (9 === $4e707583c65f6afa$var$hostParent.nodeType ? $4e707583c65f6afa$var$hostParent.body : "HTML" === $4e707583c65f6afa$var$hostParent.nodeName ? $4e707583c65f6afa$var$hostParent.ownerDocument.body : $4e707583c65f6afa$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $4e707583c65f6afa$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $4e707583c65f6afa$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $4e707583c65f6afa$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $4e707583c65f6afa$var$hostParent && ($4e707583c65f6afa$var$hostParentIsContainer ? (finishedRoot = $4e707583c65f6afa$var$hostParent, $4e707583c65f6afa$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $4e707583c65f6afa$var$retryIfBlockedOn(finishedRoot)) : $4e707583c65f6afa$var$clearHydrationBoundary($4e707583c65f6afa$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $4e707583c65f6afa$var$hostParent;
            prevHostParentIsContainer = $4e707583c65f6afa$var$hostParentIsContainer;
            $4e707583c65f6afa$var$hostParent = deletedFiber.stateNode.containerInfo;
            $4e707583c65f6afa$var$hostParentIsContainer = !0;
            $4e707583c65f6afa$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $4e707583c65f6afa$var$hostParent = prevHostParent;
            $4e707583c65f6afa$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $4e707583c65f6afa$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $4e707583c65f6afa$var$offscreenSubtreeWasHidden || $4e707583c65f6afa$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $4e707583c65f6afa$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $4e707583c65f6afa$var$offscreenSubtreeWasHidden || ($4e707583c65f6afa$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $4e707583c65f6afa$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $4e707583c65f6afa$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $4e707583c65f6afa$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $4e707583c65f6afa$var$offscreenSubtreeWasHidden = (prevHostParent = $4e707583c65f6afa$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $4e707583c65f6afa$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $4e707583c65f6afa$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $4e707583c65f6afa$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $4e707583c65f6afa$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $4e707583c65f6afa$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $4e707583c65f6afa$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $4e707583c65f6afa$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $4e707583c65f6afa$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $4e707583c65f6afa$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $4e707583c65f6afa$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $4e707583c65f6afa$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $4e707583c65f6afa$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($4e707583c65f6afa$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $4e707583c65f6afa$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $4e707583c65f6afa$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $4e707583c65f6afa$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $4e707583c65f6afa$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($4e707583c65f6afa$var$isSingletonScope(parent.type)) {
                        $4e707583c65f6afa$var$hostParent = parent.stateNode;
                        $4e707583c65f6afa$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $4e707583c65f6afa$var$hostParent = parent.stateNode;
                    $4e707583c65f6afa$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $4e707583c65f6afa$var$hostParent = parent.stateNode.containerInfo;
                    $4e707583c65f6afa$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $4e707583c65f6afa$var$hostParent) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(160));
        $4e707583c65f6afa$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $4e707583c65f6afa$var$hostParent = null;
        $4e707583c65f6afa$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$4e707583c65f6afa$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $4e707583c65f6afa$var$currentHoistableRoot = null;
function $4e707583c65f6afa$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4e707583c65f6afa$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4e707583c65f6afa$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($4e707583c65f6afa$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $4e707583c65f6afa$var$commitHookEffectListMount(3, finishedWork), $4e707583c65f6afa$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $4e707583c65f6afa$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4e707583c65f6afa$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($4e707583c65f6afa$var$offscreenSubtreeWasHidden || null === current || $4e707583c65f6afa$var$safelyDetachRef(current, current.return));
            flags & 64 && $4e707583c65f6afa$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $4e707583c65f6afa$var$currentHoistableRoot;
            $4e707583c65f6afa$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4e707583c65f6afa$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($4e707583c65f6afa$var$offscreenSubtreeWasHidden || null === current || $4e707583c65f6afa$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$4e707583c65f6afa$var$internalHoistableMarker] || currentResource[$4e707583c65f6afa$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $4e707583c65f6afa$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$4e707583c65f6afa$var$internalInstanceKey] = finishedWork;
                                        $4e707583c65f6afa$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $4e707583c65f6afa$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $4e707583c65f6afa$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $4e707583c65f6afa$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $4e707583c65f6afa$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($4e707583c65f6afa$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$4e707583c65f6afa$var$internalInstanceKey] = finishedWork;
                                $4e707583c65f6afa$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $4e707583c65f6afa$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $4e707583c65f6afa$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $4e707583c65f6afa$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $4e707583c65f6afa$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $4e707583c65f6afa$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $4e707583c65f6afa$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4e707583c65f6afa$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($4e707583c65f6afa$var$offscreenSubtreeWasHidden || null === current || $4e707583c65f6afa$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $4e707583c65f6afa$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $4e707583c65f6afa$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4e707583c65f6afa$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($4e707583c65f6afa$var$offscreenSubtreeWasHidden || null === current || $4e707583c65f6afa$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $4e707583c65f6afa$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $4e707583c65f6afa$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $4e707583c65f6afa$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($4e707583c65f6afa$var$needsFormReset = !0);
            break;
        case 6:
            $4e707583c65f6afa$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4e707583c65f6afa$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $4e707583c65f6afa$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $4e707583c65f6afa$var$tagCaches = null;
            hoistableRoot = $4e707583c65f6afa$var$currentHoistableRoot;
            $4e707583c65f6afa$var$currentHoistableRoot = $4e707583c65f6afa$var$getHoistableRoot(root.containerInfo);
            $4e707583c65f6afa$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4e707583c65f6afa$var$currentHoistableRoot = hoistableRoot;
            $4e707583c65f6afa$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $4e707583c65f6afa$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $4e707583c65f6afa$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $4e707583c65f6afa$var$needsFormReset && ($4e707583c65f6afa$var$needsFormReset = !1, $4e707583c65f6afa$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $4e707583c65f6afa$var$currentHoistableRoot;
            $4e707583c65f6afa$var$currentHoistableRoot = $4e707583c65f6afa$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $4e707583c65f6afa$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4e707583c65f6afa$var$commitReconciliationEffects(finishedWork);
            $4e707583c65f6afa$var$currentHoistableRoot = flags;
            break;
        case 12:
            $4e707583c65f6afa$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4e707583c65f6afa$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $4e707583c65f6afa$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4e707583c65f6afa$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $4e707583c65f6afa$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $4e707583c65f6afa$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4e707583c65f6afa$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($4e707583c65f6afa$var$globalMostRecentFallbackTime = $4e707583c65f6afa$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $4e707583c65f6afa$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $4e707583c65f6afa$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $4e707583c65f6afa$var$offscreenSubtreeWasHidden;
            $4e707583c65f6afa$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $4e707583c65f6afa$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $4e707583c65f6afa$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4e707583c65f6afa$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $4e707583c65f6afa$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $4e707583c65f6afa$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $4e707583c65f6afa$var$offscreenSubtreeIsHidden || $4e707583c65f6afa$var$offscreenSubtreeWasHidden || $4e707583c65f6afa$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $4e707583c65f6afa$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $4e707583c65f6afa$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $4e707583c65f6afa$var$hideOrUnhideDehydratedBoundary(instance, !0) : $4e707583c65f6afa$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $4e707583c65f6afa$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $4e707583c65f6afa$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $4e707583c65f6afa$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4e707583c65f6afa$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $4e707583c65f6afa$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $4e707583c65f6afa$var$recursivelyTraverseMutationEffects(root, finishedWork), $4e707583c65f6afa$var$commitReconciliationEffects(finishedWork);
    }
}
function $4e707583c65f6afa$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($4e707583c65f6afa$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $4e707583c65f6afa$var$getHostSibling(finishedWork);
                    $4e707583c65f6afa$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($4e707583c65f6afa$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $4e707583c65f6afa$var$getHostSibling(finishedWork);
                    $4e707583c65f6afa$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $4e707583c65f6afa$var$getHostSibling(finishedWork);
                    $4e707583c65f6afa$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($4e707583c65f6afa$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $4e707583c65f6afa$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $4e707583c65f6afa$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $4e707583c65f6afa$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $4e707583c65f6afa$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$4e707583c65f6afa$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $4e707583c65f6afa$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $4e707583c65f6afa$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $4e707583c65f6afa$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $4e707583c65f6afa$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $4e707583c65f6afa$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $4e707583c65f6afa$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $4e707583c65f6afa$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $4e707583c65f6afa$var$safelyDetachRef(finishedWork, finishedWork.return);
                $4e707583c65f6afa$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $4e707583c65f6afa$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $4e707583c65f6afa$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $4e707583c65f6afa$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $4e707583c65f6afa$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $4e707583c65f6afa$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $4e707583c65f6afa$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $4e707583c65f6afa$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $4e707583c65f6afa$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$4e707583c65f6afa$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $4e707583c65f6afa$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $4e707583c65f6afa$var$commitClassCallbacks(finishedWork);
                $4e707583c65f6afa$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $4e707583c65f6afa$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $4e707583c65f6afa$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $4e707583c65f6afa$var$commitHostMount(finishedWork);
                $4e707583c65f6afa$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $4e707583c65f6afa$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $4e707583c65f6afa$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $4e707583c65f6afa$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $4e707583c65f6afa$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $4e707583c65f6afa$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $4e707583c65f6afa$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $4e707583c65f6afa$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $4e707583c65f6afa$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $4e707583c65f6afa$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $4e707583c65f6afa$var$releaseCache(previousCache));
}
function $4e707583c65f6afa$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $4e707583c65f6afa$var$releaseCache(current));
}
function $4e707583c65f6afa$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$4e707583c65f6afa$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $4e707583c65f6afa$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $4e707583c65f6afa$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $4e707583c65f6afa$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $4e707583c65f6afa$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $4e707583c65f6afa$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $4e707583c65f6afa$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $4e707583c65f6afa$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $4e707583c65f6afa$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $4e707583c65f6afa$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $4e707583c65f6afa$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $4e707583c65f6afa$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $4e707583c65f6afa$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $4e707583c65f6afa$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $4e707583c65f6afa$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $4e707583c65f6afa$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $4e707583c65f6afa$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $4e707583c65f6afa$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $4e707583c65f6afa$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $4e707583c65f6afa$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $4e707583c65f6afa$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $4e707583c65f6afa$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $4e707583c65f6afa$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $4e707583c65f6afa$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $4e707583c65f6afa$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $4e707583c65f6afa$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $4e707583c65f6afa$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $4e707583c65f6afa$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $4e707583c65f6afa$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $4e707583c65f6afa$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $4e707583c65f6afa$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $4e707583c65f6afa$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $4e707583c65f6afa$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $4e707583c65f6afa$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $4e707583c65f6afa$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $4e707583c65f6afa$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $4e707583c65f6afa$var$suspenseyCommitFlag = 8192;
function $4e707583c65f6afa$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $4e707583c65f6afa$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$4e707583c65f6afa$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $4e707583c65f6afa$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $4e707583c65f6afa$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $4e707583c65f6afa$var$suspenseyCommitFlag && null !== fiber.memoizedState && $4e707583c65f6afa$var$suspendResource(suspendedState, $4e707583c65f6afa$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $4e707583c65f6afa$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $4e707583c65f6afa$var$currentHoistableRoot;
            $4e707583c65f6afa$var$currentHoistableRoot = $4e707583c65f6afa$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $4e707583c65f6afa$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $4e707583c65f6afa$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $4e707583c65f6afa$var$suspenseyCommitFlag, $4e707583c65f6afa$var$suspenseyCommitFlag = 16777216, $4e707583c65f6afa$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $4e707583c65f6afa$var$suspenseyCommitFlag = previousHoistableRoot) : $4e707583c65f6afa$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $4e707583c65f6afa$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $4e707583c65f6afa$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $4e707583c65f6afa$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $4e707583c65f6afa$var$nextEffect = childToDelete;
            $4e707583c65f6afa$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $4e707583c65f6afa$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$4e707583c65f6afa$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $4e707583c65f6afa$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $4e707583c65f6afa$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $4e707583c65f6afa$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $4e707583c65f6afa$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $4e707583c65f6afa$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $4e707583c65f6afa$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $4e707583c65f6afa$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $4e707583c65f6afa$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $4e707583c65f6afa$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $4e707583c65f6afa$var$nextEffect = childToDelete;
            $4e707583c65f6afa$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $4e707583c65f6afa$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $4e707583c65f6afa$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $4e707583c65f6afa$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $4e707583c65f6afa$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $4e707583c65f6afa$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $4e707583c65f6afa$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $4e707583c65f6afa$var$nextEffect;){
        var fiber = $4e707583c65f6afa$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $4e707583c65f6afa$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $4e707583c65f6afa$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $4e707583c65f6afa$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $4e707583c65f6afa$var$nextEffect;){
            cache = $4e707583c65f6afa$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $4e707583c65f6afa$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $4e707583c65f6afa$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $4e707583c65f6afa$var$nextEffect = sibling;
                break a;
            }
            $4e707583c65f6afa$var$nextEffect = returnFiber;
        }
    }
}
var $4e707583c65f6afa$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $4e707583c65f6afa$var$readContext($4e707583c65f6afa$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $4e707583c65f6afa$var$readContext($4e707583c65f6afa$var$CacheContext).controller.signal;
    }
}, $4e707583c65f6afa$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $4e707583c65f6afa$var$executionContext = 0, $4e707583c65f6afa$var$workInProgressRoot = null, $4e707583c65f6afa$var$workInProgress = null, $4e707583c65f6afa$var$workInProgressRootRenderLanes = 0, $4e707583c65f6afa$var$workInProgressSuspendedReason = 0, $4e707583c65f6afa$var$workInProgressThrownValue = null, $4e707583c65f6afa$var$workInProgressRootDidSkipSuspendedSiblings = !1, $4e707583c65f6afa$var$workInProgressRootIsPrerendering = !1, $4e707583c65f6afa$var$workInProgressRootDidAttachPingListener = !1, $4e707583c65f6afa$var$entangledRenderLanes = 0, $4e707583c65f6afa$var$workInProgressRootExitStatus = 0, $4e707583c65f6afa$var$workInProgressRootSkippedLanes = 0, $4e707583c65f6afa$var$workInProgressRootInterleavedUpdatedLanes = 0, $4e707583c65f6afa$var$workInProgressRootPingedLanes = 0, $4e707583c65f6afa$var$workInProgressDeferredLane = 0, $4e707583c65f6afa$var$workInProgressSuspendedRetryLanes = 0, $4e707583c65f6afa$var$workInProgressRootConcurrentErrors = null, $4e707583c65f6afa$var$workInProgressRootRecoverableErrors = null, $4e707583c65f6afa$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $4e707583c65f6afa$var$globalMostRecentFallbackTime = 0, $4e707583c65f6afa$var$globalMostRecentTransitionTime = 0, $4e707583c65f6afa$var$workInProgressRootRenderTargetTime = Infinity, $4e707583c65f6afa$var$workInProgressTransitions = null, $4e707583c65f6afa$var$legacyErrorBoundariesThatAlreadyFailed = null, $4e707583c65f6afa$var$pendingEffectsStatus = 0, $4e707583c65f6afa$var$pendingEffectsRoot = null, $4e707583c65f6afa$var$pendingFinishedWork = null, $4e707583c65f6afa$var$pendingEffectsLanes = 0, $4e707583c65f6afa$var$pendingEffectsRemainingLanes = 0, $4e707583c65f6afa$var$pendingPassiveTransitions = null, $4e707583c65f6afa$var$pendingRecoverableErrors = null, $4e707583c65f6afa$var$nestedUpdateCount = 0, $4e707583c65f6afa$var$rootWithNestedUpdates = null;
function $4e707583c65f6afa$var$requestUpdateLane() {
    return 0 !== ($4e707583c65f6afa$var$executionContext & 2) && 0 !== $4e707583c65f6afa$var$workInProgressRootRenderLanes ? $4e707583c65f6afa$var$workInProgressRootRenderLanes & -$4e707583c65f6afa$var$workInProgressRootRenderLanes : null !== $4e707583c65f6afa$var$ReactSharedInternals.T ? $4e707583c65f6afa$var$requestTransitionLane() : $4e707583c65f6afa$var$resolveUpdatePriority();
}
function $4e707583c65f6afa$var$requestDeferredLane() {
    if (0 === $4e707583c65f6afa$var$workInProgressDeferredLane) {
        if (0 === ($4e707583c65f6afa$var$workInProgressRootRenderLanes & 536870912) || $4e707583c65f6afa$var$isHydrating) {
            var lane = $4e707583c65f6afa$var$nextTransitionDeferredLane;
            $4e707583c65f6afa$var$nextTransitionDeferredLane <<= 1;
            0 === ($4e707583c65f6afa$var$nextTransitionDeferredLane & 3932160) && ($4e707583c65f6afa$var$nextTransitionDeferredLane = 262144);
            $4e707583c65f6afa$var$workInProgressDeferredLane = lane;
        } else $4e707583c65f6afa$var$workInProgressDeferredLane = 536870912;
    }
    lane = $4e707583c65f6afa$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $4e707583c65f6afa$var$workInProgressDeferredLane;
}
function $4e707583c65f6afa$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $4e707583c65f6afa$var$workInProgressRoot && (2 === $4e707583c65f6afa$var$workInProgressSuspendedReason || 9 === $4e707583c65f6afa$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $4e707583c65f6afa$var$prepareFreshStack(root, 0), $4e707583c65f6afa$var$markRootSuspended(root, $4e707583c65f6afa$var$workInProgressRootRenderLanes, $4e707583c65f6afa$var$workInProgressDeferredLane, !1);
    $4e707583c65f6afa$var$markRootUpdated$1(root, lane);
    if (0 === ($4e707583c65f6afa$var$executionContext & 2) || root !== $4e707583c65f6afa$var$workInProgressRoot) root === $4e707583c65f6afa$var$workInProgressRoot && (0 === ($4e707583c65f6afa$var$executionContext & 2) && ($4e707583c65f6afa$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $4e707583c65f6afa$var$workInProgressRootExitStatus && $4e707583c65f6afa$var$markRootSuspended(root, $4e707583c65f6afa$var$workInProgressRootRenderLanes, $4e707583c65f6afa$var$workInProgressDeferredLane, !1)), $4e707583c65f6afa$var$ensureRootIsScheduled(root);
}
function $4e707583c65f6afa$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($4e707583c65f6afa$var$executionContext & 6)) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $4e707583c65f6afa$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $4e707583c65f6afa$var$renderRootConcurrent(root$jscomp$0, lanes) : $4e707583c65f6afa$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $4e707583c65f6afa$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $4e707583c65f6afa$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$4e707583c65f6afa$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $4e707583c65f6afa$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $4e707583c65f6afa$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($4e707583c65f6afa$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $4e707583c65f6afa$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($4e707583c65f6afa$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $4e707583c65f6afa$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $4e707583c65f6afa$var$workInProgressRootRecoverableErrors;
                            $4e707583c65f6afa$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $4e707583c65f6afa$var$workInProgressRootRecoverableErrors ? $4e707583c65f6afa$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $4e707583c65f6afa$var$workInProgressRootRecoverableErrors.push.apply($4e707583c65f6afa$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $4e707583c65f6afa$var$prepareFreshStack(root$jscomp$0, 0);
                $4e707583c65f6afa$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($4e707583c65f6afa$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $4e707583c65f6afa$var$markRootSuspended(shouldTimeSlice, lanes, $4e707583c65f6afa$var$workInProgressDeferredLane, !$4e707583c65f6afa$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $4e707583c65f6afa$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($4e707583c65f6afa$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $4e707583c65f6afa$var$globalMostRecentFallbackTime + 300 - $4e707583c65f6afa$var$now(), 10 < exitStatus)) {
                    $4e707583c65f6afa$var$markRootSuspended(shouldTimeSlice, lanes, $4e707583c65f6afa$var$workInProgressDeferredLane, !$4e707583c65f6afa$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $4e707583c65f6afa$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $4e707583c65f6afa$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $4e707583c65f6afa$var$scheduleTimeout($4e707583c65f6afa$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $4e707583c65f6afa$var$workInProgressRootRecoverableErrors, $4e707583c65f6afa$var$workInProgressTransitions, $4e707583c65f6afa$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $4e707583c65f6afa$var$workInProgressDeferredLane, $4e707583c65f6afa$var$workInProgressRootInterleavedUpdatedLanes, $4e707583c65f6afa$var$workInProgressSuspendedRetryLanes, $4e707583c65f6afa$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $4e707583c65f6afa$var$commitRootWhenReady(shouldTimeSlice, forceSync, $4e707583c65f6afa$var$workInProgressRootRecoverableErrors, $4e707583c65f6afa$var$workInProgressTransitions, $4e707583c65f6afa$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $4e707583c65f6afa$var$workInProgressDeferredLane, $4e707583c65f6afa$var$workInProgressRootInterleavedUpdatedLanes, $4e707583c65f6afa$var$workInProgressSuspendedRetryLanes, $4e707583c65f6afa$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $4e707583c65f6afa$var$ensureRootIsScheduled(root$jscomp$0);
}
function $4e707583c65f6afa$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $4e707583c65f6afa$var$noop$1
        };
        $4e707583c65f6afa$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $4e707583c65f6afa$var$globalMostRecentFallbackTime - $4e707583c65f6afa$var$now() : (lanes & 4194048) === lanes ? $4e707583c65f6afa$var$globalMostRecentTransitionTime - $4e707583c65f6afa$var$now() : 0;
        timeoutOffset = $4e707583c65f6afa$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $4e707583c65f6afa$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($4e707583c65f6afa$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $4e707583c65f6afa$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $4e707583c65f6afa$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $4e707583c65f6afa$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$4e707583c65f6afa$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $4e707583c65f6afa$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$4e707583c65f6afa$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$4e707583c65f6afa$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $4e707583c65f6afa$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $4e707583c65f6afa$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $4e707583c65f6afa$var$flushSyncWork$1() {
    return 0 === ($4e707583c65f6afa$var$executionContext & 6) ? ($4e707583c65f6afa$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $4e707583c65f6afa$var$resetWorkInProgressStack() {
    if (null !== $4e707583c65f6afa$var$workInProgress) {
        if (0 === $4e707583c65f6afa$var$workInProgressSuspendedReason) var interruptedWork = $4e707583c65f6afa$var$workInProgress.return;
        else interruptedWork = $4e707583c65f6afa$var$workInProgress, $4e707583c65f6afa$var$lastContextDependency = $4e707583c65f6afa$var$currentlyRenderingFiber$1 = null, $4e707583c65f6afa$var$resetHooksOnUnwind(interruptedWork), $4e707583c65f6afa$var$thenableState$1 = null, $4e707583c65f6afa$var$thenableIndexCounter$1 = 0, interruptedWork = $4e707583c65f6afa$var$workInProgress;
        for(; null !== interruptedWork;)$4e707583c65f6afa$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $4e707583c65f6afa$var$workInProgress = null;
    }
}
function $4e707583c65f6afa$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $4e707583c65f6afa$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $4e707583c65f6afa$var$pendingEffectsLanes = 0;
    $4e707583c65f6afa$var$resetWorkInProgressStack();
    $4e707583c65f6afa$var$workInProgressRoot = root;
    $4e707583c65f6afa$var$workInProgress = timeoutHandle = $4e707583c65f6afa$var$createWorkInProgress(root.current, null);
    $4e707583c65f6afa$var$workInProgressRootRenderLanes = lanes;
    $4e707583c65f6afa$var$workInProgressSuspendedReason = 0;
    $4e707583c65f6afa$var$workInProgressThrownValue = null;
    $4e707583c65f6afa$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $4e707583c65f6afa$var$workInProgressRootIsPrerendering = $4e707583c65f6afa$var$checkIfRootIsPrerendering(root, lanes);
    $4e707583c65f6afa$var$workInProgressRootDidAttachPingListener = !1;
    $4e707583c65f6afa$var$workInProgressSuspendedRetryLanes = $4e707583c65f6afa$var$workInProgressDeferredLane = $4e707583c65f6afa$var$workInProgressRootPingedLanes = $4e707583c65f6afa$var$workInProgressRootInterleavedUpdatedLanes = $4e707583c65f6afa$var$workInProgressRootSkippedLanes = $4e707583c65f6afa$var$workInProgressRootExitStatus = 0;
    $4e707583c65f6afa$var$workInProgressRootRecoverableErrors = $4e707583c65f6afa$var$workInProgressRootConcurrentErrors = null;
    $4e707583c65f6afa$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $4e707583c65f6afa$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $4e707583c65f6afa$var$entangledRenderLanes = lanes;
    $4e707583c65f6afa$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $4e707583c65f6afa$var$handleThrow(root, thrownValue) {
    $4e707583c65f6afa$var$currentlyRenderingFiber = null;
    $4e707583c65f6afa$var$ReactSharedInternals.H = $4e707583c65f6afa$var$ContextOnlyDispatcher;
    thrownValue === $4e707583c65f6afa$var$SuspenseException || thrownValue === $4e707583c65f6afa$var$SuspenseActionException ? (thrownValue = $4e707583c65f6afa$var$getSuspendedThenable(), $4e707583c65f6afa$var$workInProgressSuspendedReason = 3) : thrownValue === $4e707583c65f6afa$var$SuspenseyCommitException ? (thrownValue = $4e707583c65f6afa$var$getSuspendedThenable(), $4e707583c65f6afa$var$workInProgressSuspendedReason = 4) : $4e707583c65f6afa$var$workInProgressSuspendedReason = thrownValue === $4e707583c65f6afa$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $4e707583c65f6afa$var$workInProgressThrownValue = thrownValue;
    null === $4e707583c65f6afa$var$workInProgress && ($4e707583c65f6afa$var$workInProgressRootExitStatus = 1, $4e707583c65f6afa$var$logUncaughtError(root, $4e707583c65f6afa$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $4e707583c65f6afa$var$shouldRemainOnPreviousScreen() {
    var handler = $4e707583c65f6afa$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($4e707583c65f6afa$var$workInProgressRootRenderLanes & 4194048) === $4e707583c65f6afa$var$workInProgressRootRenderLanes ? null === $4e707583c65f6afa$var$shellBoundary ? !0 : !1 : ($4e707583c65f6afa$var$workInProgressRootRenderLanes & 62914560) === $4e707583c65f6afa$var$workInProgressRootRenderLanes || 0 !== ($4e707583c65f6afa$var$workInProgressRootRenderLanes & 536870912) ? handler === $4e707583c65f6afa$var$shellBoundary : !1;
}
function $4e707583c65f6afa$var$pushDispatcher() {
    var prevDispatcher = $4e707583c65f6afa$var$ReactSharedInternals.H;
    $4e707583c65f6afa$var$ReactSharedInternals.H = $4e707583c65f6afa$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $4e707583c65f6afa$var$ContextOnlyDispatcher : prevDispatcher;
}
function $4e707583c65f6afa$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $4e707583c65f6afa$var$ReactSharedInternals.A;
    $4e707583c65f6afa$var$ReactSharedInternals.A = $4e707583c65f6afa$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $4e707583c65f6afa$var$renderDidSuspendDelayIfPossible() {
    $4e707583c65f6afa$var$workInProgressRootExitStatus = 4;
    $4e707583c65f6afa$var$workInProgressRootDidSkipSuspendedSiblings || ($4e707583c65f6afa$var$workInProgressRootRenderLanes & 4194048) !== $4e707583c65f6afa$var$workInProgressRootRenderLanes && null !== $4e707583c65f6afa$var$suspenseHandlerStackCursor.current || ($4e707583c65f6afa$var$workInProgressRootIsPrerendering = !0);
    0 === ($4e707583c65f6afa$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($4e707583c65f6afa$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $4e707583c65f6afa$var$workInProgressRoot || $4e707583c65f6afa$var$markRootSuspended($4e707583c65f6afa$var$workInProgressRoot, $4e707583c65f6afa$var$workInProgressRootRenderLanes, $4e707583c65f6afa$var$workInProgressDeferredLane, !1);
}
function $4e707583c65f6afa$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $4e707583c65f6afa$var$executionContext;
    $4e707583c65f6afa$var$executionContext |= 2;
    var prevDispatcher = $4e707583c65f6afa$var$pushDispatcher(), prevAsyncDispatcher = $4e707583c65f6afa$var$pushAsyncDispatcher();
    if ($4e707583c65f6afa$var$workInProgressRoot !== root || $4e707583c65f6afa$var$workInProgressRootRenderLanes !== lanes) $4e707583c65f6afa$var$workInProgressTransitions = null, $4e707583c65f6afa$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $4e707583c65f6afa$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $4e707583c65f6afa$var$workInProgressSuspendedReason && null !== $4e707583c65f6afa$var$workInProgress) {
            var unitOfWork = $4e707583c65f6afa$var$workInProgress, thrownValue = $4e707583c65f6afa$var$workInProgressThrownValue;
            switch($4e707583c65f6afa$var$workInProgressSuspendedReason){
                case 8:
                    $4e707583c65f6afa$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $4e707583c65f6afa$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $4e707583c65f6afa$var$workInProgressSuspendedReason;
                    $4e707583c65f6afa$var$workInProgressSuspendedReason = 0;
                    $4e707583c65f6afa$var$workInProgressThrownValue = null;
                    $4e707583c65f6afa$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $4e707583c65f6afa$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $4e707583c65f6afa$var$workInProgressSuspendedReason, $4e707583c65f6afa$var$workInProgressSuspendedReason = 0, $4e707583c65f6afa$var$workInProgressThrownValue = null, $4e707583c65f6afa$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $4e707583c65f6afa$var$workLoopSync();
        exitStatus = $4e707583c65f6afa$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $4e707583c65f6afa$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $4e707583c65f6afa$var$lastContextDependency = $4e707583c65f6afa$var$currentlyRenderingFiber$1 = null;
    $4e707583c65f6afa$var$executionContext = prevExecutionContext;
    $4e707583c65f6afa$var$ReactSharedInternals.H = prevDispatcher;
    $4e707583c65f6afa$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $4e707583c65f6afa$var$workInProgress && ($4e707583c65f6afa$var$workInProgressRoot = null, $4e707583c65f6afa$var$workInProgressRootRenderLanes = 0, $4e707583c65f6afa$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $4e707583c65f6afa$var$workLoopSync() {
    for(; null !== $4e707583c65f6afa$var$workInProgress;)$4e707583c65f6afa$var$performUnitOfWork($4e707583c65f6afa$var$workInProgress);
}
function $4e707583c65f6afa$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $4e707583c65f6afa$var$executionContext;
    $4e707583c65f6afa$var$executionContext |= 2;
    var prevDispatcher = $4e707583c65f6afa$var$pushDispatcher(), prevAsyncDispatcher = $4e707583c65f6afa$var$pushAsyncDispatcher();
    $4e707583c65f6afa$var$workInProgressRoot !== root || $4e707583c65f6afa$var$workInProgressRootRenderLanes !== lanes ? ($4e707583c65f6afa$var$workInProgressTransitions = null, $4e707583c65f6afa$var$workInProgressRootRenderTargetTime = $4e707583c65f6afa$var$now() + 500, $4e707583c65f6afa$var$prepareFreshStack(root, lanes)) : $4e707583c65f6afa$var$workInProgressRootIsPrerendering = $4e707583c65f6afa$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $4e707583c65f6afa$var$workInProgressSuspendedReason && null !== $4e707583c65f6afa$var$workInProgress) {
            lanes = $4e707583c65f6afa$var$workInProgress;
            var thrownValue = $4e707583c65f6afa$var$workInProgressThrownValue;
            b: switch($4e707583c65f6afa$var$workInProgressSuspendedReason){
                case 1:
                    $4e707583c65f6afa$var$workInProgressSuspendedReason = 0;
                    $4e707583c65f6afa$var$workInProgressThrownValue = null;
                    $4e707583c65f6afa$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($4e707583c65f6afa$var$isThenableResolved(thrownValue)) {
                        $4e707583c65f6afa$var$workInProgressSuspendedReason = 0;
                        $4e707583c65f6afa$var$workInProgressThrownValue = null;
                        $4e707583c65f6afa$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $4e707583c65f6afa$var$workInProgressSuspendedReason && 9 !== $4e707583c65f6afa$var$workInProgressSuspendedReason || $4e707583c65f6afa$var$workInProgressRoot !== root || ($4e707583c65f6afa$var$workInProgressSuspendedReason = 7);
                        $4e707583c65f6afa$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $4e707583c65f6afa$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $4e707583c65f6afa$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $4e707583c65f6afa$var$isThenableResolved(thrownValue) ? ($4e707583c65f6afa$var$workInProgressSuspendedReason = 0, $4e707583c65f6afa$var$workInProgressThrownValue = null, $4e707583c65f6afa$var$replaySuspendedUnitOfWork(lanes)) : ($4e707583c65f6afa$var$workInProgressSuspendedReason = 0, $4e707583c65f6afa$var$workInProgressThrownValue = null, $4e707583c65f6afa$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($4e707583c65f6afa$var$workInProgress.tag){
                        case 26:
                            resource = $4e707583c65f6afa$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $4e707583c65f6afa$var$workInProgress;
                            if (resource ? $4e707583c65f6afa$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $4e707583c65f6afa$var$workInProgressSuspendedReason = 0;
                                $4e707583c65f6afa$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $4e707583c65f6afa$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($4e707583c65f6afa$var$workInProgress = returnFiber, $4e707583c65f6afa$var$completeUnitOfWork(returnFiber)) : $4e707583c65f6afa$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $4e707583c65f6afa$var$workInProgressSuspendedReason = 0;
                    $4e707583c65f6afa$var$workInProgressThrownValue = null;
                    $4e707583c65f6afa$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $4e707583c65f6afa$var$workInProgressSuspendedReason = 0;
                    $4e707583c65f6afa$var$workInProgressThrownValue = null;
                    $4e707583c65f6afa$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $4e707583c65f6afa$var$resetWorkInProgressStack();
                    $4e707583c65f6afa$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($4e707583c65f6afa$var$formatProdErrorMessage(462));
            }
        }
        $4e707583c65f6afa$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $4e707583c65f6afa$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $4e707583c65f6afa$var$lastContextDependency = $4e707583c65f6afa$var$currentlyRenderingFiber$1 = null;
    $4e707583c65f6afa$var$ReactSharedInternals.H = prevDispatcher;
    $4e707583c65f6afa$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $4e707583c65f6afa$var$executionContext = prevExecutionContext;
    if (null !== $4e707583c65f6afa$var$workInProgress) return 0;
    $4e707583c65f6afa$var$workInProgressRoot = null;
    $4e707583c65f6afa$var$workInProgressRootRenderLanes = 0;
    $4e707583c65f6afa$var$finishQueueingConcurrentUpdates();
    return $4e707583c65f6afa$var$workInProgressRootExitStatus;
}
function $4e707583c65f6afa$var$workLoopConcurrentByScheduler() {
    for(; null !== $4e707583c65f6afa$var$workInProgress && !$4e707583c65f6afa$var$shouldYield();)$4e707583c65f6afa$var$performUnitOfWork($4e707583c65f6afa$var$workInProgress);
}
function $4e707583c65f6afa$var$performUnitOfWork(unitOfWork) {
    var next = $4e707583c65f6afa$var$beginWork(unitOfWork.alternate, unitOfWork, $4e707583c65f6afa$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $4e707583c65f6afa$var$completeUnitOfWork(unitOfWork) : $4e707583c65f6afa$var$workInProgress = next;
}
function $4e707583c65f6afa$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $4e707583c65f6afa$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $4e707583c65f6afa$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $4e707583c65f6afa$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $4e707583c65f6afa$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $4e707583c65f6afa$var$resetHooksOnUnwind(next);
        default:
            $4e707583c65f6afa$var$unwindInterruptedWork(current, next), next = $4e707583c65f6afa$var$workInProgress = $4e707583c65f6afa$var$resetWorkInProgress(next, $4e707583c65f6afa$var$entangledRenderLanes), next = $4e707583c65f6afa$var$beginWork(current, next, $4e707583c65f6afa$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $4e707583c65f6afa$var$completeUnitOfWork(unitOfWork) : $4e707583c65f6afa$var$workInProgress = next;
}
function $4e707583c65f6afa$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $4e707583c65f6afa$var$lastContextDependency = $4e707583c65f6afa$var$currentlyRenderingFiber$1 = null;
    $4e707583c65f6afa$var$resetHooksOnUnwind(unitOfWork);
    $4e707583c65f6afa$var$thenableState$1 = null;
    $4e707583c65f6afa$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($4e707583c65f6afa$var$throwException(root, returnFiber, unitOfWork, thrownValue, $4e707583c65f6afa$var$workInProgressRootRenderLanes)) {
            $4e707583c65f6afa$var$workInProgressRootExitStatus = 1;
            $4e707583c65f6afa$var$logUncaughtError(root, $4e707583c65f6afa$var$createCapturedValueAtFiber(thrownValue, root.current));
            $4e707583c65f6afa$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $4e707583c65f6afa$var$workInProgress = returnFiber, error;
        $4e707583c65f6afa$var$workInProgressRootExitStatus = 1;
        $4e707583c65f6afa$var$logUncaughtError(root, $4e707583c65f6afa$var$createCapturedValueAtFiber(thrownValue, root.current));
        $4e707583c65f6afa$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($4e707583c65f6afa$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($4e707583c65f6afa$var$workInProgressRootIsPrerendering || 0 !== ($4e707583c65f6afa$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($4e707583c65f6afa$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $4e707583c65f6afa$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $4e707583c65f6afa$var$unwindUnitOfWork(unitOfWork, root);
    } else $4e707583c65f6afa$var$completeUnitOfWork(unitOfWork);
}
function $4e707583c65f6afa$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $4e707583c65f6afa$var$unwindUnitOfWork(completedWork, $4e707583c65f6afa$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $4e707583c65f6afa$var$completeWork(completedWork.alternate, completedWork, $4e707583c65f6afa$var$entangledRenderLanes);
        if (null !== next) {
            $4e707583c65f6afa$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $4e707583c65f6afa$var$workInProgress = completedWork;
            return;
        }
        $4e707583c65f6afa$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $4e707583c65f6afa$var$workInProgressRootExitStatus && ($4e707583c65f6afa$var$workInProgressRootExitStatus = 5);
}
function $4e707583c65f6afa$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $4e707583c65f6afa$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $4e707583c65f6afa$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $4e707583c65f6afa$var$workInProgress = unitOfWork;
            return;
        }
        $4e707583c65f6afa$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $4e707583c65f6afa$var$workInProgressRootExitStatus = 6;
    $4e707583c65f6afa$var$workInProgress = null;
}
function $4e707583c65f6afa$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $4e707583c65f6afa$var$flushPendingEffects();
    while (0 !== $4e707583c65f6afa$var$pendingEffectsStatus);
    if (0 !== ($4e707583c65f6afa$var$executionContext & 6)) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $4e707583c65f6afa$var$concurrentlyUpdatedLanes;
        $4e707583c65f6afa$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $4e707583c65f6afa$var$workInProgressRoot && ($4e707583c65f6afa$var$workInProgress = $4e707583c65f6afa$var$workInProgressRoot = null, $4e707583c65f6afa$var$workInProgressRootRenderLanes = 0);
        $4e707583c65f6afa$var$pendingFinishedWork = finishedWork;
        $4e707583c65f6afa$var$pendingEffectsRoot = root;
        $4e707583c65f6afa$var$pendingEffectsLanes = lanes;
        $4e707583c65f6afa$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $4e707583c65f6afa$var$pendingPassiveTransitions = transitions;
        $4e707583c65f6afa$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $4e707583c65f6afa$var$scheduleCallback$1($4e707583c65f6afa$var$NormalPriority$1, function() {
            $4e707583c65f6afa$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $4e707583c65f6afa$var$ReactSharedInternals.T;
            $4e707583c65f6afa$var$ReactSharedInternals.T = null;
            transitions = $4e707583c65f6afa$var$ReactDOMSharedInternals.p;
            $4e707583c65f6afa$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $4e707583c65f6afa$var$executionContext;
            $4e707583c65f6afa$var$executionContext |= 4;
            try {
                $4e707583c65f6afa$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $4e707583c65f6afa$var$executionContext = spawnedLane, $4e707583c65f6afa$var$ReactDOMSharedInternals.p = transitions, $4e707583c65f6afa$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $4e707583c65f6afa$var$pendingEffectsStatus = 1;
        $4e707583c65f6afa$var$flushMutationEffects();
        $4e707583c65f6afa$var$flushLayoutEffects();
        $4e707583c65f6afa$var$flushSpawnedWork();
    }
}
function $4e707583c65f6afa$var$flushMutationEffects() {
    if (1 === $4e707583c65f6afa$var$pendingEffectsStatus) {
        $4e707583c65f6afa$var$pendingEffectsStatus = 0;
        var root = $4e707583c65f6afa$var$pendingEffectsRoot, finishedWork = $4e707583c65f6afa$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $4e707583c65f6afa$var$ReactSharedInternals.T;
            $4e707583c65f6afa$var$ReactSharedInternals.T = null;
            var previousPriority = $4e707583c65f6afa$var$ReactDOMSharedInternals.p;
            $4e707583c65f6afa$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $4e707583c65f6afa$var$executionContext;
            $4e707583c65f6afa$var$executionContext |= 4;
            try {
                $4e707583c65f6afa$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $4e707583c65f6afa$var$selectionInformation, curFocusedElem = $4e707583c65f6afa$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $4e707583c65f6afa$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $4e707583c65f6afa$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $4e707583c65f6afa$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $4e707583c65f6afa$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $4e707583c65f6afa$var$_enabled = !!$4e707583c65f6afa$var$eventsEnabled;
                $4e707583c65f6afa$var$selectionInformation = $4e707583c65f6afa$var$eventsEnabled = null;
            } finally{
                $4e707583c65f6afa$var$executionContext = prevExecutionContext, $4e707583c65f6afa$var$ReactDOMSharedInternals.p = previousPriority, $4e707583c65f6afa$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $4e707583c65f6afa$var$pendingEffectsStatus = 2;
    }
}
function $4e707583c65f6afa$var$flushLayoutEffects() {
    if (2 === $4e707583c65f6afa$var$pendingEffectsStatus) {
        $4e707583c65f6afa$var$pendingEffectsStatus = 0;
        var root = $4e707583c65f6afa$var$pendingEffectsRoot, finishedWork = $4e707583c65f6afa$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $4e707583c65f6afa$var$ReactSharedInternals.T;
            $4e707583c65f6afa$var$ReactSharedInternals.T = null;
            var previousPriority = $4e707583c65f6afa$var$ReactDOMSharedInternals.p;
            $4e707583c65f6afa$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $4e707583c65f6afa$var$executionContext;
            $4e707583c65f6afa$var$executionContext |= 4;
            try {
                $4e707583c65f6afa$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $4e707583c65f6afa$var$executionContext = prevExecutionContext, $4e707583c65f6afa$var$ReactDOMSharedInternals.p = previousPriority, $4e707583c65f6afa$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $4e707583c65f6afa$var$pendingEffectsStatus = 3;
    }
}
function $4e707583c65f6afa$var$flushSpawnedWork() {
    if (4 === $4e707583c65f6afa$var$pendingEffectsStatus || 3 === $4e707583c65f6afa$var$pendingEffectsStatus) {
        $4e707583c65f6afa$var$pendingEffectsStatus = 0;
        $4e707583c65f6afa$var$requestPaint();
        var root = $4e707583c65f6afa$var$pendingEffectsRoot, finishedWork = $4e707583c65f6afa$var$pendingFinishedWork, lanes = $4e707583c65f6afa$var$pendingEffectsLanes, recoverableErrors = $4e707583c65f6afa$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $4e707583c65f6afa$var$pendingEffectsStatus = 5 : ($4e707583c65f6afa$var$pendingEffectsStatus = 0, $4e707583c65f6afa$var$pendingFinishedWork = $4e707583c65f6afa$var$pendingEffectsRoot = null, $4e707583c65f6afa$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($4e707583c65f6afa$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $4e707583c65f6afa$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($4e707583c65f6afa$var$injectedHook && "function" === typeof $4e707583c65f6afa$var$injectedHook.onCommitFiberRoot) try {
            $4e707583c65f6afa$var$injectedHook.onCommitFiberRoot($4e707583c65f6afa$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $4e707583c65f6afa$var$ReactSharedInternals.T;
            remainingLanes = $4e707583c65f6afa$var$ReactDOMSharedInternals.p;
            $4e707583c65f6afa$var$ReactDOMSharedInternals.p = 2;
            $4e707583c65f6afa$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $4e707583c65f6afa$var$ReactSharedInternals.T = finishedWork, $4e707583c65f6afa$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($4e707583c65f6afa$var$pendingEffectsLanes & 3) && $4e707583c65f6afa$var$flushPendingEffects();
        $4e707583c65f6afa$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $4e707583c65f6afa$var$rootWithNestedUpdates ? $4e707583c65f6afa$var$nestedUpdateCount++ : ($4e707583c65f6afa$var$nestedUpdateCount = 0, $4e707583c65f6afa$var$rootWithNestedUpdates = root) : $4e707583c65f6afa$var$nestedUpdateCount = 0;
        $4e707583c65f6afa$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $4e707583c65f6afa$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $4e707583c65f6afa$var$releaseCache(remainingLanes)));
}
function $4e707583c65f6afa$var$flushPendingEffects() {
    $4e707583c65f6afa$var$flushMutationEffects();
    $4e707583c65f6afa$var$flushLayoutEffects();
    $4e707583c65f6afa$var$flushSpawnedWork();
    return $4e707583c65f6afa$var$flushPassiveEffects();
}
function $4e707583c65f6afa$var$flushPassiveEffects() {
    if (5 !== $4e707583c65f6afa$var$pendingEffectsStatus) return !1;
    var root = $4e707583c65f6afa$var$pendingEffectsRoot, remainingLanes = $4e707583c65f6afa$var$pendingEffectsRemainingLanes;
    $4e707583c65f6afa$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $4e707583c65f6afa$var$lanesToEventPriority($4e707583c65f6afa$var$pendingEffectsLanes), prevTransition = $4e707583c65f6afa$var$ReactSharedInternals.T, previousPriority = $4e707583c65f6afa$var$ReactDOMSharedInternals.p;
    try {
        $4e707583c65f6afa$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $4e707583c65f6afa$var$ReactSharedInternals.T = null;
        renderPriority = $4e707583c65f6afa$var$pendingPassiveTransitions;
        $4e707583c65f6afa$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $4e707583c65f6afa$var$pendingEffectsRoot, lanes = $4e707583c65f6afa$var$pendingEffectsLanes;
        $4e707583c65f6afa$var$pendingEffectsStatus = 0;
        $4e707583c65f6afa$var$pendingFinishedWork = $4e707583c65f6afa$var$pendingEffectsRoot = null;
        $4e707583c65f6afa$var$pendingEffectsLanes = 0;
        if (0 !== ($4e707583c65f6afa$var$executionContext & 6)) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(331));
        var prevExecutionContext = $4e707583c65f6afa$var$executionContext;
        $4e707583c65f6afa$var$executionContext |= 4;
        $4e707583c65f6afa$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $4e707583c65f6afa$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $4e707583c65f6afa$var$executionContext = prevExecutionContext;
        $4e707583c65f6afa$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($4e707583c65f6afa$var$injectedHook && "function" === typeof $4e707583c65f6afa$var$injectedHook.onPostCommitFiberRoot) try {
            $4e707583c65f6afa$var$injectedHook.onPostCommitFiberRoot($4e707583c65f6afa$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $4e707583c65f6afa$var$ReactDOMSharedInternals.p = previousPriority, $4e707583c65f6afa$var$ReactSharedInternals.T = prevTransition, $4e707583c65f6afa$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $4e707583c65f6afa$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $4e707583c65f6afa$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $4e707583c65f6afa$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $4e707583c65f6afa$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($4e707583c65f6afa$var$markRootUpdated$1(rootFiber, 2), $4e707583c65f6afa$var$ensureRootIsScheduled(rootFiber));
}
function $4e707583c65f6afa$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $4e707583c65f6afa$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $4e707583c65f6afa$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $4e707583c65f6afa$var$legacyErrorBoundariesThatAlreadyFailed || !$4e707583c65f6afa$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $4e707583c65f6afa$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $4e707583c65f6afa$var$createClassErrorUpdate(2);
                instance = $4e707583c65f6afa$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($4e707583c65f6afa$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $4e707583c65f6afa$var$markRootUpdated$1(instance, 2), $4e707583c65f6afa$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $4e707583c65f6afa$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $4e707583c65f6afa$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($4e707583c65f6afa$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $4e707583c65f6afa$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $4e707583c65f6afa$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $4e707583c65f6afa$var$workInProgressRoot === root && ($4e707583c65f6afa$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $4e707583c65f6afa$var$workInProgressRootExitStatus || 3 === $4e707583c65f6afa$var$workInProgressRootExitStatus && ($4e707583c65f6afa$var$workInProgressRootRenderLanes & 62914560) === $4e707583c65f6afa$var$workInProgressRootRenderLanes && 300 > $4e707583c65f6afa$var$now() - $4e707583c65f6afa$var$globalMostRecentFallbackTime ? 0 === ($4e707583c65f6afa$var$executionContext & 2) && $4e707583c65f6afa$var$prepareFreshStack(root, 0) : $4e707583c65f6afa$var$workInProgressRootPingedLanes |= pingedLanes, $4e707583c65f6afa$var$workInProgressSuspendedRetryLanes === $4e707583c65f6afa$var$workInProgressRootRenderLanes && ($4e707583c65f6afa$var$workInProgressSuspendedRetryLanes = 0));
    $4e707583c65f6afa$var$ensureRootIsScheduled(root);
}
function $4e707583c65f6afa$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $4e707583c65f6afa$var$claimNextRetryLane());
    boundaryFiber = $4e707583c65f6afa$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($4e707583c65f6afa$var$markRootUpdated$1(boundaryFiber, retryLane), $4e707583c65f6afa$var$ensureRootIsScheduled(boundaryFiber));
}
function $4e707583c65f6afa$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $4e707583c65f6afa$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $4e707583c65f6afa$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($4e707583c65f6afa$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $4e707583c65f6afa$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $4e707583c65f6afa$var$scheduleCallback$1(priorityLevel, callback) {
    return $4e707583c65f6afa$var$scheduleCallback$3(priorityLevel, callback);
}
var $4e707583c65f6afa$var$firstScheduledRoot = null, $4e707583c65f6afa$var$lastScheduledRoot = null, $4e707583c65f6afa$var$didScheduleMicrotask = !1, $4e707583c65f6afa$var$mightHavePendingSyncWork = !1, $4e707583c65f6afa$var$isFlushingWork = !1, $4e707583c65f6afa$var$currentEventTransitionLane = 0;
function $4e707583c65f6afa$var$ensureRootIsScheduled(root) {
    root !== $4e707583c65f6afa$var$lastScheduledRoot && null === root.next && (null === $4e707583c65f6afa$var$lastScheduledRoot ? $4e707583c65f6afa$var$firstScheduledRoot = $4e707583c65f6afa$var$lastScheduledRoot = root : $4e707583c65f6afa$var$lastScheduledRoot = $4e707583c65f6afa$var$lastScheduledRoot.next = root);
    $4e707583c65f6afa$var$mightHavePendingSyncWork = !0;
    $4e707583c65f6afa$var$didScheduleMicrotask || ($4e707583c65f6afa$var$didScheduleMicrotask = !0, $4e707583c65f6afa$var$scheduleImmediateRootScheduleTask());
}
function $4e707583c65f6afa$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$4e707583c65f6afa$var$isFlushingWork && $4e707583c65f6afa$var$mightHavePendingSyncWork) {
        $4e707583c65f6afa$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $4e707583c65f6afa$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $4e707583c65f6afa$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $4e707583c65f6afa$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $4e707583c65f6afa$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $4e707583c65f6afa$var$getNextLanes(root$170, root$170 === $4e707583c65f6afa$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $4e707583c65f6afa$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $4e707583c65f6afa$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $4e707583c65f6afa$var$isFlushingWork = !1;
    }
}
function $4e707583c65f6afa$var$processRootScheduleInImmediateTask() {
    $4e707583c65f6afa$var$processRootScheduleInMicrotask();
}
function $4e707583c65f6afa$var$processRootScheduleInMicrotask() {
    $4e707583c65f6afa$var$mightHavePendingSyncWork = $4e707583c65f6afa$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $4e707583c65f6afa$var$currentEventTransitionLane && $4e707583c65f6afa$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $4e707583c65f6afa$var$currentEventTransitionLane);
    for(var currentTime = $4e707583c65f6afa$var$now(), prev = null, root = $4e707583c65f6afa$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $4e707583c65f6afa$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $4e707583c65f6afa$var$firstScheduledRoot = next : prev.next = next, null === next && ($4e707583c65f6afa$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $4e707583c65f6afa$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $4e707583c65f6afa$var$pendingEffectsStatus && 5 !== $4e707583c65f6afa$var$pendingEffectsStatus || $4e707583c65f6afa$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $4e707583c65f6afa$var$currentEventTransitionLane && ($4e707583c65f6afa$var$currentEventTransitionLane = 0);
}
function $4e707583c65f6afa$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $4e707583c65f6afa$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $4e707583c65f6afa$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $4e707583c65f6afa$var$workInProgressRoot;
    suspendedLanes = $4e707583c65f6afa$var$workInProgressRootRenderLanes;
    suspendedLanes = $4e707583c65f6afa$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $4e707583c65f6afa$var$workInProgressSuspendedReason || 9 === $4e707583c65f6afa$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $4e707583c65f6afa$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $4e707583c65f6afa$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $4e707583c65f6afa$var$cancelCallback$1(pingedLanes);
        switch($4e707583c65f6afa$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $4e707583c65f6afa$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $4e707583c65f6afa$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $4e707583c65f6afa$var$IdlePriority;
                break;
            default:
                suspendedLanes = $4e707583c65f6afa$var$NormalPriority$1;
        }
        pingedLanes = $4e707583c65f6afa$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $4e707583c65f6afa$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $4e707583c65f6afa$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $4e707583c65f6afa$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $4e707583c65f6afa$var$pendingEffectsStatus && 5 !== $4e707583c65f6afa$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($4e707583c65f6afa$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $4e707583c65f6afa$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $4e707583c65f6afa$var$getNextLanes(root, root === $4e707583c65f6afa$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $4e707583c65f6afa$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $4e707583c65f6afa$var$scheduleTaskForRootDuringMicrotask(root, $4e707583c65f6afa$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $4e707583c65f6afa$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $4e707583c65f6afa$var$performSyncWorkOnRoot(root, lanes) {
    if ($4e707583c65f6afa$var$flushPendingEffects()) return null;
    $4e707583c65f6afa$var$performWorkOnRoot(root, lanes, !0);
}
function $4e707583c65f6afa$var$scheduleImmediateRootScheduleTask() {
    $4e707583c65f6afa$var$scheduleMicrotask(function() {
        0 !== ($4e707583c65f6afa$var$executionContext & 6) ? $4e707583c65f6afa$var$scheduleCallback$3($4e707583c65f6afa$var$ImmediatePriority, $4e707583c65f6afa$var$processRootScheduleInImmediateTask) : $4e707583c65f6afa$var$processRootScheduleInMicrotask();
    });
}
function $4e707583c65f6afa$var$requestTransitionLane() {
    if (0 === $4e707583c65f6afa$var$currentEventTransitionLane) {
        var actionScopeLane = $4e707583c65f6afa$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $4e707583c65f6afa$var$nextTransitionUpdateLane, $4e707583c65f6afa$var$nextTransitionUpdateLane <<= 1, 0 === ($4e707583c65f6afa$var$nextTransitionUpdateLane & 261888) && ($4e707583c65f6afa$var$nextTransitionUpdateLane = 256));
        $4e707583c65f6afa$var$currentEventTransitionLane = actionScopeLane;
    }
    return $4e707583c65f6afa$var$currentEventTransitionLane;
}
function $4e707583c65f6afa$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $4e707583c65f6afa$var$sanitizeURL("" + actionProp);
}
function $4e707583c65f6afa$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $4e707583c65f6afa$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $4e707583c65f6afa$var$coerceFormActionProp((nativeEventTarget[$4e707583c65f6afa$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$4e707583c65f6afa$var$internalPropsKey] || null) ? $4e707583c65f6afa$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $4e707583c65f6afa$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $4e707583c65f6afa$var$currentEventTransitionLane) {
                                var formData = submitter ? $4e707583c65f6afa$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $4e707583c65f6afa$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $4e707583c65f6afa$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $4e707583c65f6afa$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $4e707583c65f6afa$var$i$jscomp$inline_1577 = 0; $4e707583c65f6afa$var$i$jscomp$inline_1577 < $4e707583c65f6afa$var$simpleEventPluginEvents.length; $4e707583c65f6afa$var$i$jscomp$inline_1577++){
    var $4e707583c65f6afa$var$eventName$jscomp$inline_1578 = $4e707583c65f6afa$var$simpleEventPluginEvents[$4e707583c65f6afa$var$i$jscomp$inline_1577], $4e707583c65f6afa$var$domEventName$jscomp$inline_1579 = $4e707583c65f6afa$var$eventName$jscomp$inline_1578.toLowerCase(), $4e707583c65f6afa$var$capitalizedEvent$jscomp$inline_1580 = $4e707583c65f6afa$var$eventName$jscomp$inline_1578[0].toUpperCase() + $4e707583c65f6afa$var$eventName$jscomp$inline_1578.slice(1);
    $4e707583c65f6afa$var$registerSimpleEvent($4e707583c65f6afa$var$domEventName$jscomp$inline_1579, "on" + $4e707583c65f6afa$var$capitalizedEvent$jscomp$inline_1580);
}
$4e707583c65f6afa$var$registerSimpleEvent($4e707583c65f6afa$var$ANIMATION_END, "onAnimationEnd");
$4e707583c65f6afa$var$registerSimpleEvent($4e707583c65f6afa$var$ANIMATION_ITERATION, "onAnimationIteration");
$4e707583c65f6afa$var$registerSimpleEvent($4e707583c65f6afa$var$ANIMATION_START, "onAnimationStart");
$4e707583c65f6afa$var$registerSimpleEvent("dblclick", "onDoubleClick");
$4e707583c65f6afa$var$registerSimpleEvent("focusin", "onFocus");
$4e707583c65f6afa$var$registerSimpleEvent("focusout", "onBlur");
$4e707583c65f6afa$var$registerSimpleEvent($4e707583c65f6afa$var$TRANSITION_RUN, "onTransitionRun");
$4e707583c65f6afa$var$registerSimpleEvent($4e707583c65f6afa$var$TRANSITION_START, "onTransitionStart");
$4e707583c65f6afa$var$registerSimpleEvent($4e707583c65f6afa$var$TRANSITION_CANCEL, "onTransitionCancel");
$4e707583c65f6afa$var$registerSimpleEvent($4e707583c65f6afa$var$TRANSITION_END, "onTransitionEnd");
$4e707583c65f6afa$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4e707583c65f6afa$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4e707583c65f6afa$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4e707583c65f6afa$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4e707583c65f6afa$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4e707583c65f6afa$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4e707583c65f6afa$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4e707583c65f6afa$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4e707583c65f6afa$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4e707583c65f6afa$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4e707583c65f6afa$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4e707583c65f6afa$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($4e707583c65f6afa$var$mediaEventTypes));
function $4e707583c65f6afa$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $4e707583c65f6afa$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $4e707583c65f6afa$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $4e707583c65f6afa$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$4e707583c65f6afa$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$4e707583c65f6afa$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($4e707583c65f6afa$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $4e707583c65f6afa$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $4e707583c65f6afa$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $4e707583c65f6afa$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $4e707583c65f6afa$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$4e707583c65f6afa$var$listeningMarker]) {
        rootContainerElement[$4e707583c65f6afa$var$listeningMarker] = !0;
        $4e707583c65f6afa$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($4e707583c65f6afa$var$nonDelegatedEvents.has(domEventName) || $4e707583c65f6afa$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $4e707583c65f6afa$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$4e707583c65f6afa$var$listeningMarker] || (ownerDocument[$4e707583c65f6afa$var$listeningMarker] = !0, $4e707583c65f6afa$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $4e707583c65f6afa$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($4e707583c65f6afa$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $4e707583c65f6afa$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $4e707583c65f6afa$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $4e707583c65f6afa$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$4e707583c65f6afa$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $4e707583c65f6afa$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $4e707583c65f6afa$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $4e707583c65f6afa$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $4e707583c65f6afa$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $4e707583c65f6afa$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $4e707583c65f6afa$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $4e707583c65f6afa$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $4e707583c65f6afa$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $4e707583c65f6afa$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $4e707583c65f6afa$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $4e707583c65f6afa$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $4e707583c65f6afa$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $4e707583c65f6afa$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $4e707583c65f6afa$var$SyntheticTouchEvent;
                        break;
                    case $4e707583c65f6afa$var$ANIMATION_END:
                    case $4e707583c65f6afa$var$ANIMATION_ITERATION:
                    case $4e707583c65f6afa$var$ANIMATION_START:
                        SyntheticEventCtor = $4e707583c65f6afa$var$SyntheticAnimationEvent;
                        break;
                    case $4e707583c65f6afa$var$TRANSITION_END:
                        SyntheticEventCtor = $4e707583c65f6afa$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $4e707583c65f6afa$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $4e707583c65f6afa$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $4e707583c65f6afa$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $4e707583c65f6afa$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $4e707583c65f6afa$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $4e707583c65f6afa$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($4e707583c65f6afa$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $4e707583c65f6afa$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($4e707583c65f6afa$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$4e707583c65f6afa$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $4e707583c65f6afa$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $4e707583c65f6afa$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $4e707583c65f6afa$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $4e707583c65f6afa$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $4e707583c65f6afa$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $4e707583c65f6afa$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $4e707583c65f6afa$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $4e707583c65f6afa$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $4e707583c65f6afa$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $4e707583c65f6afa$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $4e707583c65f6afa$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $4e707583c65f6afa$var$getTargetInstForChangeEvent;
                else if ($4e707583c65f6afa$var$isTextInputElement(reactName)) {
                    if ($4e707583c65f6afa$var$isInputEventSupported) getTargetInstFunc = $4e707583c65f6afa$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $4e707583c65f6afa$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $4e707583c65f6afa$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $4e707583c65f6afa$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $4e707583c65f6afa$var$getTargetInstForChangeEvent) : getTargetInstFunc = $4e707583c65f6afa$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $4e707583c65f6afa$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $4e707583c65f6afa$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $4e707583c65f6afa$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($4e707583c65f6afa$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $4e707583c65f6afa$var$activeElement = handleEventFunc, $4e707583c65f6afa$var$activeElementInst = targetInst, $4e707583c65f6afa$var$lastSelection = null;
                    break;
                case "focusout":
                    $4e707583c65f6afa$var$lastSelection = $4e707583c65f6afa$var$activeElementInst = $4e707583c65f6afa$var$activeElement = null;
                    break;
                case "mousedown":
                    $4e707583c65f6afa$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4e707583c65f6afa$var$mouseDown = !1;
                    $4e707583c65f6afa$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($4e707583c65f6afa$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $4e707583c65f6afa$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($4e707583c65f6afa$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $4e707583c65f6afa$var$isComposing ? $4e707583c65f6afa$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($4e707583c65f6afa$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($4e707583c65f6afa$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $4e707583c65f6afa$var$isComposing && (fallbackData = $4e707583c65f6afa$var$getData()) : ($4e707583c65f6afa$var$root = nativeEventTarget, $4e707583c65f6afa$var$startText = "value" in $4e707583c65f6afa$var$root ? $4e707583c65f6afa$var$root.value : $4e707583c65f6afa$var$root.textContent, $4e707583c65f6afa$var$isComposing = !0)), handleEventFunc = $4e707583c65f6afa$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $4e707583c65f6afa$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $4e707583c65f6afa$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $4e707583c65f6afa$var$canUseTextInputEvent ? $4e707583c65f6afa$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $4e707583c65f6afa$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $4e707583c65f6afa$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $4e707583c65f6afa$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $4e707583c65f6afa$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $4e707583c65f6afa$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $4e707583c65f6afa$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $4e707583c65f6afa$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $4e707583c65f6afa$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($4e707583c65f6afa$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $4e707583c65f6afa$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($4e707583c65f6afa$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $4e707583c65f6afa$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $4e707583c65f6afa$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $4e707583c65f6afa$var$getListener(target, registrationName), null != stateNode && listeners.unshift($4e707583c65f6afa$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $4e707583c65f6afa$var$getListener(target, registrationName), null != stateNode && listeners.push($4e707583c65f6afa$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $4e707583c65f6afa$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $4e707583c65f6afa$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $4e707583c65f6afa$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($4e707583c65f6afa$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($4e707583c65f6afa$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $4e707583c65f6afa$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $4e707583c65f6afa$var$normalizeMarkupForTextOrAttribute(clientText);
    return $4e707583c65f6afa$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $4e707583c65f6afa$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $4e707583c65f6afa$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $4e707583c65f6afa$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $4e707583c65f6afa$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $4e707583c65f6afa$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $4e707583c65f6afa$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $4e707583c65f6afa$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $4e707583c65f6afa$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $4e707583c65f6afa$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $4e707583c65f6afa$var$setProp(domElement, tag, "name", props.name, props, null), $4e707583c65f6afa$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $4e707583c65f6afa$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $4e707583c65f6afa$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($4e707583c65f6afa$var$setProp(domElement, tag, "encType", props.encType, props, null), $4e707583c65f6afa$var$setProp(domElement, tag, "method", props.method, props, null), $4e707583c65f6afa$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $4e707583c65f6afa$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $4e707583c65f6afa$var$noop$1);
            break;
        case "onScroll":
            null != value && $4e707583c65f6afa$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $4e707583c65f6afa$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $4e707583c65f6afa$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("toggle", domElement);
            $4e707583c65f6afa$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $4e707583c65f6afa$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $4e707583c65f6afa$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $4e707583c65f6afa$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $4e707583c65f6afa$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $4e707583c65f6afa$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $4e707583c65f6afa$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $4e707583c65f6afa$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $4e707583c65f6afa$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $4e707583c65f6afa$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $4e707583c65f6afa$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $4e707583c65f6afa$var$aliases.get(key) || key, $4e707583c65f6afa$var$setValueForAttribute(domElement, key, value);
    }
}
function $4e707583c65f6afa$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $4e707583c65f6afa$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $4e707583c65f6afa$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $4e707583c65f6afa$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $4e707583c65f6afa$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $4e707583c65f6afa$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $4e707583c65f6afa$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$4e707583c65f6afa$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$4e707583c65f6afa$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $4e707583c65f6afa$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $4e707583c65f6afa$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("error", domElement);
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($4e707583c65f6afa$var$formatProdErrorMessage(137, tag));
                    default:
                        $4e707583c65f6afa$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $4e707583c65f6afa$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $4e707583c65f6afa$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $4e707583c65f6afa$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $4e707583c65f6afa$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $4e707583c65f6afa$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $4e707583c65f6afa$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $4e707583c65f6afa$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(91));
                    break;
                default:
                    $4e707583c65f6afa$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $4e707583c65f6afa$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $4e707583c65f6afa$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("toggle", domElement);
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("cancel", domElement);
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $4e707583c65f6afa$var$mediaEventTypes.length; hasSrc++)$4e707583c65f6afa$var$listenToNonDelegatedEvent($4e707583c65f6afa$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("error", domElement);
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $4e707583c65f6afa$var$listenToNonDelegatedEvent("error", domElement), $4e707583c65f6afa$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($4e707583c65f6afa$var$formatProdErrorMessage(137, tag));
                default:
                    $4e707583c65f6afa$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($4e707583c65f6afa$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $4e707583c65f6afa$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $4e707583c65f6afa$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $4e707583c65f6afa$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $4e707583c65f6afa$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $4e707583c65f6afa$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $4e707583c65f6afa$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $4e707583c65f6afa$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $4e707583c65f6afa$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $4e707583c65f6afa$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $4e707583c65f6afa$var$updateOptions(domElement, !!lastProps, tag, !0) : $4e707583c65f6afa$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $4e707583c65f6afa$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $4e707583c65f6afa$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $4e707583c65f6afa$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $4e707583c65f6afa$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $4e707583c65f6afa$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $4e707583c65f6afa$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $4e707583c65f6afa$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($4e707583c65f6afa$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $4e707583c65f6afa$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $4e707583c65f6afa$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $4e707583c65f6afa$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $4e707583c65f6afa$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $4e707583c65f6afa$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $4e707583c65f6afa$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $4e707583c65f6afa$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $4e707583c65f6afa$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $4e707583c65f6afa$var$eventsEnabled = null, $4e707583c65f6afa$var$selectionInformation = null;
function $4e707583c65f6afa$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $4e707583c65f6afa$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $4e707583c65f6afa$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $4e707583c65f6afa$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $4e707583c65f6afa$var$currentPopstateTransitionEvent = null;
function $4e707583c65f6afa$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $4e707583c65f6afa$var$currentPopstateTransitionEvent) return !1;
        $4e707583c65f6afa$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $4e707583c65f6afa$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $4e707583c65f6afa$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $4e707583c65f6afa$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $4e707583c65f6afa$var$localPromise = "function" === typeof Promise ? Promise : void 0, $4e707583c65f6afa$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4e707583c65f6afa$var$localPromise ? function(callback) {
    return $4e707583c65f6afa$var$localPromise.resolve(null).then(callback).catch($4e707583c65f6afa$var$handleErrorInNextTick);
} : $4e707583c65f6afa$var$scheduleTimeout;
function $4e707583c65f6afa$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $4e707583c65f6afa$var$isSingletonScope(type) {
    return "head" === type;
}
function $4e707583c65f6afa$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $4e707583c65f6afa$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $4e707583c65f6afa$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $4e707583c65f6afa$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$4e707583c65f6afa$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $4e707583c65f6afa$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $4e707583c65f6afa$var$retryIfBlockedOn(hydrationInstance);
}
function $4e707583c65f6afa$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $4e707583c65f6afa$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $4e707583c65f6afa$var$clearContainerSparingly(node);
                $4e707583c65f6afa$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $4e707583c65f6afa$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$4e707583c65f6afa$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $4e707583c65f6afa$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $4e707583c65f6afa$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $4e707583c65f6afa$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $4e707583c65f6afa$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $4e707583c65f6afa$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $4e707583c65f6afa$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $4e707583c65f6afa$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $4e707583c65f6afa$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $4e707583c65f6afa$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $4e707583c65f6afa$var$previousHydratableOnEnteringScopedSingleton = null;
function $4e707583c65f6afa$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $4e707583c65f6afa$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $4e707583c65f6afa$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $4e707583c65f6afa$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $4e707583c65f6afa$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($4e707583c65f6afa$var$formatProdErrorMessage(451));
    }
}
function $4e707583c65f6afa$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $4e707583c65f6afa$var$detachDeletedInstance(instance);
}
var $4e707583c65f6afa$var$preloadPropsMap = new Map(), $4e707583c65f6afa$var$preconnectsSet = new Set();
function $4e707583c65f6afa$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $4e707583c65f6afa$var$previousDispatcher = $4e707583c65f6afa$var$ReactDOMSharedInternals.d;
$4e707583c65f6afa$var$ReactDOMSharedInternals.d = {
    f: $4e707583c65f6afa$var$flushSyncWork,
    r: $4e707583c65f6afa$var$requestFormReset,
    D: $4e707583c65f6afa$var$prefetchDNS,
    C: $4e707583c65f6afa$var$preconnect,
    L: $4e707583c65f6afa$var$preload,
    m: $4e707583c65f6afa$var$preloadModule,
    X: $4e707583c65f6afa$var$preinitScript,
    S: $4e707583c65f6afa$var$preinitStyle,
    M: $4e707583c65f6afa$var$preinitModuleScript
};
function $4e707583c65f6afa$var$flushSyncWork() {
    var previousWasRendering = $4e707583c65f6afa$var$previousDispatcher.f(), wasRendering = $4e707583c65f6afa$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $4e707583c65f6afa$var$requestFormReset(form) {
    var formInst = $4e707583c65f6afa$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $4e707583c65f6afa$var$requestFormReset$1(formInst) : $4e707583c65f6afa$var$previousDispatcher.r(form);
}
var $4e707583c65f6afa$var$globalDocument = "undefined" === typeof document ? null : document;
function $4e707583c65f6afa$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $4e707583c65f6afa$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $4e707583c65f6afa$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $4e707583c65f6afa$var$preconnectsSet.has(limitedEscapedHref) || ($4e707583c65f6afa$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $4e707583c65f6afa$var$setInitialProperties(href, "link", rel), $4e707583c65f6afa$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $4e707583c65f6afa$var$prefetchDNS(href) {
    $4e707583c65f6afa$var$previousDispatcher.D(href);
    $4e707583c65f6afa$var$preconnectAs("dns-prefetch", href, null);
}
function $4e707583c65f6afa$var$preconnect(href, crossOrigin) {
    $4e707583c65f6afa$var$previousDispatcher.C(href, crossOrigin);
    $4e707583c65f6afa$var$preconnectAs("preconnect", href, crossOrigin);
}
function $4e707583c65f6afa$var$preload(href, as, options) {
    $4e707583c65f6afa$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $4e707583c65f6afa$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $4e707583c65f6afa$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $4e707583c65f6afa$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $4e707583c65f6afa$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $4e707583c65f6afa$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $4e707583c65f6afa$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $4e707583c65f6afa$var$getStyleKey(href);
                break;
            case "script":
                key = $4e707583c65f6afa$var$getScriptKey(href);
        }
        $4e707583c65f6afa$var$preloadPropsMap.has(key) || (href = $4e707583c65f6afa$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $4e707583c65f6afa$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($4e707583c65f6afa$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($4e707583c65f6afa$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $4e707583c65f6afa$var$setInitialProperties(as, "link", href), $4e707583c65f6afa$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $4e707583c65f6afa$var$preloadModule(href, options) {
    $4e707583c65f6afa$var$previousDispatcher.m(href, options);
    var ownerDocument = $4e707583c65f6afa$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $4e707583c65f6afa$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $4e707583c65f6afa$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $4e707583c65f6afa$var$getScriptKey(href);
        }
        if (!$4e707583c65f6afa$var$preloadPropsMap.has(key) && (href = $4e707583c65f6afa$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $4e707583c65f6afa$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($4e707583c65f6afa$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $4e707583c65f6afa$var$setInitialProperties(as, "link", href);
            $4e707583c65f6afa$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $4e707583c65f6afa$var$preinitStyle(href, precedence, options) {
    $4e707583c65f6afa$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $4e707583c65f6afa$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $4e707583c65f6afa$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $4e707583c65f6afa$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($4e707583c65f6afa$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $4e707583c65f6afa$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $4e707583c65f6afa$var$preloadPropsMap.get(key)) && $4e707583c65f6afa$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $4e707583c65f6afa$var$markNodeAsHoistable(link);
                $4e707583c65f6afa$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $4e707583c65f6afa$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $4e707583c65f6afa$var$preinitScript(src, options) {
    $4e707583c65f6afa$var$previousDispatcher.X(src, options);
    var ownerDocument = $4e707583c65f6afa$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $4e707583c65f6afa$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $4e707583c65f6afa$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($4e707583c65f6afa$var$getScriptSelectorFromKey(key)), resource || (src = $4e707583c65f6afa$var$assign({
            src: src,
            async: !0
        }, options), (options = $4e707583c65f6afa$var$preloadPropsMap.get(key)) && $4e707583c65f6afa$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $4e707583c65f6afa$var$markNodeAsHoistable(resource), $4e707583c65f6afa$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $4e707583c65f6afa$var$preinitModuleScript(src, options) {
    $4e707583c65f6afa$var$previousDispatcher.M(src, options);
    var ownerDocument = $4e707583c65f6afa$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $4e707583c65f6afa$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $4e707583c65f6afa$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($4e707583c65f6afa$var$getScriptSelectorFromKey(key)), resource || (src = $4e707583c65f6afa$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $4e707583c65f6afa$var$preloadPropsMap.get(key)) && $4e707583c65f6afa$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $4e707583c65f6afa$var$markNodeAsHoistable(resource), $4e707583c65f6afa$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $4e707583c65f6afa$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $4e707583c65f6afa$var$rootInstanceStackCursor.current) ? $4e707583c65f6afa$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $4e707583c65f6afa$var$getStyleKey(pendingProps.href), pendingProps = $4e707583c65f6afa$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $4e707583c65f6afa$var$getStyleKey(pendingProps.href);
                var styles$243 = $4e707583c65f6afa$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($4e707583c65f6afa$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $4e707583c65f6afa$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $4e707583c65f6afa$var$preloadPropsMap.set(type, pendingProps), styles$243 || $4e707583c65f6afa$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $4e707583c65f6afa$var$getScriptKey(pendingProps), pendingProps = $4e707583c65f6afa$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($4e707583c65f6afa$var$formatProdErrorMessage(444, type));
    }
}
function $4e707583c65f6afa$var$getStyleKey(href) {
    return 'href="' + $4e707583c65f6afa$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $4e707583c65f6afa$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $4e707583c65f6afa$var$stylesheetPropsFromRawProps(rawProps) {
    return $4e707583c65f6afa$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $4e707583c65f6afa$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $4e707583c65f6afa$var$setInitialProperties(key, "link", preloadProps), $4e707583c65f6afa$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $4e707583c65f6afa$var$getScriptKey(src) {
    return '[src="' + $4e707583c65f6afa$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $4e707583c65f6afa$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $4e707583c65f6afa$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $4e707583c65f6afa$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $4e707583c65f6afa$var$markNodeAsHoistable(instance), instance;
            var styleProps = $4e707583c65f6afa$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $4e707583c65f6afa$var$markNodeAsHoistable(instance);
            $4e707583c65f6afa$var$setInitialProperties(instance, "style", styleProps);
            $4e707583c65f6afa$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $4e707583c65f6afa$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($4e707583c65f6afa$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $4e707583c65f6afa$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $4e707583c65f6afa$var$stylesheetPropsFromRawProps(props);
            (styleProps = $4e707583c65f6afa$var$preloadPropsMap.get(styleProps)) && $4e707583c65f6afa$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $4e707583c65f6afa$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $4e707583c65f6afa$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $4e707583c65f6afa$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $4e707583c65f6afa$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($4e707583c65f6afa$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $4e707583c65f6afa$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $4e707583c65f6afa$var$preloadPropsMap.get(instance$249)) instance = $4e707583c65f6afa$var$assign({}, props), $4e707583c65f6afa$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $4e707583c65f6afa$var$markNodeAsHoistable(styleProps);
            $4e707583c65f6afa$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($4e707583c65f6afa$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $4e707583c65f6afa$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $4e707583c65f6afa$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $4e707583c65f6afa$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $4e707583c65f6afa$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $4e707583c65f6afa$var$tagCaches = null;
function $4e707583c65f6afa$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $4e707583c65f6afa$var$tagCaches) {
        var cache = new Map();
        var caches = $4e707583c65f6afa$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $4e707583c65f6afa$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$4e707583c65f6afa$var$internalHoistableMarker] || node[$4e707583c65f6afa$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $4e707583c65f6afa$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $4e707583c65f6afa$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $4e707583c65f6afa$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $4e707583c65f6afa$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $4e707583c65f6afa$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($4e707583c65f6afa$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $4e707583c65f6afa$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $4e707583c65f6afa$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $4e707583c65f6afa$var$stylesheetPropsFromRawProps(props);
            (key = $4e707583c65f6afa$var$preloadPropsMap.get(key)) && $4e707583c65f6afa$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $4e707583c65f6afa$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $4e707583c65f6afa$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $4e707583c65f6afa$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $4e707583c65f6afa$var$estimatedBytesWithinLimit = 0;
function $4e707583c65f6afa$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $4e707583c65f6afa$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $4e707583c65f6afa$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $4e707583c65f6afa$var$estimatedBytesWithinLimit && ($4e707583c65f6afa$var$estimatedBytesWithinLimit = 62500 * $4e707583c65f6afa$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $4e707583c65f6afa$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $4e707583c65f6afa$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $4e707583c65f6afa$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $4e707583c65f6afa$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $4e707583c65f6afa$var$precedencesByRoot = null;
function $4e707583c65f6afa$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $4e707583c65f6afa$var$precedencesByRoot = new Map(), resources.forEach($4e707583c65f6afa$var$insertStylesheetIntoRoot, state), $4e707583c65f6afa$var$precedencesByRoot = null, $4e707583c65f6afa$var$onUnsuspend.call(state));
}
function $4e707583c65f6afa$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $4e707583c65f6afa$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $4e707583c65f6afa$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $4e707583c65f6afa$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $4e707583c65f6afa$var$HostTransitionContext = {
    $$typeof: $4e707583c65f6afa$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $4e707583c65f6afa$var$sharedNotPendingObject,
    _currentValue2: $4e707583c65f6afa$var$sharedNotPendingObject,
    _threadCount: 0
};
function $4e707583c65f6afa$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $4e707583c65f6afa$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4e707583c65f6afa$var$createLaneMap(0);
    this.hiddenUpdates = $4e707583c65f6afa$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $4e707583c65f6afa$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $4e707583c65f6afa$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $4e707583c65f6afa$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $4e707583c65f6afa$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $4e707583c65f6afa$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $4e707583c65f6afa$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $4e707583c65f6afa$var$emptyContextObject;
    parentComponent = $4e707583c65f6afa$var$emptyContextObject;
    return parentComponent;
}
function $4e707583c65f6afa$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $4e707583c65f6afa$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $4e707583c65f6afa$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $4e707583c65f6afa$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($4e707583c65f6afa$var$scheduleUpdateOnFiber(element, rootFiber, lane), $4e707583c65f6afa$var$entangleTransitions(element, rootFiber, lane));
}
function $4e707583c65f6afa$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $4e707583c65f6afa$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $4e707583c65f6afa$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $4e707583c65f6afa$var$markRetryLaneImpl(fiber, retryLane);
}
function $4e707583c65f6afa$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $4e707583c65f6afa$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $4e707583c65f6afa$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $4e707583c65f6afa$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $4e707583c65f6afa$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $4e707583c65f6afa$var$requestUpdateLane();
        lane = $4e707583c65f6afa$var$getBumpedLaneForHydrationByLane(lane);
        var root = $4e707583c65f6afa$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $4e707583c65f6afa$var$scheduleUpdateOnFiber(root, fiber, lane);
        $4e707583c65f6afa$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $4e707583c65f6afa$var$_enabled = !0;
function $4e707583c65f6afa$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $4e707583c65f6afa$var$ReactSharedInternals.T;
    $4e707583c65f6afa$var$ReactSharedInternals.T = null;
    var previousPriority = $4e707583c65f6afa$var$ReactDOMSharedInternals.p;
    try {
        $4e707583c65f6afa$var$ReactDOMSharedInternals.p = 2, $4e707583c65f6afa$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $4e707583c65f6afa$var$ReactDOMSharedInternals.p = previousPriority, $4e707583c65f6afa$var$ReactSharedInternals.T = prevTransition;
    }
}
function $4e707583c65f6afa$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $4e707583c65f6afa$var$ReactSharedInternals.T;
    $4e707583c65f6afa$var$ReactSharedInternals.T = null;
    var previousPriority = $4e707583c65f6afa$var$ReactDOMSharedInternals.p;
    try {
        $4e707583c65f6afa$var$ReactDOMSharedInternals.p = 8, $4e707583c65f6afa$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $4e707583c65f6afa$var$ReactDOMSharedInternals.p = previousPriority, $4e707583c65f6afa$var$ReactSharedInternals.T = prevTransition;
    }
}
function $4e707583c65f6afa$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($4e707583c65f6afa$var$_enabled) {
        var blockedOn = $4e707583c65f6afa$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $4e707583c65f6afa$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $4e707583c65f6afa$var$return_targetInst, targetContainer), $4e707583c65f6afa$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($4e707583c65f6afa$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($4e707583c65f6afa$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $4e707583c65f6afa$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $4e707583c65f6afa$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $4e707583c65f6afa$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $4e707583c65f6afa$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $4e707583c65f6afa$var$ensureRootIsScheduled(fiber);
                                0 === ($4e707583c65f6afa$var$executionContext & 6) && ($4e707583c65f6afa$var$workInProgressRootRenderTargetTime = $4e707583c65f6afa$var$now() + 500, $4e707583c65f6afa$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $4e707583c65f6afa$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $4e707583c65f6afa$var$scheduleUpdateOnFiber(root, fiber, 2), $4e707583c65f6afa$var$flushSyncWork$1(), $4e707583c65f6afa$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $4e707583c65f6afa$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $4e707583c65f6afa$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $4e707583c65f6afa$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $4e707583c65f6afa$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $4e707583c65f6afa$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $4e707583c65f6afa$var$getEventTarget(nativeEvent);
    return $4e707583c65f6afa$var$findInstanceBlockingTarget(nativeEvent);
}
var $4e707583c65f6afa$var$return_targetInst = null;
function $4e707583c65f6afa$var$findInstanceBlockingTarget(targetNode) {
    $4e707583c65f6afa$var$return_targetInst = null;
    targetNode = $4e707583c65f6afa$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $4e707583c65f6afa$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $4e707583c65f6afa$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $4e707583c65f6afa$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $4e707583c65f6afa$var$return_targetInst = targetNode;
    return null;
}
function $4e707583c65f6afa$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($4e707583c65f6afa$var$getCurrentPriorityLevel()){
                case $4e707583c65f6afa$var$ImmediatePriority:
                    return 2;
                case $4e707583c65f6afa$var$UserBlockingPriority:
                    return 8;
                case $4e707583c65f6afa$var$NormalPriority$1:
                case $4e707583c65f6afa$var$LowPriority:
                    return 32;
                case $4e707583c65f6afa$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $4e707583c65f6afa$var$hasScheduledReplayAttempt = !1, $4e707583c65f6afa$var$queuedFocus = null, $4e707583c65f6afa$var$queuedDrag = null, $4e707583c65f6afa$var$queuedMouse = null, $4e707583c65f6afa$var$queuedPointers = new Map(), $4e707583c65f6afa$var$queuedPointerCaptures = new Map(), $4e707583c65f6afa$var$queuedExplicitHydrationTargets = [], $4e707583c65f6afa$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $4e707583c65f6afa$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $4e707583c65f6afa$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $4e707583c65f6afa$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $4e707583c65f6afa$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $4e707583c65f6afa$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4e707583c65f6afa$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $4e707583c65f6afa$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $4e707583c65f6afa$var$getInstanceFromNode(blockedOn), null !== blockedOn && $4e707583c65f6afa$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $4e707583c65f6afa$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $4e707583c65f6afa$var$queuedFocus = $4e707583c65f6afa$var$accumulateOrCreateContinuousQueuedReplayableEvent($4e707583c65f6afa$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $4e707583c65f6afa$var$queuedDrag = $4e707583c65f6afa$var$accumulateOrCreateContinuousQueuedReplayableEvent($4e707583c65f6afa$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $4e707583c65f6afa$var$queuedMouse = $4e707583c65f6afa$var$accumulateOrCreateContinuousQueuedReplayableEvent($4e707583c65f6afa$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $4e707583c65f6afa$var$queuedPointers.set(pointerId, $4e707583c65f6afa$var$accumulateOrCreateContinuousQueuedReplayableEvent($4e707583c65f6afa$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $4e707583c65f6afa$var$queuedPointerCaptures.set(pointerId, $4e707583c65f6afa$var$accumulateOrCreateContinuousQueuedReplayableEvent($4e707583c65f6afa$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $4e707583c65f6afa$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $4e707583c65f6afa$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $4e707583c65f6afa$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $4e707583c65f6afa$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $4e707583c65f6afa$var$runWithPriority(queuedTarget.priority, function() {
                        $4e707583c65f6afa$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $4e707583c65f6afa$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $4e707583c65f6afa$var$runWithPriority(queuedTarget.priority, function() {
                        $4e707583c65f6afa$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $4e707583c65f6afa$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $4e707583c65f6afa$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $4e707583c65f6afa$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $4e707583c65f6afa$var$currentReplayingEvent = null;
        } else return targetContainers = $4e707583c65f6afa$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $4e707583c65f6afa$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $4e707583c65f6afa$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $4e707583c65f6afa$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $4e707583c65f6afa$var$replayUnblockedEvents() {
    $4e707583c65f6afa$var$hasScheduledReplayAttempt = !1;
    null !== $4e707583c65f6afa$var$queuedFocus && $4e707583c65f6afa$var$attemptReplayContinuousQueuedEvent($4e707583c65f6afa$var$queuedFocus) && ($4e707583c65f6afa$var$queuedFocus = null);
    null !== $4e707583c65f6afa$var$queuedDrag && $4e707583c65f6afa$var$attemptReplayContinuousQueuedEvent($4e707583c65f6afa$var$queuedDrag) && ($4e707583c65f6afa$var$queuedDrag = null);
    null !== $4e707583c65f6afa$var$queuedMouse && $4e707583c65f6afa$var$attemptReplayContinuousQueuedEvent($4e707583c65f6afa$var$queuedMouse) && ($4e707583c65f6afa$var$queuedMouse = null);
    $4e707583c65f6afa$var$queuedPointers.forEach($4e707583c65f6afa$var$attemptReplayContinuousQueuedEventInMap);
    $4e707583c65f6afa$var$queuedPointerCaptures.forEach($4e707583c65f6afa$var$attemptReplayContinuousQueuedEventInMap);
}
function $4e707583c65f6afa$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $4e707583c65f6afa$var$hasScheduledReplayAttempt || ($4e707583c65f6afa$var$hasScheduledReplayAttempt = !0, $eOszH.unstable_scheduleCallback($eOszH.unstable_NormalPriority, $4e707583c65f6afa$var$replayUnblockedEvents)));
}
var $4e707583c65f6afa$var$lastScheduledReplayQueue = null;
function $4e707583c65f6afa$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $4e707583c65f6afa$var$lastScheduledReplayQueue !== formReplayingQueue && ($4e707583c65f6afa$var$lastScheduledReplayQueue = formReplayingQueue, $eOszH.unstable_scheduleCallback($eOszH.unstable_NormalPriority, function() {
        $4e707583c65f6afa$var$lastScheduledReplayQueue === formReplayingQueue && ($4e707583c65f6afa$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $4e707583c65f6afa$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $4e707583c65f6afa$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $4e707583c65f6afa$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $4e707583c65f6afa$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $4e707583c65f6afa$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $4e707583c65f6afa$var$queuedFocus && $4e707583c65f6afa$var$scheduleCallbackIfUnblocked($4e707583c65f6afa$var$queuedFocus, unblocked);
    null !== $4e707583c65f6afa$var$queuedDrag && $4e707583c65f6afa$var$scheduleCallbackIfUnblocked($4e707583c65f6afa$var$queuedDrag, unblocked);
    null !== $4e707583c65f6afa$var$queuedMouse && $4e707583c65f6afa$var$scheduleCallbackIfUnblocked($4e707583c65f6afa$var$queuedMouse, unblocked);
    $4e707583c65f6afa$var$queuedPointers.forEach(unblock);
    $4e707583c65f6afa$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $4e707583c65f6afa$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $4e707583c65f6afa$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $4e707583c65f6afa$var$queuedExplicitHydrationTargets.length && (i = $4e707583c65f6afa$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$4e707583c65f6afa$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $4e707583c65f6afa$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$4e707583c65f6afa$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $4e707583c65f6afa$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$4e707583c65f6afa$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $4e707583c65f6afa$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $4e707583c65f6afa$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $4e707583c65f6afa$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $4e707583c65f6afa$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$4e707583c65f6afa$var$ReactDOMHydrationRoot.prototype.render = $4e707583c65f6afa$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(409));
    var current = root.current, lane = $4e707583c65f6afa$var$requestUpdateLane();
    $4e707583c65f6afa$var$updateContainerImpl(current, lane, children, root, null, null);
};
$4e707583c65f6afa$var$ReactDOMHydrationRoot.prototype.unmount = $4e707583c65f6afa$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $4e707583c65f6afa$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $4e707583c65f6afa$var$flushSyncWork$1();
        container[$4e707583c65f6afa$var$internalContainerInstanceKey] = null;
    }
};
function $4e707583c65f6afa$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$4e707583c65f6afa$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $4e707583c65f6afa$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $4e707583c65f6afa$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $4e707583c65f6afa$var$queuedExplicitHydrationTargets[i].priority; i++);
        $4e707583c65f6afa$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $4e707583c65f6afa$var$attemptExplicitHydrationTarget(target);
    }
};
var $4e707583c65f6afa$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $5jV9H.version;
if ("19.2.4" !== $4e707583c65f6afa$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(527, $4e707583c65f6afa$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$4e707583c65f6afa$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($4e707583c65f6afa$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $4e707583c65f6afa$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $4e707583c65f6afa$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $4e707583c65f6afa$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $4e707583c65f6afa$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4e707583c65f6afa$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4e707583c65f6afa$var$hook$jscomp$inline_2348.isDisabled && $4e707583c65f6afa$var$hook$jscomp$inline_2348.supportsFiber) try {
        $4e707583c65f6afa$var$rendererID = $4e707583c65f6afa$var$hook$jscomp$inline_2348.inject($4e707583c65f6afa$var$internals$jscomp$inline_2347), $4e707583c65f6afa$var$injectedHook = $4e707583c65f6afa$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$4e707583c65f6afa$export$882461b6382ed46c = function(container, options) {
    if (!$4e707583c65f6afa$var$isValidContainer(container)) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $4e707583c65f6afa$var$defaultOnUncaughtError, onCaughtError = $4e707583c65f6afa$var$defaultOnCaughtError, onRecoverableError = $4e707583c65f6afa$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $4e707583c65f6afa$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $4e707583c65f6afa$var$defaultOnDefaultTransitionIndicator);
    container[$4e707583c65f6afa$var$internalContainerInstanceKey] = options.current;
    $4e707583c65f6afa$var$listenToAllSupportedEvents(container);
    return new $4e707583c65f6afa$var$ReactDOMRoot(options);
};
$4e707583c65f6afa$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$4e707583c65f6afa$var$isValidContainer(container)) throw Error($4e707583c65f6afa$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $4e707583c65f6afa$var$defaultOnUncaughtError, onCaughtError = $4e707583c65f6afa$var$defaultOnCaughtError, onRecoverableError = $4e707583c65f6afa$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $4e707583c65f6afa$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $4e707583c65f6afa$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $4e707583c65f6afa$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $4e707583c65f6afa$var$requestUpdateLane();
    isStrictMode = $4e707583c65f6afa$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $4e707583c65f6afa$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $4e707583c65f6afa$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $4e707583c65f6afa$var$markRootUpdated$1(initialChildren, options);
    $4e707583c65f6afa$var$ensureRootIsScheduled(initialChildren);
    container[$4e707583c65f6afa$var$internalContainerInstanceKey] = initialChildren.current;
    $4e707583c65f6afa$var$listenToAllSupportedEvents(container);
    return new $4e707583c65f6afa$var$ReactDOMHydrationRoot(initialChildren);
};
$4e707583c65f6afa$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("eOszH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3LI6R"));

});
parcelRegister("3LI6R", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $2be7fa20be983fd0$export$c4744153514ff05d, (v) => $2be7fa20be983fd0$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $2be7fa20be983fd0$export$3e506c1ccc9cc1a7, (v) => $2be7fa20be983fd0$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $2be7fa20be983fd0$export$e26fe2ed2fa76875, (v) => $2be7fa20be983fd0$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $2be7fa20be983fd0$export$502329bbf4b505b1, (v) => $2be7fa20be983fd0$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $2be7fa20be983fd0$export$6e3807111c4874c4, (v) => $2be7fa20be983fd0$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $2be7fa20be983fd0$export$c27134553091fb3a, (v) => $2be7fa20be983fd0$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $2be7fa20be983fd0$export$33ee1acdc04fd2a2, (v) => $2be7fa20be983fd0$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $2be7fa20be983fd0$export$b00a404bbd5edef2, (v) => $2be7fa20be983fd0$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $2be7fa20be983fd0$export$d66a1c1c77bd778b, (v) => $2be7fa20be983fd0$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $2be7fa20be983fd0$export$d3dfb8e4810cb555, (v) => $2be7fa20be983fd0$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $2be7fa20be983fd0$export$72fdf0e06517287b, (v) => $2be7fa20be983fd0$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $2be7fa20be983fd0$export$816d2913ae6b83b1, (v) => $2be7fa20be983fd0$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $2be7fa20be983fd0$export$61bcfe829111a1d0, (v) => $2be7fa20be983fd0$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $2be7fa20be983fd0$export$7ee8c9beb337bc3f, (v) => $2be7fa20be983fd0$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $2be7fa20be983fd0$export$b5836b71941fa3ed, (v) => $2be7fa20be983fd0$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $2be7fa20be983fd0$export$cf845f2c119da08a, (v) => $2be7fa20be983fd0$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2be7fa20be983fd0$export$c4744153514ff05d;
var $2be7fa20be983fd0$export$3e506c1ccc9cc1a7;
var $2be7fa20be983fd0$export$e26fe2ed2fa76875;
var $2be7fa20be983fd0$export$502329bbf4b505b1;
var $2be7fa20be983fd0$export$6e3807111c4874c4;
var $2be7fa20be983fd0$export$c27134553091fb3a;
var $2be7fa20be983fd0$export$33ee1acdc04fd2a2;
var $2be7fa20be983fd0$export$b00a404bbd5edef2;
var $2be7fa20be983fd0$export$d66a1c1c77bd778b;
var $2be7fa20be983fd0$export$d3dfb8e4810cb555;
var $2be7fa20be983fd0$export$72fdf0e06517287b;
var $2be7fa20be983fd0$export$816d2913ae6b83b1;
var $2be7fa20be983fd0$export$61bcfe829111a1d0;
var $2be7fa20be983fd0$export$7ee8c9beb337bc3f;
var $2be7fa20be983fd0$export$b5836b71941fa3ed;
var $2be7fa20be983fd0$export$cf845f2c119da08a;
"use strict";
function $2be7fa20be983fd0$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $2be7fa20be983fd0$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $2be7fa20be983fd0$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $2be7fa20be983fd0$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $2be7fa20be983fd0$var$compare(left, last)) rightIndex < length && 0 > $2be7fa20be983fd0$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $2be7fa20be983fd0$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $2be7fa20be983fd0$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$2be7fa20be983fd0$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $2be7fa20be983fd0$var$localPerformance = performance;
    $2be7fa20be983fd0$export$c4744153514ff05d = function() {
        return $2be7fa20be983fd0$var$localPerformance.now();
    };
} else {
    var $2be7fa20be983fd0$var$localDate = Date, $2be7fa20be983fd0$var$initialTime = $2be7fa20be983fd0$var$localDate.now();
    $2be7fa20be983fd0$export$c4744153514ff05d = function() {
        return $2be7fa20be983fd0$var$localDate.now() - $2be7fa20be983fd0$var$initialTime;
    };
}
var $2be7fa20be983fd0$var$taskQueue = [], $2be7fa20be983fd0$var$timerQueue = [], $2be7fa20be983fd0$var$taskIdCounter = 1, $2be7fa20be983fd0$var$currentTask = null, $2be7fa20be983fd0$var$currentPriorityLevel = 3, $2be7fa20be983fd0$var$isPerformingWork = !1, $2be7fa20be983fd0$var$isHostCallbackScheduled = !1, $2be7fa20be983fd0$var$isHostTimeoutScheduled = !1, $2be7fa20be983fd0$var$needsPaint = !1, $2be7fa20be983fd0$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $2be7fa20be983fd0$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $2be7fa20be983fd0$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $2be7fa20be983fd0$var$advanceTimers(currentTime) {
    for(var timer = $2be7fa20be983fd0$var$peek($2be7fa20be983fd0$var$timerQueue); null !== timer;){
        if (null === timer.callback) $2be7fa20be983fd0$var$pop($2be7fa20be983fd0$var$timerQueue);
        else if (timer.startTime <= currentTime) $2be7fa20be983fd0$var$pop($2be7fa20be983fd0$var$timerQueue), timer.sortIndex = timer.expirationTime, $2be7fa20be983fd0$var$push($2be7fa20be983fd0$var$taskQueue, timer);
        else break;
        timer = $2be7fa20be983fd0$var$peek($2be7fa20be983fd0$var$timerQueue);
    }
}
function $2be7fa20be983fd0$var$handleTimeout(currentTime) {
    $2be7fa20be983fd0$var$isHostTimeoutScheduled = !1;
    $2be7fa20be983fd0$var$advanceTimers(currentTime);
    if (!$2be7fa20be983fd0$var$isHostCallbackScheduled) {
        if (null !== $2be7fa20be983fd0$var$peek($2be7fa20be983fd0$var$taskQueue)) $2be7fa20be983fd0$var$isHostCallbackScheduled = !0, $2be7fa20be983fd0$var$isMessageLoopRunning || ($2be7fa20be983fd0$var$isMessageLoopRunning = !0, $2be7fa20be983fd0$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $2be7fa20be983fd0$var$peek($2be7fa20be983fd0$var$timerQueue);
            null !== firstTimer && $2be7fa20be983fd0$var$requestHostTimeout($2be7fa20be983fd0$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $2be7fa20be983fd0$var$isMessageLoopRunning = !1, $2be7fa20be983fd0$var$taskTimeoutID = -1, $2be7fa20be983fd0$var$frameInterval = 5, $2be7fa20be983fd0$var$startTime = -1;
function $2be7fa20be983fd0$var$shouldYieldToHost() {
    return $2be7fa20be983fd0$var$needsPaint ? !0 : $2be7fa20be983fd0$export$c4744153514ff05d() - $2be7fa20be983fd0$var$startTime < $2be7fa20be983fd0$var$frameInterval ? !1 : !0;
}
function $2be7fa20be983fd0$var$performWorkUntilDeadline() {
    $2be7fa20be983fd0$var$needsPaint = !1;
    if ($2be7fa20be983fd0$var$isMessageLoopRunning) {
        var currentTime = $2be7fa20be983fd0$export$c4744153514ff05d();
        $2be7fa20be983fd0$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $2be7fa20be983fd0$var$isHostCallbackScheduled = !1;
                $2be7fa20be983fd0$var$isHostTimeoutScheduled && ($2be7fa20be983fd0$var$isHostTimeoutScheduled = !1, $2be7fa20be983fd0$var$localClearTimeout($2be7fa20be983fd0$var$taskTimeoutID), $2be7fa20be983fd0$var$taskTimeoutID = -1);
                $2be7fa20be983fd0$var$isPerformingWork = !0;
                var previousPriorityLevel = $2be7fa20be983fd0$var$currentPriorityLevel;
                try {
                    b: {
                        $2be7fa20be983fd0$var$advanceTimers(currentTime);
                        for($2be7fa20be983fd0$var$currentTask = $2be7fa20be983fd0$var$peek($2be7fa20be983fd0$var$taskQueue); null !== $2be7fa20be983fd0$var$currentTask && !($2be7fa20be983fd0$var$currentTask.expirationTime > currentTime && $2be7fa20be983fd0$var$shouldYieldToHost());){
                            var callback = $2be7fa20be983fd0$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $2be7fa20be983fd0$var$currentTask.callback = null;
                                $2be7fa20be983fd0$var$currentPriorityLevel = $2be7fa20be983fd0$var$currentTask.priorityLevel;
                                var continuationCallback = callback($2be7fa20be983fd0$var$currentTask.expirationTime <= currentTime);
                                currentTime = $2be7fa20be983fd0$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $2be7fa20be983fd0$var$currentTask.callback = continuationCallback;
                                    $2be7fa20be983fd0$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $2be7fa20be983fd0$var$currentTask === $2be7fa20be983fd0$var$peek($2be7fa20be983fd0$var$taskQueue) && $2be7fa20be983fd0$var$pop($2be7fa20be983fd0$var$taskQueue);
                                $2be7fa20be983fd0$var$advanceTimers(currentTime);
                            } else $2be7fa20be983fd0$var$pop($2be7fa20be983fd0$var$taskQueue);
                            $2be7fa20be983fd0$var$currentTask = $2be7fa20be983fd0$var$peek($2be7fa20be983fd0$var$taskQueue);
                        }
                        if (null !== $2be7fa20be983fd0$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $2be7fa20be983fd0$var$peek($2be7fa20be983fd0$var$timerQueue);
                            null !== firstTimer && $2be7fa20be983fd0$var$requestHostTimeout($2be7fa20be983fd0$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $2be7fa20be983fd0$var$currentTask = null, $2be7fa20be983fd0$var$currentPriorityLevel = previousPriorityLevel, $2be7fa20be983fd0$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $2be7fa20be983fd0$var$schedulePerformWorkUntilDeadline() : $2be7fa20be983fd0$var$isMessageLoopRunning = !1;
        }
    }
}
var $2be7fa20be983fd0$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $2be7fa20be983fd0$var$localSetImmediate) $2be7fa20be983fd0$var$schedulePerformWorkUntilDeadline = function() {
    $2be7fa20be983fd0$var$localSetImmediate($2be7fa20be983fd0$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $2be7fa20be983fd0$var$channel = new MessageChannel(), $2be7fa20be983fd0$var$port = $2be7fa20be983fd0$var$channel.port2;
    $2be7fa20be983fd0$var$channel.port1.onmessage = $2be7fa20be983fd0$var$performWorkUntilDeadline;
    $2be7fa20be983fd0$var$schedulePerformWorkUntilDeadline = function() {
        $2be7fa20be983fd0$var$port.postMessage(null);
    };
} else $2be7fa20be983fd0$var$schedulePerformWorkUntilDeadline = function() {
    $2be7fa20be983fd0$var$localSetTimeout($2be7fa20be983fd0$var$performWorkUntilDeadline, 0);
};
function $2be7fa20be983fd0$var$requestHostTimeout(callback, ms) {
    $2be7fa20be983fd0$var$taskTimeoutID = $2be7fa20be983fd0$var$localSetTimeout(function() {
        callback($2be7fa20be983fd0$export$c4744153514ff05d());
    }, ms);
}
$2be7fa20be983fd0$export$3e506c1ccc9cc1a7 = 5;
$2be7fa20be983fd0$export$e26fe2ed2fa76875 = 1;
$2be7fa20be983fd0$export$502329bbf4b505b1 = 4;
$2be7fa20be983fd0$export$6e3807111c4874c4 = 3;
$2be7fa20be983fd0$export$c27134553091fb3a = null;
$2be7fa20be983fd0$export$33ee1acdc04fd2a2 = 2;
$2be7fa20be983fd0$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$2be7fa20be983fd0$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $2be7fa20be983fd0$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$2be7fa20be983fd0$export$d3dfb8e4810cb555 = function() {
    return $2be7fa20be983fd0$var$currentPriorityLevel;
};
$2be7fa20be983fd0$export$72fdf0e06517287b = function(eventHandler) {
    switch($2be7fa20be983fd0$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $2be7fa20be983fd0$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $2be7fa20be983fd0$var$currentPriorityLevel;
    $2be7fa20be983fd0$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $2be7fa20be983fd0$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$2be7fa20be983fd0$export$816d2913ae6b83b1 = function() {
    $2be7fa20be983fd0$var$needsPaint = !0;
};
$2be7fa20be983fd0$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $2be7fa20be983fd0$var$currentPriorityLevel;
    $2be7fa20be983fd0$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $2be7fa20be983fd0$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$2be7fa20be983fd0$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $2be7fa20be983fd0$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $2be7fa20be983fd0$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $2be7fa20be983fd0$var$push($2be7fa20be983fd0$var$timerQueue, priorityLevel), null === $2be7fa20be983fd0$var$peek($2be7fa20be983fd0$var$taskQueue) && priorityLevel === $2be7fa20be983fd0$var$peek($2be7fa20be983fd0$var$timerQueue) && ($2be7fa20be983fd0$var$isHostTimeoutScheduled ? ($2be7fa20be983fd0$var$localClearTimeout($2be7fa20be983fd0$var$taskTimeoutID), $2be7fa20be983fd0$var$taskTimeoutID = -1) : $2be7fa20be983fd0$var$isHostTimeoutScheduled = !0, $2be7fa20be983fd0$var$requestHostTimeout($2be7fa20be983fd0$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $2be7fa20be983fd0$var$push($2be7fa20be983fd0$var$taskQueue, priorityLevel), $2be7fa20be983fd0$var$isHostCallbackScheduled || $2be7fa20be983fd0$var$isPerformingWork || ($2be7fa20be983fd0$var$isHostCallbackScheduled = !0, $2be7fa20be983fd0$var$isMessageLoopRunning || ($2be7fa20be983fd0$var$isMessageLoopRunning = !0, $2be7fa20be983fd0$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$2be7fa20be983fd0$export$b5836b71941fa3ed = $2be7fa20be983fd0$var$shouldYieldToHost;
$2be7fa20be983fd0$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $2be7fa20be983fd0$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $2be7fa20be983fd0$var$currentPriorityLevel;
        $2be7fa20be983fd0$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $2be7fa20be983fd0$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("5jV9H", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jXpdd"));

});

parcelRegister("7ukom", function(module, exports) {
'use strict';
function $573b272ca250b2ec$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($573b272ca250b2ec$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$573b272ca250b2ec$var$checkDCE();

module.exports = (parcelRequire("7V36Z"));

});
parcelRegister("7V36Z", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $5c40452d851f917a$export$69ce8ef3fe5cead0, (v) => $5c40452d851f917a$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $5c40452d851f917a$export$d39a5bbd09211389, (v) => $5c40452d851f917a$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $5c40452d851f917a$export$cd75ccfd720a3cd4, (v) => $5c40452d851f917a$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $5c40452d851f917a$export$a0816fa17a9e79be, (v) => $5c40452d851f917a$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $5c40452d851f917a$export$7292efcadded39f3, (v) => $5c40452d851f917a$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $5c40452d851f917a$export$da407abadb9b8f86, (v) => $5c40452d851f917a$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $5c40452d851f917a$export$314cfea32580671c, (v) => $5c40452d851f917a$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $5c40452d851f917a$export$513ccb98c53b8039, (v) => $5c40452d851f917a$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $5c40452d851f917a$export$dbca993bc2d264a, (v) => $5c40452d851f917a$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $5c40452d851f917a$export$4797a8006f0655d0, (v) => $5c40452d851f917a$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $5c40452d851f917a$export$c78a37762a8d58e1, (v) => $5c40452d851f917a$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $5c40452d851f917a$export$606f11b2eb45ecc6, (v) => $5c40452d851f917a$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $5c40452d851f917a$export$f7e8a0bf92324b1e, (v) => $5c40452d851f917a$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $5c40452d851f917a$export$83d89fbfd8236492, (v) => $5c40452d851f917a$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5c40452d851f917a$export$69ce8ef3fe5cead0;
var $5c40452d851f917a$export$d39a5bbd09211389;
var $5c40452d851f917a$export$cd75ccfd720a3cd4;
var $5c40452d851f917a$export$a0816fa17a9e79be;
var $5c40452d851f917a$export$7292efcadded39f3;
var $5c40452d851f917a$export$da407abadb9b8f86;
var $5c40452d851f917a$export$314cfea32580671c;
var $5c40452d851f917a$export$513ccb98c53b8039;
var $5c40452d851f917a$export$dbca993bc2d264a;
var $5c40452d851f917a$export$4797a8006f0655d0;
var $5c40452d851f917a$export$c78a37762a8d58e1;
var $5c40452d851f917a$export$606f11b2eb45ecc6;
var $5c40452d851f917a$export$f7e8a0bf92324b1e;
var $5c40452d851f917a$export$83d89fbfd8236492;
"use strict";

var $5jV9H = parcelRequire("5jV9H");
function $5c40452d851f917a$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $5c40452d851f917a$var$noop() {}
var $5c40452d851f917a$var$Internals = {
    d: {
        f: $5c40452d851f917a$var$noop,
        r: function() {
            throw Error($5c40452d851f917a$var$formatProdErrorMessage(522));
        },
        D: $5c40452d851f917a$var$noop,
        C: $5c40452d851f917a$var$noop,
        L: $5c40452d851f917a$var$noop,
        m: $5c40452d851f917a$var$noop,
        X: $5c40452d851f917a$var$noop,
        S: $5c40452d851f917a$var$noop,
        M: $5c40452d851f917a$var$noop
    },
    p: 0,
    findDOMNode: null
}, $5c40452d851f917a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $5c40452d851f917a$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $5c40452d851f917a$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $5c40452d851f917a$var$ReactSharedInternals = $5jV9H.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $5c40452d851f917a$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$5c40452d851f917a$export$69ce8ef3fe5cead0 = $5c40452d851f917a$var$Internals;
$5c40452d851f917a$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($5c40452d851f917a$var$formatProdErrorMessage(299));
    return $5c40452d851f917a$var$createPortal$1(children, container, null, key);
};
$5c40452d851f917a$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $5c40452d851f917a$var$ReactSharedInternals.T, previousUpdatePriority = $5c40452d851f917a$var$Internals.p;
    try {
        if ($5c40452d851f917a$var$ReactSharedInternals.T = null, $5c40452d851f917a$var$Internals.p = 2, fn) return fn();
    } finally{
        $5c40452d851f917a$var$ReactSharedInternals.T = previousTransition, $5c40452d851f917a$var$Internals.p = previousUpdatePriority, $5c40452d851f917a$var$Internals.d.f();
    }
};
$5c40452d851f917a$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $5c40452d851f917a$var$Internals.d.C(href, options));
};
$5c40452d851f917a$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $5c40452d851f917a$var$Internals.d.D(href);
};
$5c40452d851f917a$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $5c40452d851f917a$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $5c40452d851f917a$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $5c40452d851f917a$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$5c40452d851f917a$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $5c40452d851f917a$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $5c40452d851f917a$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $5c40452d851f917a$var$Internals.d.M(href);
    }
};
$5c40452d851f917a$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $5c40452d851f917a$var$getCrossOriginStringAs(as, options.crossOrigin);
        $5c40452d851f917a$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$5c40452d851f917a$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $5c40452d851f917a$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $5c40452d851f917a$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $5c40452d851f917a$var$Internals.d.m(href);
    }
};
$5c40452d851f917a$export$4797a8006f0655d0 = function(form) {
    $5c40452d851f917a$var$Internals.d.r(form);
};
$5c40452d851f917a$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$5c40452d851f917a$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $5c40452d851f917a$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$5c40452d851f917a$export$f7e8a0bf92324b1e = function() {
    return $5c40452d851f917a$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$5c40452d851f917a$export$83d89fbfd8236492 = "19.2.4";

});



var $c56b12d5022cecd0$exports = {};
'use strict';

$c56b12d5022cecd0$exports = (parcelRequire("bJlpu"));



var $5jV9H = parcelRequire("5jV9H");
var $35103ae6fb992fb0$exports = {};
'use strict';
function $35103ae6fb992fb0$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($35103ae6fb992fb0$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$35103ae6fb992fb0$var$checkDCE();

$35103ae6fb992fb0$exports = (parcelRequire("6JwTj"));




var $5jV9H = parcelRequire("5jV9H");

parcelRequire("5jV9H");


var $5jV9H = parcelRequire("5jV9H");
const $aa236c764a6c6983$var$STORAGE_KEY = 'valyux-theme';
/* ------------------------------------------------------------------ */ /*  Context                                                            */ /* ------------------------------------------------------------------ */ const $aa236c764a6c6983$var$ThemeContext = /*#__PURE__*/ (0, $5jV9H.createContext)({
    mode: 'light',
    resolved: 'light',
    setMode: ()=>{},
    toggle: ()=>{}
});
const $aa236c764a6c6983$export$93d4e7f90805808f = ()=>(0, $5jV9H.useContext)($aa236c764a6c6983$var$ThemeContext);
const $aa236c764a6c6983$export$d8964aec282183a3 = ({ children: children })=>{
    const [mode, setModeState] = (0, $5jV9H.useState)(()=>{
        try {
            const saved = localStorage.getItem($aa236c764a6c6983$var$STORAGE_KEY);
            if (saved === 'light' || saved === 'dark' || saved === 'system') return saved;
        } catch  {}
        // Default to light (white) background when nothing is stored
        return 'light';
    });
    const [systemDark, setSystemDark] = (0, $5jV9H.useState)(()=>typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    // Listen for system theme changes
    (0, $5jV9H.useEffect)(()=>{
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        const handler = (e)=>setSystemDark(e.matches);
        mq.addEventListener('change', handler);
        return ()=>mq.removeEventListener('change', handler);
    }, []);
    const resolved = mode === 'system' ? systemDark ? 'dark' : 'light' : mode;
    // Apply dark class to <html>
    (0, $5jV9H.useEffect)(()=>{
        const root = document.documentElement;
        if (resolved === 'dark') root.classList.add('dark');
        else root.classList.remove('dark');
    }, [
        resolved
    ]);
    const setMode = (0, $5jV9H.useCallback)((m)=>{
        setModeState(m);
        try {
            localStorage.setItem($aa236c764a6c6983$var$STORAGE_KEY, m);
        } catch  {}
    }, []);
    const toggle = (0, $5jV9H.useCallback)(()=>{
        setMode(resolved === 'dark' ? 'light' : 'dark');
    }, [
        resolved,
        setMode
    ]);
    return /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)($aa236c764a6c6983$var$ThemeContext.Provider, {
        value: {
            mode: mode,
            resolved: resolved,
            setMode: setMode,
            toggle: toggle
        },
        children: children
    });
};


var $27e2627fb6cf48ca$exports = {};
$27e2627fb6cf48ca$exports = import.meta.resolve("SlwEe");


const $b3f1cf32d4482287$var$valyuxLogo = new URL($27e2627fb6cf48ca$exports).href;
const $b3f1cf32d4482287$var$Navbar = ({ cartCount: cartCount, onCartClick: onCartClick, searchQuery: searchQuery, onSearchChange: onSearchChange, onSearchSubmit: onSearchSubmit, onLogoClick: onLogoClick })=>{
    const { resolved: resolved, toggle: toggle } = (0, $aa236c764a6c6983$export$93d4e7f90805808f)();
    return /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("nav", {
        className: "sticky top-0 z-40 bg-white dark:bg-neutral-900 border-b border-neutral-200 dark:border-neutral-800",
        children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
            className: "max-w-6xl mx-auto px-4 pt-2 pb-2 sm:pt-2.5 sm:pb-2 flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                    className: "flex flex-row items-center justify-between gap-3 w-full min-h-0",
                    children: [
                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                            type: "button",
                            className: "flex items-center shrink-0 cursor-pointer text-left min-w-0",
                            onClick: ()=>onLogoClick?.(),
                            children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                                className: "inline-flex items-center gap-1.5 sm:gap-2 text-lg sm:text-xl font-bold text-neutral-900 dark:text-white tracking-tight leading-none whitespace-nowrap",
                                children: [
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("img", {
                                        src: $b3f1cf32d4482287$var$valyuxLogo,
                                        alt: "",
                                        className: "h-[2.22em] w-[2.22em] sm:h-[2.22em] sm:w-[2.22em] rounded-lg object-contain shrink-0",
                                        "aria-hidden": true
                                    }),
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                                        className: "leading-none",
                                        children: "Valyux"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                            className: "flex items-center gap-1 sm:gap-2 shrink-0",
                            children: [
                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                                    onClick: toggle,
                                    "aria-label": "Toggle theme",
                                    className: "p-2 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 text-neutral-500",
                                    children: resolved === 'dark' ? /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("svg", {
                                        className: "w-5 h-5",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24",
                                        children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                                        })
                                    }) : /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("svg", {
                                        className: "w-5 h-5",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24",
                                        children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("button", {
                                    onClick: onCartClick,
                                    className: "relative flex items-center gap-1.5 sm:gap-2 bg-yellow-400 hover:bg-yellow-500 text-neutral-900 px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg font-semibold text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("svg", {
                                            className: "w-5 h-5",
                                            fill: "none",
                                            stroke: "currentColor",
                                            viewBox: "0 0 24 24",
                                            children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: 2,
                                                d: "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                                            })
                                        }),
                                        "Cart",
                                        cartCount > 0 && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                                            className: "absolute -top-1 -right-1 bg-red-500 text-white text-xs min-w-[18px] h-[18px] flex items-center justify-center rounded-full",
                                            children: cartCount
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                    className: "w-full min-w-0",
                    children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                                className: "absolute left-4 top-1/2 -translate-y-1/2 text-neutral-400 pointer-events-none",
                                children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("svg", {
                                    className: "w-4 h-4",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24",
                                    children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("input", {
                                type: "text",
                                placeholder: "Search products...",
                                className: "w-full bg-white dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 rounded-full py-2.5 pl-11 pr-4 text-sm outline-none focus:ring-2 focus:ring-yellow-400/50 focus:border-yellow-400 placeholder:text-neutral-400",
                                value: searchQuery,
                                onChange: (e)=>onSearchChange(e.target.value),
                                onKeyDown: (e)=>{
                                    if (e.key === 'Enter') {
                                        onSearchSubmit?.();
                                        e.currentTarget.blur();
                                    }
                                }
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $b3f1cf32d4482287$export$2e2bcd8739ae039 = $b3f1cf32d4482287$var$Navbar;




var $5jV9H = parcelRequire("5jV9H");
const $f8724ca7633d3fc2$var$DEFAULT_URLS = {
    JioMart: 'https://www.jiomart.com',
    Blinkit: 'https://blinkit.com',
    Instamart: 'https://www.swiggy.com/instamart',
    Zepto: 'https://www.zepto.com'
};
// Search path per platform (?q= or /search?q= etc.) – built from default base so search always works
const $f8724ca7633d3fc2$var$SEARCH_PATHS = {
    JioMart: '/search?q=',
    Blinkit: '/s/?q=',
    Instamart: '?q=',
    Zepto: '/search?q='
};
// Referenced explicitly so Parcel injects them from .env at build time (backup for when you have affiliate links)
const $f8724ca7633d3fc2$var$AFFILIATE_URLS = {
    JioMart: $f8724ca7633d3fc2$var$DEFAULT_URLS.JioMart,
    Blinkit: $f8724ca7633d3fc2$var$DEFAULT_URLS.Blinkit,
    Instamart: $f8724ca7633d3fc2$var$DEFAULT_URLS.Instamart,
    Zepto: $f8724ca7633d3fc2$var$DEFAULT_URLS.Zepto
};
function $f8724ca7633d3fc2$export$745b59647432dd19(platform) {
    const url = $f8724ca7633d3fc2$var$AFFILIATE_URLS[platform];
    return url && url.startsWith('http') ? url : $f8724ca7633d3fc2$var$DEFAULT_URLS[platform];
}
function $f8724ca7633d3fc2$export$8e445a41829852(platform, searchQuery) {
    const base = $f8724ca7633d3fc2$var$DEFAULT_URLS[platform].replace(/\/$/, '');
    const path = $f8724ca7633d3fc2$var$SEARCH_PATHS[platform];
    const encoded = encodeURIComponent(searchQuery.trim());
    return `${base}${path}${encoded}`;
}
const $f8724ca7633d3fc2$var$INSTAMART_ITEM_BASE = 'https://instamart.in/item/';
/** Instamart `/p/--ID` URLs 404; working format is `/item/{ID}` without leading dashes. */ function $f8724ca7633d3fc2$var$instamartItemId(raw) {
    if (!raw) return null;
    const fromUrl = raw.match(/instamart\.in\/(?:p|item)\/[-_]*([A-Za-z0-9]+)/i);
    if (fromUrl?.[1]) return fromUrl[1];
    const cleaned = raw.replace(/^[-_]+/, '').trim();
    return /^[A-Za-z0-9]+$/.test(cleaned) ? cleaned : null;
}
function $f8724ca7633d3fc2$export$2a5744d9b5ca1c4d(platform, productName, productUrl, itemId) {
    if (platform === 'Instamart') {
        const id = $f8724ca7633d3fc2$var$instamartItemId(itemId) || $f8724ca7633d3fc2$var$instamartItemId(productUrl);
        if (id) return `${$f8724ca7633d3fc2$var$INSTAMART_ITEM_BASE}${id}`;
    }
    return productUrl || $f8724ca7633d3fc2$export$8e445a41829852(platform, productName);
}


var $7e0e03a2f383014c$exports = {};
$7e0e03a2f383014c$exports = import.meta.resolve("5RlOc");


/** Bundled Zepto icon — external CDN/favicon proxies fail on many mobile browsers. */ const $c415184affb3c148$var$ZEPTO_ICON = new URL($7e0e03a2f383014c$exports).href;
const $c415184affb3c148$export$20330efe7064a3a3 = {
    JioMart: 'https://www.google.com/s2/favicons?domain=jiomart.com&sz=128',
    Blinkit: 'https://blinkit.com/favicon.ico',
    Instamart: 'https://www.google.com/s2/favicons?domain=swiggy.com&sz=128',
    Zepto: $c415184affb3c148$var$ZEPTO_ICON
};
const $c415184affb3c148$var$PLATFORM_ICON_FALLBACKS = {
    Zepto: 'https://cdn.zeptonow.com/web-static-assets-prod/artifacts/16.19.0/favicon.png'
};
function $c415184affb3c148$export$95bc294db34c3e24(platform) {
    return $c415184affb3c148$export$20330efe7064a3a3[platform] ?? '';
}
function $c415184affb3c148$export$91054406962f6412(platform) {
    return $c415184affb3c148$var$PLATFORM_ICON_FALLBACKS[platform];
}


const $e2f42211602dbfa6$var$PLACEHOLDER_IMAGE = 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=400&q=80';
/** Keeps digits and units (e.g. "7 mins") on one line and aligned on the same baseline (fixes mobile font-metrics quirks). */ function $e2f42211602dbfa6$var$DeliveryTimeLabel({ value: value, className: className }) {
    const cleaned = value.replace(/\s+/g, ' ').trim();
    const match = cleaned.match(/^(\d+)\s*(.+)$/);
    const base = className ?? 'text-[10px] text-neutral-500 dark:text-neutral-400';
    if (match) {
        const [, num, rest] = match;
        return /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
            className: `inline-flex items-baseline gap-0.5 whitespace-nowrap ${base}`,
            children: [
                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                    className: "tabular-nums font-semibold leading-none",
                    children: num
                }),
                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                    className: "leading-none",
                    children: rest
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
        className: `whitespace-nowrap leading-none ${base}`,
        children: cleaned
    });
}
const $e2f42211602dbfa6$var$ProductCard = ({ product: product, onAddToCart: onAddToCart })=>{
    const sortedPrices = [
        ...product.platformPrices
    ].sort((a, b)=>a.price - b.price);
    const cheapestPrice = sortedPrices[0];
    const otherPrices = sortedPrices.slice(1);
    const discountPct = cheapestPrice && cheapestPrice.originalPrice > cheapestPrice.price ? Math.round((1 - cheapestPrice.price / cheapestPrice.originalPrice) * 100) : 0;
    const [menuOpen, setMenuOpen] = (0, $5jV9H.useState)(false);
    const getPlatformColor = (platform)=>{
        switch(platform){
            case 'JioMart':
                return 'text-blue-600 dark:text-blue-400 border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-900/20';
            case 'Blinkit':
                return 'text-yellow-600 dark:text-yellow-400 border-yellow-200 dark:border-yellow-800 bg-yellow-50 dark:bg-yellow-900/20';
            case 'Instamart':
                return 'text-orange-600 dark:text-orange-400 border-orange-200 dark:border-orange-800 bg-orange-50 dark:bg-orange-900/20';
            case 'Zepto':
                return 'text-purple-600 dark:text-purple-400 border-purple-200 dark:border-purple-800 bg-purple-50 dark:bg-purple-900/20';
            default:
                return 'text-gray-600 dark:text-gray-400 border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800';
        }
    };
    const getPlatformIconUrl = (platform)=>(0, $c415184affb3c148$export$95bc294db34c3e24)(platform);
    const handlePlatformIconError = (platform)=>(e)=>{
            const el = e.currentTarget;
            const fallback = (0, $c415184affb3c148$export$91054406962f6412)(platform);
            if (fallback && el.src !== fallback) {
                el.src = fallback;
                return;
            }
            el.style.visibility = 'hidden';
        };
    if (!cheapestPrice) return /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
        className: "bg-white dark:bg-neutral-800 rounded-xl border border-neutral-200 dark:border-neutral-700 p-4 text-sm text-neutral-500",
        children: "No prices available"
    });
    return /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
        className: "bg-white dark:bg-neutral-800 rounded-xl border border-neutral-200 dark:border-neutral-700 overflow-hidden flex flex-col",
        children: [
            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                className: "relative aspect-square overflow-hidden bg-neutral-50 dark:bg-neutral-800",
                children: [
                    product.imageUrl ? /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("img", {
                        src: product.imageUrl,
                        alt: product.name,
                        width: 400,
                        height: 400,
                        className: "absolute inset-4 h-[calc(100%-2rem)] w-[calc(100%-2rem)] object-contain",
                        loading: "lazy",
                        decoding: "async",
                        onError: (e)=>{
                            e.target.src = $e2f42211602dbfa6$var$PLACEHOLDER_IMAGE;
                        }
                    }) : /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                        className: "absolute inset-0 flex items-center justify-center text-neutral-400",
                        children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("svg", {
                            className: "h-12 w-12 shrink-0",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24",
                            "aria-hidden": true,
                            children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: 1,
                                d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14"
                            })
                        })
                    }),
                    discountPct > 0 && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                        className: "absolute top-2 left-2 bg-yellow-400 text-neutral-900 text-xs font-semibold px-2 py-0.5 rounded",
                        children: [
                            discountPct,
                            "% off"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                className: "flex flex-1 flex-col p-3",
                children: [
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                        className: "mb-0.5 min-h-[1rem] text-xs text-neutral-500",
                        children: product.brand
                    }),
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("h3", {
                        className: "mb-1 min-h-[2.5rem] text-sm font-medium leading-snug text-neutral-900 line-clamp-2 dark:text-white",
                        children: product.name
                    }),
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                        className: "mb-3 min-h-[1rem] text-xs text-neutral-500",
                        children: product.quantity
                    }),
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                        className: "mb-3 flex flex-wrap items-center gap-1.5",
                        children: product.platformPrices.length >= 2 ? /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                            className: "text-[10px] font-semibold px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-300 dark:border-emerald-800",
                            children: [
                                "Compared (",
                                product.platformPrices.length,
                                ")"
                            ]
                        }) : /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                            className: "text-[10px] font-semibold px-2 py-0.5 rounded-full bg-neutral-50 text-neutral-700 border border-neutral-200 dark:bg-neutral-900/40 dark:text-neutral-300 dark:border-neutral-700",
                            children: "Not compared"
                        })
                    }),
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                        className: `mt-auto min-h-[4.75rem] rounded-lg border px-2.5 py-2.5 ${getPlatformColor(cheapestPrice.platform)} ring-1 ring-yellow-400/80`,
                        children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                            className: "flex gap-2",
                            children: [
                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                                    className: "mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white/80 ring-1 ring-black/5 dark:bg-neutral-700/80 dark:ring-white/10",
                                    children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("img", {
                                        src: getPlatformIconUrl(cheapestPrice.platform),
                                        alt: "",
                                        width: 24,
                                        height: 24,
                                        className: "h-full w-full object-contain",
                                        loading: "lazy",
                                        decoding: "async",
                                        referrerPolicy: "no-referrer",
                                        onError: handlePlatformIconError(cheapestPrice.platform)
                                    })
                                }),
                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                    className: "flex min-w-0 flex-1 flex-col items-end gap-0.5 text-right",
                                    children: [
                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                            className: "flex w-full items-center justify-end gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                                                    className: "text-base font-bold tabular-nums whitespace-nowrap",
                                                    children: [
                                                        "\u20B9",
                                                        cheapestPrice.price
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("a", {
                                                    href: (0, $f8724ca7633d3fc2$export$2a5744d9b5ca1c4d)(cheapestPrice.platform, product.name, cheapestPrice.productUrl, cheapestPrice.externalItemId),
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    className: "shrink-0 text-neutral-600 dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-white p-0.5",
                                                    title: "Open on app",
                                                    children: "\u2197"
                                                }),
                                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>onAddToCart(product, cheapestPrice.platform),
                                                    className: "shrink-0 w-7 h-7 flex items-center justify-center rounded-lg bg-neutral-200 dark:bg-neutral-600 hover:bg-yellow-400 hover:text-neutral-900 text-sm font-bold",
                                                    children: "+"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                                            className: "flex min-h-[1.125rem] w-full justify-end",
                                            children: cheapestPrice.deliveryTime ? /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)($e2f42211602dbfa6$var$DeliveryTimeLabel, {
                                                value: cheapestPrice.deliveryTime
                                            }) : null
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    otherPrices.length > 0 && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                        className: "mt-2",
                        children: [
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>setMenuOpen(!menuOpen),
                                className: "w-full flex items-center justify-between text-left text-xs font-medium text-neutral-600 dark:text-neutral-300 py-2 px-2 rounded-lg border border-neutral-200 dark:border-neutral-600 hover:bg-neutral-50 dark:hover:bg-neutral-800/80",
                                children: [
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                                        children: [
                                            "Other platforms (",
                                            otherPrices.length,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("svg", {
                                        className: `w-4 h-4 transition-transform ${menuOpen ? 'rotate-180' : ''}`,
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24",
                                        children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M19 9l-7 7-7-7"
                                        })
                                    })
                                ]
                            }),
                            menuOpen && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("ul", {
                                className: "mt-1 space-y-1 border border-neutral-100 dark:border-neutral-700 rounded-lg p-1.5 bg-neutral-50/80 dark:bg-neutral-900/50",
                                children: otherPrices.map((pp)=>/*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("li", {
                                        className: `flex items-start gap-2 py-1.5 px-2 rounded-md ${getPlatformColor(pp.platform)}`,
                                        children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                            className: "flex gap-1.5 min-w-0 flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                                                    className: "mt-0.5 inline-flex h-8 w-8 shrink-0 overflow-hidden rounded-full",
                                                    children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("img", {
                                                        src: getPlatformIconUrl(pp.platform),
                                                        alt: "",
                                                        width: 32,
                                                        height: 32,
                                                        className: "h-full w-full object-contain",
                                                        loading: "lazy",
                                                        decoding: "async",
                                                        referrerPolicy: "no-referrer",
                                                        onError: handlePlatformIconError(pp.platform)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                                    className: "min-w-0 flex-1 flex flex-col gap-0.5 items-end text-right",
                                                    children: [
                                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                                            className: "flex w-full items-center justify-end gap-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                                                                    className: "text-xs font-semibold tabular-nums whitespace-nowrap",
                                                                    children: [
                                                                        "\u20B9",
                                                                        pp.price
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("a", {
                                                                    href: (0, $f8724ca7633d3fc2$export$2a5744d9b5ca1c4d)(pp.platform, product.name, pp.productUrl, pp.externalItemId),
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    className: "shrink-0 text-neutral-600 dark:text-neutral-400 p-0.5",
                                                                    children: "\u2197"
                                                                }),
                                                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: ()=>onAddToCart(product, pp.platform),
                                                                    className: "shrink-0 w-6 h-6 flex items-center justify-center rounded bg-white/60 dark:bg-neutral-700 hover:bg-yellow-400 text-xs font-bold",
                                                                    children: "+"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                                                            className: "flex min-h-[1rem] w-full justify-end",
                                                            children: pp.deliveryTime ? /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)($e2f42211602dbfa6$var$DeliveryTimeLabel, {
                                                                value: pp.deliveryTime,
                                                                className: "text-[9px] text-neutral-500 dark:text-neutral-400"
                                                            }) : null
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, pp.platform))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                className: "px-3 py-2 bg-neutral-50 dark:bg-neutral-800/80 border-t border-neutral-100 dark:border-neutral-700 flex justify-between items-center text-xs",
                children: [
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                        className: "text-neutral-500",
                        children: "From"
                    }),
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                        className: "font-semibold tabular-nums text-yellow-600 dark:text-yellow-400",
                        children: [
                            "\u20B9",
                            cheapestPrice.price
                        ]
                    })
                ]
            })
        ]
    });
};
const $e2f42211602dbfa6$export$f0fd42021896dce9 = ()=>/*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
        className: "flex flex-col overflow-hidden rounded-xl border border-neutral-200 bg-white animate-pulse dark:border-neutral-700 dark:bg-neutral-800",
        children: [
            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                className: "aspect-square bg-neutral-100 dark:bg-neutral-700"
            }),
            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                className: "flex flex-1 flex-col gap-2 p-3",
                children: [
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                        className: "min-h-[1rem] w-14 rounded bg-neutral-200 dark:bg-neutral-600"
                    }),
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                        className: "min-h-[2.5rem] space-y-1.5",
                        children: [
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                                className: "h-3.5 w-full rounded bg-neutral-200 dark:bg-neutral-600"
                            }),
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                                className: "h-3.5 w-4/5 rounded bg-neutral-200 dark:bg-neutral-600"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                        className: "min-h-[1rem] w-24 rounded bg-neutral-200 dark:bg-neutral-600"
                    }),
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                        className: "h-5 w-28 rounded-full bg-neutral-200 dark:bg-neutral-600"
                    }),
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                        className: "mt-auto min-h-[4.75rem] rounded-lg bg-neutral-200 dark:bg-neutral-600"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                className: "flex h-10 items-center justify-between border-t border-neutral-100 bg-neutral-50 px-3 dark:border-neutral-700 dark:bg-neutral-800/80",
                children: [
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                        className: "h-3 w-8 rounded bg-neutral-200 dark:bg-neutral-600"
                    }),
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                        className: "h-3 w-14 rounded bg-neutral-200 dark:bg-neutral-600"
                    })
                ]
            })
        ]
    });
var $e2f42211602dbfa6$export$2e2bcd8739ae039 = $e2f42211602dbfa6$var$ProductCard;




var $5jV9H = parcelRequire("5jV9H");


var $5jV9H = parcelRequire("5jV9H");
const $b278c220d8f9e2d6$var$API_BASE = "https://api.valyux.in";
function $b278c220d8f9e2d6$var$isTransientBackendStatus(status) {
    return status === 502 || status === 503 || status === 504;
}
function $b278c220d8f9e2d6$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
function $b278c220d8f9e2d6$var$mergeTimeoutWithUserSignal(timeoutMs, userSignal) {
    const timeoutSignal = AbortSignal.timeout(timeoutMs);
    if (!userSignal) return timeoutSignal;
    if (typeof AbortSignal.any === 'function') return AbortSignal.any([
        timeoutSignal,
        userSignal
    ]);
    const c = new AbortController();
    const abort = ()=>{
        if (!c.signal.aborted) c.abort();
    };
    if (timeoutSignal.aborted || userSignal.aborted) {
        abort();
        return c.signal;
    }
    timeoutSignal.addEventListener('abort', abort, {
        once: true
    });
    userSignal.addEventListener('abort', abort, {
        once: true
    });
    return c.signal;
}
function $b278c220d8f9e2d6$var$isAbortError(e) {
    return e instanceof DOMException && e.name === 'AbortError' || e instanceof Error && e.name === 'AbortError';
}
async function $b278c220d8f9e2d6$export$ca0ec81f9ff33ad0(path, options = {}) {
    const { timeoutMs: timeoutMs = 20000, retries: retries = 2, backoffMs: backoffMs = 1200, signal: userSignal, ...init } = options;
    const url = path.startsWith('http') ? path : `${$b278c220d8f9e2d6$var$API_BASE}${path.startsWith('/') ? '' : '/'}${path}`;
    let lastErr = null;
    for(let attempt = 0; attempt <= retries; attempt++){
        if (userSignal?.aborted) throw new DOMException('Aborted', 'AbortError');
        try {
            const signal = $b278c220d8f9e2d6$var$mergeTimeoutWithUserSignal(timeoutMs, userSignal);
            const res = await fetch(url, {
                ...init,
                signal: signal
            });
            if ($b278c220d8f9e2d6$var$isTransientBackendStatus(res.status) && attempt < retries) {
                await $b278c220d8f9e2d6$var$sleep(backoffMs * Math.pow(1.8, attempt));
                continue;
            }
            return res;
        } catch (e) {
            lastErr = e;
            if (userSignal?.aborted) throw $b278c220d8f9e2d6$var$isAbortError(e) ? e : new DOMException('Aborted', 'AbortError');
            if ($b278c220d8f9e2d6$var$isAbortError(e)) {
                if (attempt < retries) {
                    await $b278c220d8f9e2d6$var$sleep(backoffMs * Math.pow(1.8, attempt));
                    continue;
                }
                throw new Error(`Backend is starting up \u{2014} please try again in 10\u{2013}15 seconds.`);
            }
            if (attempt < retries) {
                await $b278c220d8f9e2d6$var$sleep(backoffMs * Math.pow(1.8, attempt));
                continue;
            }
        }
    }
    const msg = lastErr instanceof Error ? lastErr.message : 'Backend unreachable';
    throw new Error(`Backend is starting up \u{2014} please try again in 10\u{2013}15 seconds.`);
}


async function $e008777dadf22ad2$export$be695d37caaa2a5f(pincode, signal) {
    const params = new URLSearchParams({
        pincode: pincode.trim()
    });
    const res = await (0, $b278c220d8f9e2d6$export$ca0ec81f9ff33ad0)(`/api/location/pincode-geocode?${params}`, {
        timeoutMs: 20000,
        retries: 2,
        signal: signal
    });
    if (!res.ok) {
        const err = await res.json().catch(()=>({}));
        throw new Error(err?.error || 'Could not locate pincode');
    }
    return res.json();
}



async function $82a7fb16635378a2$export$a781579ca247470(query, lat, lon, pincode) {
    const params = new URLSearchParams({
        q: query.trim(),
        lat: lat.trim(),
        lon: lon.trim(),
        pincode: pincode.trim()
    });
    const res = await (0, $b278c220d8f9e2d6$export$ca0ec81f9ff33ad0)(`/api/qc/groupsearch?${params}`, {
        timeoutMs: 90000,
        retries: 2
    });
    if (!res.ok) {
        const err = await res.json().catch(()=>({}));
        throw new Error(err?.message || err?.error || `Search failed (${res.status})`);
    }
    const data = await res.json();
    return {
        results: data.results || [],
        meta: data.meta || {
            totalResults: 0,
            fetchedAt: new Date().toISOString()
        }
    };
}
async function $82a7fb16635378a2$export$df1faf33d77bf83f(lat, lon, pincode, signal) {
    const params = new URLSearchParams({
        lat: lat.trim(),
        lon: lon.trim(),
        pincode: pincode.trim()
    });
    const res = await (0, $b278c220d8f9e2d6$export$ca0ec81f9ff33ad0)(`/api/qc/groupeta?${params}`, {
        timeoutMs: 30000,
        retries: 2,
        signal: signal
    });
    if (!res.ok) {
        // ETA is an enhancement for labels/filtering. Keep search usable on upstream hiccups.
        if (res.status >= 500) return {
            etaByPlatform: {},
            openByPlatform: {}
        };
        const err = await res.json().catch(()=>({}));
        throw new Error(err?.message || 'ETA failed');
    }
    const data = await res.json();
    return {
        etaByPlatform: data.etaByPlatform || {},
        openByPlatform: data.openByPlatform || {}
    };
}




var $5jV9H = parcelRequire("5jV9H");

async function $549d80f1a40ce8cc$export$52d87663d1da021e(query) {
    const q = query.trim();
    if (q.length < 3) return [];
    const params = new URLSearchParams({
        q: q
    });
    const res = await (0, $b278c220d8f9e2d6$export$ca0ec81f9ff33ad0)(`/api/location/autocomplete?${params}`, {
        timeoutMs: 20000,
        retries: 2
    });
    if (!res.ok) {
        const err = await res.json().catch(()=>({}));
        throw new Error(err?.message || `Address search failed (${res.status})`);
    }
    const data = await res.json();
    return Array.isArray(data.results) ? data.results : [];
}
async function $549d80f1a40ce8cc$export$f4666fc7f52a0aa8(lat, lon, signal) {
    const params = new URLSearchParams({
        lat: String(lat),
        lon: String(lon)
    });
    const res = await (0, $b278c220d8f9e2d6$export$ca0ec81f9ff33ad0)(`/api/location/reverse?${params}`, {
        timeoutMs: 20000,
        retries: 2,
        signal: signal
    });
    if (!res.ok) {
        const err = await res.json().catch(()=>({}));
        const msg = err?.message || err?.error || `Reverse geocode failed (${res.status})`;
        const retryAfter = err?.retryAfterSeconds;
        throw new Error(retryAfter ? `${msg} (try again in ~${retryAfter}s)` : msg);
    }
    return res.json();
}



function $1dbff0aa5bfa1cb5$var$isAbortError(e) {
    return e instanceof DOMException && e.name === 'AbortError' || e instanceof Error && e.name === 'AbortError';
}
const $1dbff0aa5bfa1cb5$var$STORAGE_KEY = 'valyux-location';
const $1dbff0aa5bfa1cb5$var$LEGACY_PINCODE_KEY = 'valyux-pincode';
function $1dbff0aa5bfa1cb5$export$78e365a0b3acf41b() {
    if (typeof window === 'undefined') return {
        pincode: '',
        addressLabel: ''
    };
    try {
        const raw = localStorage.getItem($1dbff0aa5bfa1cb5$var$STORAGE_KEY);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed.pincode && /^\d{6}$/.test(parsed.pincode)) return {
                pincode: parsed.pincode,
                addressLabel: typeof parsed.addressLabel === 'string' ? parsed.addressLabel : '',
                lat: typeof parsed.lat === 'string' && parsed.lat ? parsed.lat : undefined,
                lon: typeof parsed.lon === 'string' && parsed.lon ? parsed.lon : undefined
            };
        }
    } catch  {
    /* ignore */ }
    const legacy = localStorage.getItem($1dbff0aa5bfa1cb5$var$LEGACY_PINCODE_KEY);
    if (legacy && /^\d{6}$/.test(legacy.trim())) return {
        pincode: legacy.trim(),
        addressLabel: '',
        lat: undefined,
        lon: undefined
    };
    return {
        pincode: '',
        addressLabel: ''
    };
}
function $1dbff0aa5bfa1cb5$export$fe9ec8db39d8b5c2(loc) {
    if (typeof window === 'undefined') return;
    localStorage.setItem($1dbff0aa5bfa1cb5$var$STORAGE_KEY, JSON.stringify(loc));
    try {
        localStorage.removeItem($1dbff0aa5bfa1cb5$var$LEGACY_PINCODE_KEY);
    } catch  {
    /* ignore */ }
}
function $1dbff0aa5bfa1cb5$export$208c6df502389a6c() {
    return $1dbff0aa5bfa1cb5$export$78e365a0b3acf41b().pincode;
}
function $1dbff0aa5bfa1cb5$export$7108ad49865458f4(pincode) {
    $1dbff0aa5bfa1cb5$export$fe9ec8db39d8b5c2({
        pincode: pincode.trim(),
        addressLabel: ''
    });
}
const $1dbff0aa5bfa1cb5$export$55d05cc2d01dc042 = ({ onConfirm: onConfirm })=>{
    const [manualPincode, setManualPincode] = (0, $5jV9H.useState)('');
    const [geoLoading, setGeoLoading] = (0, $5jV9H.useState)(false);
    const [geoError, setGeoError] = (0, $5jV9H.useState)(null);
    const [confirmUseLocation, setConfirmUseLocation] = (0, $5jV9H.useState)(false);
    const [error, setError] = (0, $5jV9H.useState)('');
    const [manualLoading, setManualLoading] = (0, $5jV9H.useState)(false);
    const locateAbortRef = (0, $5jV9H.useRef)(null);
    const startLocateRequest = ()=>{
        locateAbortRef.current?.abort();
        locateAbortRef.current = new AbortController();
        return locateAbortRef.current.signal;
    };
    (0, $5jV9H.useEffect)(()=>()=>locateAbortRef.current?.abort(), []);
    const requestCurrentLocation = ()=>{
        setGeoError(null);
        if (typeof navigator === 'undefined' || !navigator.geolocation) {
            setGeoError('Geolocation is not supported in this browser');
            return;
        }
        const signal = startLocateRequest();
        setGeoLoading(true);
        navigator.geolocation.getCurrentPosition(async (pos)=>{
            try {
                if (signal.aborted) return;
                const lat = pos.coords.latitude;
                const lon = pos.coords.longitude;
                const geo = await (0, $549d80f1a40ce8cc$export$f4666fc7f52a0aa8)(lat, lon, signal);
                if (signal.aborted) return;
                const loc = {
                    pincode: geo.pincode,
                    addressLabel: geo.addressLabel || `Pincode ${geo.pincode}`,
                    lat: geo.lat,
                    lon: geo.lon
                };
                $1dbff0aa5bfa1cb5$export$fe9ec8db39d8b5c2(loc);
                onConfirm(loc);
            } catch (err) {
                if ($1dbff0aa5bfa1cb5$var$isAbortError(err)) return;
                setGeoError(err instanceof Error ? err.message : 'Could not fetch your current location');
            } finally{
                if (!signal.aborted) setGeoLoading(false);
            }
        }, (e)=>{
            setGeoLoading(false);
            const msg = e.code === e.PERMISSION_DENIED ? 'Location permission denied' : 'Could not access your location';
            setGeoError(msg);
        }, {
            enableHighAccuracy: true,
            timeout: 15000,
            maximumAge: 0
        });
    };
    const handleUseCurrentLocation = ()=>setConfirmUseLocation(true);
    const handleManualSubmit = async (e)=>{
        e.preventDefault();
        const trimmed = manualPincode.replace(/\D/g, '');
        if (!trimmed) {
            setError('Enter a 6-digit pincode');
            return;
        }
        if (!/^\d{6}$/.test(trimmed)) {
            setError('Pincode must be 6 digits');
            return;
        }
        setError('');
        const signal = startLocateRequest();
        setManualLoading(true);
        try {
            const geo = await (0, $e008777dadf22ad2$export$be695d37caaa2a5f)(trimmed, signal);
            if (signal.aborted) return;
            const loc = {
                pincode: trimmed,
                addressLabel: geo.label || `Pincode ${trimmed}`,
                lat: geo.lat,
                lon: geo.lon
            };
            $1dbff0aa5bfa1cb5$export$fe9ec8db39d8b5c2(loc);
            onConfirm(loc);
        } catch (err) {
            if ($1dbff0aa5bfa1cb5$var$isAbortError(err)) return;
            setError(err instanceof Error ? err.message : 'Could not find this pincode on the map');
        } finally{
            if (!signal.aborted) setManualLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
        className: "fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 dark:bg-black/60 p-4",
        children: [
            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                className: "bg-white dark:bg-neutral-900 rounded-2xl shadow-xl max-w-lg w-full max-h-[90vh] flex flex-col border border-neutral-200 dark:border-neutral-700",
                role: "dialog",
                "aria-labelledby": "location-title",
                children: [
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                        className: "p-5 pb-3 border-b border-neutral-100 dark:border-neutral-800",
                        children: [
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("h2", {
                                id: "location-title",
                                className: "text-lg font-bold text-neutral-900 dark:text-white",
                                children: "Where should we deliver?"
                            }),
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                                className: "text-sm text-neutral-500 dark:text-neutral-400 mt-1",
                                children: "Enter your pincode (or use current location). We use it for prices and delivery."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                        className: "p-5 flex-1 overflow-y-auto space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                className: "rounded-xl border border-neutral-200 dark:border-neutral-700 bg-neutral-50/70 dark:bg-neutral-800/40 p-3",
                                children: [
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                                        type: "button",
                                        onClick: handleUseCurrentLocation,
                                        disabled: geoLoading,
                                        className: "w-full py-3 bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 rounded-xl font-semibold text-neutral-900 dark:text-white disabled:opacity-60",
                                        children: geoLoading ? "Getting location\u2026" : 'Use current location'
                                    }),
                                    geoError && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                                        className: "mt-2 text-xs text-amber-700 dark:text-amber-400",
                                        children: geoError
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("form", {
                                onSubmit: handleManualSubmit,
                                className: "space-y-3 pt-1",
                                children: [
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                                        className: "text-xs text-neutral-500",
                                        children: "6-digit India pincode"
                                    }),
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("input", {
                                        type: "text",
                                        inputMode: "numeric",
                                        maxLength: 6,
                                        placeholder: "e.g. 560001",
                                        value: manualPincode,
                                        onChange: (e)=>{
                                            setManualPincode(e.target.value.replace(/\D/g, ''));
                                            setError('');
                                        },
                                        className: "w-full px-4 py-3 text-center text-lg font-medium tracking-widest rounded-xl border border-neutral-200 dark:border-neutral-600 bg-neutral-50 dark:bg-neutral-800 outline-none focus:border-yellow-500"
                                    }),
                                    error && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                                        className: "text-red-500 text-sm text-center",
                                        children: error
                                    }),
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                                        type: "submit",
                                        disabled: manualLoading,
                                        className: "w-full py-3 bg-yellow-400 hover:bg-yellow-500 text-neutral-900 font-semibold rounded-xl disabled:opacity-60",
                                        children: manualLoading ? "Locating\u2026" : 'Continue with pincode'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            confirmUseLocation && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                className: "fixed inset-0 z-[10000] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4",
                children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                    className: "w-full max-w-sm rounded-2xl border border-neutral-200 bg-white p-4 shadow-2xl dark:border-neutral-700 dark:bg-neutral-950",
                    children: [
                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("h3", {
                            className: "text-base font-bold text-neutral-900 dark:text-white",
                            children: "Allow current location?"
                        }),
                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                            className: "mt-2 text-sm text-neutral-600 dark:text-neutral-300",
                            children: "We will use your location to show live grocery prices near you."
                        }),
                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                            className: "mt-4 flex gap-2",
                            children: [
                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>{
                                        try {
                                            setConfirmUseLocation(false);
                                        } catch  {}
                                        requestCurrentLocation();
                                    },
                                    disabled: geoLoading,
                                    className: "flex-1 py-3 rounded-xl font-semibold bg-yellow-400 hover:bg-yellow-500 text-neutral-900 disabled:opacity-60",
                                    children: geoLoading ? "Getting\u2026" : 'Allow'
                                }),
                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setConfirmUseLocation(false),
                                    className: "flex-1 py-3 rounded-xl font-semibold bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100",
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


const $24dcc62c2df3455e$var$PincodeContext = /*#__PURE__*/ (0, $5jV9H.createContext)(null);
function $24dcc62c2df3455e$var$isAbortError(e) {
    return e instanceof DOMException && e.name === 'AbortError' || e instanceof Error && e.name === 'AbortError';
}
function $24dcc62c2df3455e$export$7025bb4dd876b4d2({ children: children }) {
    const [location, setLocationState] = (0, $5jV9H.useState)(()=>(0, $1dbff0aa5bfa1cb5$export$78e365a0b3acf41b)());
    const [etaByPlatform, setEtaByPlatform] = (0, $5jV9H.useState)({});
    const [openByPlatform, setOpenByPlatform] = (0, $5jV9H.useState)({});
    const [etaLoading, setEtaLoading] = (0, $5jV9H.useState)(false);
    const [etaError, setEtaError] = (0, $5jV9H.useState)(null);
    (0, $5jV9H.useEffect)(()=>{
        setLocationState((0, $1dbff0aa5bfa1cb5$export$78e365a0b3acf41b)());
    }, []);
    const setDeliveryLocation = (0, $5jV9H.useCallback)((loc)=>{
        const pin = loc.pincode.trim();
        const label = (loc.addressLabel || '').trim();
        const lat = (loc.lat || '').trim();
        const lon = (loc.lon || '').trim();
        const next = {
            pincode: pin,
            addressLabel: label,
            lat: lat || undefined,
            lon: lon || undefined
        };
        (0, $1dbff0aa5bfa1cb5$export$fe9ec8db39d8b5c2)(next);
        setLocationState(next);
        setEtaByPlatform({});
        setOpenByPlatform({});
        setEtaError(null);
    }, []);
    /** Backfill coordinates for saved sessions that only had pincode */ (0, $5jV9H.useEffect)(()=>{
        if (!/^\d{6}$/.test(location.pincode)) return;
        if (location.lat && location.lon) return;
        const ac = new AbortController();
        (0, $e008777dadf22ad2$export$be695d37caaa2a5f)(location.pincode, ac.signal).then((g)=>{
            setLocationState((prev)=>{
                if (prev.pincode !== location.pincode) return prev;
                const next = {
                    ...prev,
                    lat: g.lat,
                    lon: g.lon
                };
                (0, $1dbff0aa5bfa1cb5$export$fe9ec8db39d8b5c2)(next);
                return next;
            });
        }).catch((e)=>{
            if (ac.signal.aborted || $24dcc62c2df3455e$var$isAbortError(e)) return;
        /* non-fatal: user can re-open location */ });
        return ()=>ac.abort();
    }, [
        location.pincode,
        location.lat,
        location.lon
    ]);
    (0, $5jV9H.useEffect)(()=>{
        if (!/^\d{6}$/.test(location.pincode)) return;
        if (!location.lat || !location.lon) return;
        const ac = new AbortController();
        setEtaLoading(true);
        setEtaError(null);
        (0, $82a7fb16635378a2$export$df1faf33d77bf83f)(location.lat, location.lon, location.pincode, ac.signal).then(({ etaByPlatform: eta, openByPlatform: open })=>{
            setEtaByPlatform(eta);
            setOpenByPlatform(open);
        }).catch((e)=>{
            if (ac.signal.aborted || $24dcc62c2df3455e$var$isAbortError(e)) return;
            setEtaError(e instanceof Error ? e.message : 'Could not load delivery times');
            setEtaByPlatform({});
            setOpenByPlatform({});
        }).finally(()=>{
            if (!ac.signal.aborted) setEtaLoading(false);
        });
        return ()=>ac.abort();
    }, [
        location.pincode,
        location.lat,
        location.lon
    ]);
    const hasCoords = Boolean(location.lat && location.lon && !Number.isNaN(Number(location.lat)) && !Number.isNaN(Number(location.lon)));
    return /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)($24dcc62c2df3455e$var$PincodeContext.Provider, {
        value: {
            pincode: location.pincode,
            addressLabel: location.addressLabel,
            lat: location.lat || '',
            lon: location.lon || '',
            etaByPlatform: etaByPlatform,
            openByPlatform: openByPlatform,
            etaLoading: etaLoading,
            etaError: etaError,
            setDeliveryLocation: setDeliveryLocation,
            hasPincode: /^\d{6}$/.test(location.pincode),
            hasCoords: hasCoords
        },
        children: children
    });
}
function $24dcc62c2df3455e$export$8334c7d775399ded() {
    const ctx = (0, $5jV9H.useContext)($24dcc62c2df3455e$var$PincodeContext);
    if (!ctx) throw new Error('usePincode must be used within PincodeProvider');
    return ctx;
}




const $2a47d05e44508b29$var$PLATFORM_ICONS = {
    JioMart: (0, $c415184affb3c148$export$95bc294db34c3e24)('JioMart'),
    Blinkit: (0, $c415184affb3c148$export$95bc294db34c3e24)('Blinkit'),
    Instamart: (0, $c415184affb3c148$export$95bc294db34c3e24)('Instamart'),
    Zepto: (0, $c415184affb3c148$export$95bc294db34c3e24)('Zepto')
};
const $2a47d05e44508b29$var$CartDrawer = ({ items: items, onClose: onClose, onUpdateQuantity: onUpdateQuantity })=>{
    const { openByPlatform: openByPlatform } = (0, $24dcc62c2df3455e$export$8334c7d775399ded)();
    const [showCheckoutMessage, setShowCheckoutMessage] = (0, $5jV9H.useState)(false);
    const normalizeNameForCompare = (s)=>(s || '').toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
    const normalizeQtyForCompare = (q)=>(q || '').toLowerCase().replace(/\s+/g, '').replace(/\.0+(?=\D|$)/g, '').trim();
    const tokenSimilarity = (a, b)=>{
        const ta = a.split(' ').filter(Boolean);
        const tb = b.split(' ').filter(Boolean);
        if (ta.length === 0 || tb.length === 0) return 0;
        if (a === b) return 1;
        if (a.includes(b) || b.includes(a)) return 1;
        const setA = new Set(ta);
        const setB = new Set(tb);
        let inter = 0;
        for (const t of setA)if (setB.has(t)) inter += 1;
        return inter / Math.max(setA.size, setB.size);
    };
    const itemCount = items.reduce((acc, i)=>acc + i.quantity, 0);
    const platformTotals = (0, $5jV9H.useMemo)(()=>{
        const totals = {
            JioMart: 0,
            Blinkit: 0,
            Instamart: 0,
            Zepto: 0
        };
        const openPlatforms = [
            'JioMart',
            'Blinkit',
            'Instamart',
            'Zepto'
        ].filter((p)=>openByPlatform[p] !== false);
        items.forEach((item)=>{
            openPlatforms.forEach((platform)=>{
                const priceObj = item.product.platformPrices.find((pp)=>pp.platform === platform);
                if (priceObj) totals[platform] += priceObj.price * item.quantity;
            });
        });
        return totals;
    }, [
        items,
        openByPlatform
    ]);
    const cheapestPlatform = (0, $5jV9H.useMemo)(()=>{
        if (items.length === 0) return null;
        const openPlatforms = [
            'JioMart',
            'Blinkit',
            'Instamart',
            'Zepto'
        ].filter((p)=>openByPlatform[p] !== false);
        let minPlatform = null;
        let minTotal = Infinity;
        openPlatforms.forEach((platform)=>{
            const total = platformTotals[platform];
            if (total > 0 && total < minTotal) {
                minTotal = total;
                minPlatform = platform;
            }
        });
        return minPlatform ? {
            platform: minPlatform,
            total: minTotal
        } : null;
    }, [
        platformTotals,
        items,
        openByPlatform
    ]);
    const linePrice = (item)=>item.product.platformPrices.find((pp)=>pp.platform === item.selectedPlatform)?.price || 0;
    const groceryTotal = items.reduce((acc, item)=>acc + linePrice(item) * item.quantity, 0);
    const FREE_DELIVERY_THRESHOLD = 200;
    const DELIVERY_FEE = 30;
    const deliveryFee = groceryTotal >= FREE_DELIVERY_THRESHOLD ? 0 : DELIVERY_FEE;
    const totalWithDelivery = groceryTotal + deliveryFee;
    const cheapestPlatformDeliveryFee = cheapestPlatform ? cheapestPlatform.total >= FREE_DELIVERY_THRESHOLD ? 0 : DELIVERY_FEE : 0;
    const cheapestPlatformTotalWithDelivery = cheapestPlatform ? cheapestPlatform.total + cheapestPlatformDeliveryFee : 0;
    const openLink = (item)=>{
        const offer = item.product.platformPrices.find((p)=>p.platform === item.selectedPlatform);
        const url = (0, $f8724ca7633d3fc2$export$2a5744d9b5ca1c4d)(item.selectedPlatform, item.product.name, offer?.productUrl, offer?.externalItemId);
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    return /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
        className: "fixed inset-0 z-50 flex justify-end",
        children: [
            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                className: "absolute inset-0 bg-black/40 dark:bg-black/60 backdrop-blur-sm",
                onClick: onClose
            }),
            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                className: "relative w-full max-w-md h-full flex flex-col bg-white dark:bg-neutral-950 shadow-2xl transition-colors duration-300",
                children: [
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                        className: "p-4 border-b border-neutral-200 dark:border-neutral-800 flex justify-between items-center bg-white dark:bg-neutral-950 sticky top-0 z-10 shrink-0",
                        children: [
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("h2", {
                                className: "text-lg font-bold text-neutral-900 dark:text-white",
                                children: [
                                    "Grocery Cart (",
                                    itemCount,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                                onClick: onClose,
                                className: "p-2 hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-full transition-colors",
                                children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("svg", {
                                    className: "w-6 h-6 text-neutral-600 dark:text-neutral-400",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24",
                                    children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M6 18L18 6M6 6l12 12"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                        className: "flex-1 overflow-y-auto p-4 space-y-4 bg-white dark:bg-neutral-950 min-h-0",
                        children: [
                            items.length === 0 ? /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                className: "flex flex-col items-center justify-center h-64 text-neutral-400 dark:text-neutral-500",
                                children: [
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("svg", {
                                        className: "w-16 h-16 mb-4 opacity-20",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24",
                                        children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                                        children: "Your basket is empty"
                                    })
                                ]
                            }) : (()=>{
                                const groups = [];
                                for (const item of items){
                                    const itemName = normalizeNameForCompare(item.product.name);
                                    const itemBrand = normalizeNameForCompare(item.product.brand || '');
                                    const target = groups.find((g)=>{
                                        const gName = normalizeNameForCompare(g.canonicalName);
                                        const sim = tokenSimilarity(itemName, gName);
                                        if (sim < 0.72) return false;
                                        const gBrand = normalizeNameForCompare(g.canonicalBrand || '');
                                        if (itemBrand && gBrand && itemBrand !== gBrand) return false;
                                        return true;
                                    });
                                    if (!target) groups.push({
                                        canonicalName: item.product.name,
                                        canonicalBrand: item.product.brand || '',
                                        items: [
                                            item
                                        ]
                                    });
                                    else target.items.push(item);
                                }
                                return groups.map((group)=>{
                                    const brandPrefix = group.canonicalBrand ? `${group.canonicalBrand} \xb7 ` : '';
                                    const variantQtys = Array.from(new Set(group.items.map((it)=>normalizeQtyForCompare(it.product.quantity)))).filter(Boolean);
                                    return /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                                className: "rounded-lg border border-neutral-200 bg-neutral-50 p-3 dark:border-neutral-800 dark:bg-neutral-900",
                                                children: [
                                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("h4", {
                                                        className: "text-sm font-semibold text-neutral-900 dark:text-neutral-100",
                                                        children: [
                                                            brandPrefix,
                                                            group.canonicalName
                                                        ]
                                                    }),
                                                    variantQtys.length > 0 && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("p", {
                                                        className: "text-xs text-neutral-500 dark:text-neutral-400 mt-1",
                                                        children: [
                                                            "Variants:",
                                                            ' ',
                                                            variantQtys.map((q)=>group.items.find((it)=>normalizeQtyForCompare(it.product.quantity) === q)?.product.quantity || q).join(" \xb7 ")
                                                        ]
                                                    })
                                                ]
                                            }),
                                            group.items.map((item)=>/*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                                    className: "flex gap-4 rounded-lg border border-neutral-200 bg-neutral-50 p-3 shadow-sm dark:border-neutral-800 dark:bg-neutral-900",
                                                    children: [
                                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("img", {
                                                            src: item.product.imageUrl,
                                                            alt: item.product.name,
                                                            className: "h-20 w-20 rounded object-contain bg-white dark:bg-neutral-950"
                                                        }),
                                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                                            className: "min-w-0 flex-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("h4", {
                                                                    className: "truncate text-sm font-semibold text-neutral-900 dark:text-neutral-100",
                                                                    children: group.canonicalName
                                                                }),
                                                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("p", {
                                                                    className: "mb-1 text-xs text-neutral-500 dark:text-neutral-400",
                                                                    children: [
                                                                        item.product.quantity,
                                                                        " \xb7 Cart: ",
                                                                        item.selectedPlatform
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                                                    className: "flex flex-wrap items-center justify-between gap-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                                                                            className: "text-sm font-bold text-neutral-900 dark:text-white",
                                                                            children: [
                                                                                "\u20B9",
                                                                                linePrice(item)
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                                                            className: "flex items-center gap-2",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("button", {
                                                                                    type: "button",
                                                                                    onClick: ()=>openLink(item),
                                                                                    className: "flex items-center gap-0.5 text-[10px] font-bold text-indigo-600 hover:underline dark:text-indigo-400",
                                                                                    children: [
                                                                                        "Open ",
                                                                                        item.selectedPlatform,
                                                                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("svg", {
                                                                                            className: "h-3 w-3",
                                                                                            fill: "none",
                                                                                            stroke: "currentColor",
                                                                                            viewBox: "0 0 24 24",
                                                                                            children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("path", {
                                                                                                strokeLinecap: "round",
                                                                                                strokeLinejoin: "round",
                                                                                                strokeWidth: 2,
                                                                                                d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                                                                    className: "flex items-center gap-0 rounded-lg border border-neutral-200 bg-white px-2 py-1 dark:border-neutral-700 dark:bg-neutral-800",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                                                                                            onClick: ()=>onUpdateQuantity(item.product.id, item.selectedPlatform, -1),
                                                                                            className: "flex h-6 w-6 items-center justify-center text-xl font-bold text-neutral-600 dark:text-neutral-300",
                                                                                            children: "-"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                                                                                            className: "w-4 text-center text-sm font-bold text-neutral-900 dark:text-white",
                                                                                            children: item.quantity
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                                                                                            onClick: ()=>onUpdateQuantity(item.product.id, item.selectedPlatform, 1),
                                                                                            className: "flex h-6 w-6 items-center justify-center text-xl font-bold text-neutral-600 dark:text-neutral-300",
                                                                                            children: "+"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, `${item.product.id}-${item.selectedPlatform}`))
                                        ]
                                    }, `group-${group.canonicalName}`);
                                });
                            })(),
                            items.length > 0 && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                                className: "mt-4 rounded-xl border border-neutral-200 bg-neutral-50 p-4 dark:border-neutral-700 dark:bg-neutral-900/80",
                                children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                    className: "flex items-start gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                                            className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-yellow-400/90 text-neutral-900",
                                            children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("svg", {
                                                className: "h-5 w-5",
                                                fill: "none",
                                                stroke: "currentColor",
                                                viewBox: "0 0 24 24",
                                                children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    strokeWidth: 2,
                                                    d: "M13 10V3L4 14h7v7l9-11h-7z"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                            className: "min-w-0 flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                                    className: "flex flex-wrap items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("h3", {
                                                            className: "text-sm font-bold text-neutral-900 dark:text-white",
                                                            children: "Smart Buy Cart"
                                                        }),
                                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                                                            className: "rounded-full bg-neutral-200 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-neutral-600 dark:bg-neutral-700 dark:text-neutral-300",
                                                            children: "Soon"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("p", {
                                                    className: "mt-1 text-xs leading-relaxed text-neutral-600 dark:text-neutral-400",
                                                    children: [
                                                        "One-tap optimized checkout is on the way. For now, use ",
                                                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("strong", {
                                                            children: "Open"
                                                        }),
                                                        " on each line to buy on the app you chose."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                        className: "shrink-0 border-t border-neutral-200 bg-white p-4 shadow-[0_-4px_10px_rgba(0,0,0,0.05)] dark:border-neutral-800 dark:bg-neutral-950 dark:shadow-[0_-4px_10px_rgba(0,0,0,0.35)]",
                        children: [
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                className: "mb-4 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                                                className: "block text-xs font-medium text-neutral-500 dark:text-neutral-400",
                                                children: "Total"
                                            }),
                                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                                                className: "text-xl font-black text-neutral-900 dark:text-white",
                                                children: [
                                                    "\u20B9",
                                                    totalWithDelivery.toFixed(2)
                                                ]
                                            })
                                        ]
                                    }),
                                    cheapestPlatform && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                        className: "text-right",
                                        children: [
                                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                                                className: "block text-[10px] font-bold uppercase text-green-600 dark:text-green-400",
                                                children: "Best Single Price"
                                            }),
                                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                                                className: "text-sm font-bold text-neutral-800 dark:text-neutral-200",
                                                children: [
                                                    "\u20B9",
                                                    cheapestPlatformTotalWithDelivery.toFixed(2)
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                className: "space-y-2",
                                children: [
                                    showCheckoutMessage && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                        className: "rounded-lg border border-amber-300 bg-amber-50 dark:border-amber-700 dark:bg-amber-950/40 p-3 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                                                className: "font-medium text-amber-900 dark:text-amber-100",
                                                children: "This only works in app \u2014 coming soon."
                                            }),
                                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                                                className: "mt-1 text-amber-800 dark:text-amber-200/90",
                                                children: 'Till then, use the "Open" links above each item to add products to your cart in the respective app.'
                                            }),
                                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setShowCheckoutMessage(false),
                                                className: "mt-2 text-xs font-semibold text-amber-700 dark:text-amber-300 underline",
                                                children: "Dismiss"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                                        className: "rounded-lg border border-neutral-200 bg-neutral-50 dark:border-neutral-800 dark:bg-neutral-900/30 p-2",
                                        children: deliveryFee === 0 ? /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("p", {
                                            className: "text-center text-[10px] font-medium text-neutral-800 dark:text-neutral-200",
                                            children: [
                                                "Delivery charge removed (free over \u20B9",
                                                FREE_DELIVERY_THRESHOLD,
                                                ")"
                                            ]
                                        }) : /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("p", {
                                            className: "text-center text-[10px] font-medium text-neutral-800 dark:text-neutral-200",
                                            children: [
                                                "Delivery: \u20B9",
                                                DELIVERY_FEE,
                                                " \xb7 Add \u20B9",
                                                Math.max(0, Math.ceil(FREE_DELIVERY_THRESHOLD - groceryTotal)),
                                                " more to remove delivery charge"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("button", {
                                        type: "button",
                                        disabled: items.length === 0,
                                        onClick: ()=>items.length > 0 && setShowCheckoutMessage(true),
                                        className: "flex w-full flex-col items-center justify-center gap-1 rounded-xl bg-yellow-400 py-4 font-bold text-neutral-900 transition-colors hover:bg-yellow-500 disabled:bg-neutral-200 disabled:text-neutral-400 dark:disabled:bg-neutral-800 dark:disabled:text-neutral-500",
                                        children: [
                                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("svg", {
                                                        className: "w-5 h-5",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        viewBox: "0 0 24 24",
                                                        children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: 2,
                                                            d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                                                        children: [
                                                            "Browse checkout on ",
                                                            cheapestPlatform?.platform || 'Platform'
                                                        ]
                                                    })
                                                ]
                                            }),
                                            cheapestPlatform && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                                                className: "text-[10px] font-medium opacity-70 flex items-center gap-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("img", {
                                                        src: $2a47d05e44508b29$var$PLATFORM_ICONS[cheapestPlatform.platform],
                                                        alt: "",
                                                        className: "w-3 h-3 rounded-full"
                                                    }),
                                                    "Cheapest single-app total: \u20B9",
                                                    cheapestPlatform.total.toFixed(2)
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                                        className: "text-center text-[10px] font-medium text-neutral-500 dark:text-neutral-400 px-1",
                                        children: 'Checkout in app \u2014 coming soon. Use the "Open" links above to add items.'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $2a47d05e44508b29$export$2e2bcd8739ae039 = $2a47d05e44508b29$var$CartDrawer;








var $5jV9H = parcelRequire("5jV9H");
function $c1d2ccc0dc6c2950$export$21805fee57372823(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, $5jV9H.useState)(value);
    (0, $5jV9H.useEffect)(()=>{
        const timer = setTimeout(()=>setDebouncedValue(value), delay);
        return ()=>clearTimeout(timer);
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}


const $2c088e6e7f3e7a96$var$GROCERY_CART = 'valyux-grocery-cart';
const $2c088e6e7f3e7a96$var$GROCERY_SEARCH = 'valyux-grocery-search';
const $2c088e6e7f3e7a96$var$PLATFORMS = [
    'JioMart',
    'Blinkit',
    'Instamart',
    'Zepto'
];
function $2c088e6e7f3e7a96$var$isPlatform(x) {
    return typeof x === 'string' && $2c088e6e7f3e7a96$var$PLATFORMS.includes(x);
}
function $2c088e6e7f3e7a96$var$parsePlatformPrice(raw) {
    if (!raw || typeof raw !== 'object') return null;
    const o = raw;
    if (!$2c088e6e7f3e7a96$var$isPlatform(o.platform)) return null;
    return {
        platform: o.platform,
        price: Number(o.price) || 0,
        originalPrice: Number(o.originalPrice) || 0,
        deliveryTime: typeof o.deliveryTime === 'string' ? o.deliveryTime : "\u2014",
        productUrl: typeof o.productUrl === 'string' ? o.productUrl : undefined,
        externalItemId: typeof o.externalItemId === 'string' ? o.externalItemId : undefined
    };
}
function $2c088e6e7f3e7a96$var$parseProduct(raw) {
    if (!raw || typeof raw !== 'object') return null;
    const o = raw;
    const id = typeof o.id === 'string' ? o.id : '';
    const name = typeof o.name === 'string' ? o.name : '';
    if (!id || !name) return null;
    const pps = Array.isArray(o.platformPrices) ? o.platformPrices.map($2c088e6e7f3e7a96$var$parsePlatformPrice).filter(Boolean) : [];
    return {
        id: id,
        name: name,
        brand: typeof o.brand === 'string' ? o.brand : '',
        quantity: typeof o.quantity === 'string' ? o.quantity : '',
        imageUrl: typeof o.imageUrl === 'string' ? o.imageUrl : '',
        category: typeof o.category === 'string' ? o.category : 'Other',
        platformPrices: pps
    };
}
function $2c088e6e7f3e7a96$var$parseCartItem(raw) {
    if (!raw || typeof raw !== 'object') return null;
    const o = raw;
    const product = $2c088e6e7f3e7a96$var$parseProduct(o.product);
    if (!product || !$2c088e6e7f3e7a96$var$isPlatform(o.selectedPlatform)) return null;
    const quantity = Number(o.quantity);
    if (!Number.isFinite(quantity) || quantity < 1) return null;
    return {
        product: product,
        selectedPlatform: o.selectedPlatform,
        quantity: Math.floor(quantity)
    };
}
function $2c088e6e7f3e7a96$var$readJson(key) {
    if (typeof window === 'undefined') return null;
    try {
        const raw = localStorage.getItem(key);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch  {
        return null;
    }
}
function $2c088e6e7f3e7a96$export$a822875dec294e4d() {
    const parsed = $2c088e6e7f3e7a96$var$readJson($2c088e6e7f3e7a96$var$GROCERY_CART);
    if (!Array.isArray(parsed)) return [];
    return parsed.map($2c088e6e7f3e7a96$var$parseCartItem).filter((x)=>x !== null);
}
function $2c088e6e7f3e7a96$export$94666d3983dc6b91(items) {
    if (typeof window === 'undefined') return;
    try {
        localStorage.setItem($2c088e6e7f3e7a96$var$GROCERY_CART, JSON.stringify(items));
    } catch  {
    /* ignore quota / private mode */ }
}
function $2c088e6e7f3e7a96$export$80b058555503f6da() {
    if (typeof window === 'undefined') return '';
    try {
        const raw = localStorage.getItem($2c088e6e7f3e7a96$var$GROCERY_SEARCH);
        return typeof raw === 'string' ? raw : '';
    } catch  {
        return '';
    }
}
function $2c088e6e7f3e7a96$export$3b7c368697f35c3d(q) {
    if (typeof window === 'undefined') return;
    try {
        localStorage.setItem($2c088e6e7f3e7a96$var$GROCERY_SEARCH, q);
    } catch  {
    /* ignore */ }
}



parcelRequire("5jV9H");


const $2b7ad95a2c11b3ea$var$GROCERY_PLATFORMS = [
    {
        platform: 'JioMart',
        label: 'JioMart'
    },
    {
        platform: 'Blinkit',
        label: 'Blinkit'
    },
    {
        platform: 'Instamart',
        label: 'Swiggy Instamart'
    },
    {
        platform: 'Zepto',
        label: 'Zepto'
    }
];
/**
 * Platform logos with delivery ETA under each (from QuickCommerce group ETA).
 */ const $2b7ad95a2c11b3ea$var$GroceryPlatformLogos = ()=>{
    const { etaByPlatform: etaByPlatform, etaLoading: etaLoading, hasCoords: hasCoords, openByPlatform: openByPlatform } = (0, $24dcc62c2df3455e$export$8334c7d775399ded)();
    const etaLine = (platform)=>{
        if (!hasCoords) return "\u2014";
        if (etaLoading && !etaByPlatform[platform]) return "\u2026";
        if (openByPlatform[platform] === false) return 'Closed';
        const t = etaByPlatform[platform];
        return t && t.trim() ? t : "\u2014";
    };
    return /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
        className: "flex flex-col items-center justify-center mb-8 px-2",
        children: [
            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                className: "text-xs font-semibold uppercase tracking-wider text-neutral-400 dark:text-neutral-500 mb-4",
                children: "Comparing from"
            }),
            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                className: "flex flex-wrap items-start justify-center gap-x-4 gap-y-6 sm:gap-x-6 max-w-2xl",
                "aria-label": "Grocery platforms compared",
                children: $2b7ad95a2c11b3ea$var$GROCERY_PLATFORMS.map((p)=>/*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                        className: "flex w-[4.5rem] sm:w-[5rem] flex-col items-center gap-2 text-center",
                        children: [
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                                className: " flex h-14 w-14 sm:h-16 sm:w-16 shrink-0 items-center justify-center rounded-full overflow-hidden border-[3px] border-white dark:border-neutral-950 bg-white dark:bg-neutral-900 shadow-[0_4px_14px_rgba(0,0,0,0.08)] dark:shadow-[0_4px_14px_rgba(0,0,0,0.35)] ring-1 ring-neutral-200/90 dark:ring-neutral-700 ",
                                title: p.label,
                                children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("img", {
                                    src: (0, $c415184affb3c148$export$95bc294db34c3e24)(p.platform),
                                    alt: "",
                                    className: "h-9 w-9 sm:h-10 sm:w-10 object-contain",
                                    loading: "lazy",
                                    referrerPolicy: "no-referrer",
                                    decoding: "async",
                                    onError: (e)=>{
                                        const el = e.currentTarget;
                                        const fallback = (0, $c415184affb3c148$export$91054406962f6412)(p.platform);
                                        if (fallback && el.src !== fallback) {
                                            el.src = fallback;
                                            return;
                                        }
                                        el.style.display = 'none';
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                                className: "text-[10px] sm:text-[11px] font-semibold leading-tight text-neutral-700 dark:text-neutral-200 tabular-nums min-h-[2.5rem] flex items-start justify-center px-0.5",
                                title: `Delivery time \xb7 ${p.label}`,
                                children: etaLine(p.platform)
                            })
                        ]
                    }, p.platform))
            })
        ]
    });
};
var $2b7ad95a2c11b3ea$export$2e2bcd8739ae039 = $2b7ad95a2c11b3ea$var$GroceryPlatformLogos;



parcelRequire("5jV9H");
const $2d455e2b6085b916$var$SECTIONS = [
    {
        title: 'Grocery & Kitchen',
        items: [
            {
                label: 'Vegetables & Fruits',
                query: 'vegetables fruits',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Vegetables_&_Fruits_312x360_1765863495231'
            },
            {
                label: 'Atta, Rice & Dal',
                query: 'rice atta dal',
                image: 'https://cdn.grofers.com/app/images/collections/asset_atta,_rice_&_dal_1697023078302'
            },
            {
                label: 'Oil, Ghee & Masala',
                query: 'cooking oil ghee masala',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Oil,_ghee_&_masala_1697023177309'
            },
            {
                label: 'Dairy, Bread & Eggs',
                query: 'milk bread eggs',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Dairy,_bread_&_eggs_1697439479199'
            },
            {
                label: 'Bakery & Biscuits',
                query: 'biscuits bakery',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Biscuits_&_bakery_1697023878012'
            },
            {
                label: 'Dry Fruits & Cereals',
                query: 'dry fruits cereal',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Dry_Fruits_&_Cereals_(1)_1727547591238'
            },
            {
                label: 'Chicken, Meat & Fish',
                query: 'chicken meat fish',
                image: 'https://cdn.grofers.com/app/images/collections/asset_chicken,_meat_&_fish_1697025365538'
            },
            {
                label: 'Kitchenware & Accessories',
                query: 'kitchenware',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Kitchen_Utensils_&_1697802997422'
            }
        ]
    },
    {
        title: 'Snacks & Drinks',
        items: [
            {
                label: 'Chips & Namkeen',
                query: 'chips namkeen',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Chips_&_namkeen_1697025537433'
            },
            {
                label: 'Sweets & Chocolates',
                query: 'chocolate sweets',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Sweets_&_chocolates_1697025717829'
            },
            {
                label: 'Drinks & Juices',
                query: 'juice cold drink',
                image: 'https://cdn.grofers.com/app/images/collections/asset_V7_312x360_(2)_1774455548692'
            },
            {
                label: 'Tea, Coffee & Milk Drinks',
                query: 'tea coffee',
                image: 'https://cdn.grofers.com/app/images/collections/asset_L0_v1_0_1746557294148'
            },
            {
                label: 'Instant Food',
                query: 'instant noodles soup',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Instant_Food_(2)_1766127254031'
            },
            {
                label: 'Sauces & Spreads',
                query: 'sauce jam spread',
                image: 'https://cdn.grofers.com/app/images/collections/asset_sauces_&_spreads_1697025783179'
            },
            {
                label: 'Paan Corner',
                query: 'mouth freshener',
                image: 'https://cdn.grofers.com/app/images/collections/asset_312x360_(1)_1750440200815'
            },
            {
                label: 'Ice Creams & More',
                query: 'ice cream',
                image: 'https://cdn.grofers.com/app/images/collections/asset_V7_312x360_(1)_1763118369111'
            }
        ]
    },
    {
        title: 'Beauty & Personal Care',
        items: [
            {
                label: 'Bath & Body',
                query: 'soap body wash lotion',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Bath_&_Body_1697028879274'
            },
            {
                label: 'Hair Care',
                query: 'shampoo conditioner hair oil',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Hair_1697025936187'
            },
            {
                label: 'Skin & Face Care',
                query: 'face wash moisturizer skin care',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Skin_&_face_(1)_1710665369044'
            },
            {
                label: 'Beauty & Cosmetics',
                query: 'makeup lipstick beauty',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Beauty_&_Cosmetics_1714732446632'
            },
            {
                label: 'Feminine Hygiene',
                query: 'sanitary pads feminine care',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Feminine_hygiene_1697028415717'
            },
            {
                label: 'Baby Care',
                query: 'baby care wipes diapers',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Baby_care_1697028457580'
            },
            {
                label: 'Health & Pharma',
                query: 'medicine health supplements',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Health_&_pharma_1697028551531'
            },
            {
                label: 'Sexual Wellness',
                query: 'sexual wellness personal care',
                image: 'https://cdn.grofers.com/app/images/collections/asset_Sexual_wellness_1697028588156'
            }
        ]
    }
];
const $2d455e2b6085b916$var$GroceryCategoryNav = ({ onPickSearch: onPickSearch })=>{
    return /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("nav", {
        className: "w-full",
        "aria-label": "Browse grocery categories",
        children: $2d455e2b6085b916$var$SECTIONS.map((section)=>/*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                className: "mb-10 last:mb-6",
                children: [
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("h2", {
                        className: "mb-3 text-left text-base font-bold tracking-tight text-neutral-900 dark:text-white sm:text-lg",
                        children: section.title
                    }),
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                        className: "grid grid-cols-4 gap-2 sm:gap-3 md:gap-4",
                        children: section.items.map((item)=>/*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>onPickSearch(item.query),
                                className: "group flex flex-col items-center text-center focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400 focus-visible:ring-offset-2 rounded-xl dark:focus-visible:ring-offset-neutral-950",
                                children: [
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                                        className: "relative w-full overflow-hidden rounded-xl bg-[#eef2f4] dark:bg-neutral-800/70 aspect-square shadow-sm ring-1 ring-black/[0.04] dark:ring-white/10 transition-transform group-hover:scale-[1.02] group-active:scale-[0.98]",
                                        children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("img", {
                                            src: item.image,
                                            alt: "",
                                            className: "h-full w-full object-cover",
                                            loading: "lazy",
                                            decoding: "async",
                                            referrerPolicy: "no-referrer"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                                        className: "mt-2 line-clamp-2 min-h-[2.5rem] w-full px-0.5 text-[11px] font-medium leading-snug text-neutral-800 dark:text-neutral-200 sm:text-xs",
                                        children: item.label
                                    })
                                ]
                            }, item.label))
                    })
                ]
            }, section.title))
    });
};
var $2d455e2b6085b916$export$2e2bcd8739ae039 = $2d455e2b6085b916$var$GroceryCategoryNav;



parcelRequire("5jV9H");
const $2b07605f7581d10b$var$STEPS = [
    {
        title: 'Lock your area',
        points: [
            'Enter your pincode or use current location to show live prices and delivery times.'
        ],
        icon: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("svg", {
            className: "h-7 w-7",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            "aria-hidden": true,
            children: [
                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.75,
                    d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                }),
                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.75,
                    d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                })
            ]
        })
    },
    {
        title: 'Search once, see everyone',
        points: [
            'Use the search bar and see apps compared side by side in a grid.'
        ],
        icon: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("svg", {
            className: "h-7 w-7",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            "aria-hidden": true,
            children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.75,
                d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            })
        })
    },
    {
        title: 'Buy on the winner',
        points: [
            'Use Open and complete checkout in the partner app you trust.'
        ],
        icon: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("svg", {
            className: "h-7 w-7",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            "aria-hidden": true,
            children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.75,
                d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
            })
        })
    }
];
const $2b07605f7581d10b$var$HowItWorks = ()=>{
    return /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("section", {
        className: "mb-10",
        "aria-labelledby": "how-it-works-heading",
        children: [
            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("h2", {
                id: "how-it-works-heading",
                className: "mb-4 text-left text-xl font-bold tracking-tight text-neutral-900 dark:text-white sm:text-2xl",
                children: "How it works"
            }),
            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                className: "flex flex-col gap-3 sm:gap-4",
                children: $2b07605f7581d10b$var$STEPS.map((step)=>/*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                        className: "flex gap-4 rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-700 dark:bg-neutral-800/80 dark:shadow-[0_2px_12px_rgba(0,0,0,0.2)] sm:p-5",
                        children: [
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                                className: "flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-yellow-100 text-yellow-800 dark:bg-yellow-400/15 dark:text-yellow-400",
                                "aria-hidden": true,
                                children: step.icon
                            }),
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                className: "min-w-0 flex-1 pt-0.5",
                                children: [
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("h3", {
                                        className: "text-base font-bold text-neutral-900 dark:text-white",
                                        children: step.title
                                    }),
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("ul", {
                                        className: "mt-2 list-none space-y-1.5 p-0 text-sm text-neutral-600 dark:text-neutral-400",
                                        children: step.points.map((p)=>/*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("li", {
                                                className: "leading-snug",
                                                children: p
                                            }, p))
                                    })
                                ]
                            })
                        ]
                    }, step.title))
            })
        ]
    });
};
var $2b07605f7581d10b$export$2e2bcd8739ae039 = $2b07605f7581d10b$var$HowItWorks;



parcelRequire("5jV9H");

const $3b937c931ecf63d6$var$valyuxLogo = new URL($27e2627fb6cf48ca$exports).href;
const $3b937c931ecf63d6$var$FloatingCartBar = ({ itemCount: itemCount, totalRupee: totalRupee, onViewCart: onViewCart })=>{
    if (itemCount <= 0) return null;
    const itemsLabel = itemCount === 1 ? '1 item' : `${itemCount} items`;
    const formatted = Math.round(totalRupee).toLocaleString('en-IN');
    return /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
        className: "fixed bottom-0 left-0 right-0 z-40 flex justify-center pointer-events-none px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-2",
        children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("button", {
            type: "button",
            onClick: onViewCart,
            className: "pointer-events-auto flex w-full max-w-lg items-center gap-3 rounded-full bg-white pl-2.5 pr-4 py-2.5 text-left text-black shadow-lg shadow-black/15 ring-1 ring-black/10 transition hover:ring-black/20 active:scale-[0.99] focus:outline-none focus-visible:ring-2 focus-visible:ring-black/30 dark:bg-black dark:text-white dark:shadow-black/50 dark:ring-white/15 dark:hover:ring-white/25 dark:focus-visible:ring-white/40",
            "aria-label": `View cart, ${itemsLabel}, ${formatted} rupees`,
            children: [
                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                    className: "flex shrink-0 items-center justify-center",
                    children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("img", {
                        src: $3b937c931ecf63d6$var$valyuxLogo,
                        alt: "",
                        className: "h-9 w-9 rounded-lg object-contain",
                        "aria-hidden": true
                    })
                }),
                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                    className: "min-w-0 flex-1",
                    children: [
                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                            className: "block text-sm font-normal text-black/75 dark:text-white/80",
                            children: itemsLabel
                        }),
                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                            className: "block text-base font-bold tabular-nums text-black dark:text-white",
                            children: [
                                "\u20B9",
                                formatted
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                    className: "flex shrink-0 items-center gap-1 text-sm font-bold text-black dark:text-white",
                    children: [
                        "View Cart",
                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("svg", {
                            className: "h-3.5 w-3.5 text-current",
                            viewBox: "0 0 12 12",
                            fill: "currentColor",
                            "aria-hidden": true,
                            children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("path", {
                                d: "M4 2 L9 6 L4 10 z"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $3b937c931ecf63d6$export$2e2bcd8739ae039 = $3b937c931ecf63d6$var$FloatingCartBar;



var $5jV9H = parcelRequire("5jV9H");
/** GA4 measurement ID from build env (Vercel / local `.env`). */ function $f55e4a7d45f5f9a0$export$9853691218a43b6d() {
    const raw = "G-B9BY1CG1CQ";
    const id = typeof raw === 'string' ? raw.trim() : '';
    if (!id || !id.startsWith('G-')) return null;
    return id;
}
function $f55e4a7d45f5f9a0$export$8d2b6f129245731e(pagePath, pageTitle) {
    if (typeof window === 'undefined' || !$f55e4a7d45f5f9a0$export$9853691218a43b6d()) return;
    const title = pageTitle || (typeof document !== 'undefined' ? document.title : '');
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const page_location = origin && pagePath ? `${origin}${pagePath.startsWith('/') ? '' : '/'}${pagePath}` : undefined;
    const run = ()=>{
        if (typeof window.gtag !== 'function') return false;
        window.gtag('event', 'page_view', {
            page_path: pagePath,
            page_title: title,
            ...page_location ? {
                page_location: page_location
            } : {}
        });
        return true;
    };
    if (run()) return;
    window.setTimeout(()=>void run(), 0);
    window.setTimeout(()=>void run(), 100);
}


let $ac8f5c29a6884c31$var$gtagBootstrapStarted = false;
/**
 * Loads GA4 (gtag.js) when `GA_MEASUREMENT_ID` is set at build time.
 * Default `send_page_view` stays on so the first hit reaches GA once gtag.js loads (helps Realtime).
 * Section changes still send extra `page_view` events from `gaTrackPageView`.
 */ const $ac8f5c29a6884c31$var$GoogleAnalytics = ()=>{
    (0, $5jV9H.useEffect)(()=>{
        const id = (0, $f55e4a7d45f5f9a0$export$9853691218a43b6d)();
        if (!id || $ac8f5c29a6884c31$var$gtagBootstrapStarted) return;
        $ac8f5c29a6884c31$var$gtagBootstrapStarted = true;
        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag(...args) {
            window.dataLayer.push(args);
        };
        window.gtag('js', new Date());
        window.gtag('config', id);
        const existing = document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`);
        if (existing) return;
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
        document.head.appendChild(script);
    }, []);
    return null;
};
var $ac8f5c29a6884c31$export$2e2bcd8739ae039 = $ac8f5c29a6884c31$var$GoogleAnalytics;



const $bb0afab29a25db0d$var$AppContent = ()=>{
    const { pincode: pincode, addressLabel: addressLabel, lat: lat, lon: lon, setDeliveryLocation: setDeliveryLocation, hasPincode: hasPincode, hasCoords: hasCoords, etaLoading: etaLoading, etaError: etaError, openByPlatform: openByPlatform } = (0, $24dcc62c2df3455e$export$8334c7d775399ded)();
    const [cart, setCart] = (0, $5jV9H.useState)(()=>(0, $2c088e6e7f3e7a96$export$a822875dec294e4d)());
    const [isCartOpen, setIsCartOpen] = (0, $5jV9H.useState)(false);
    const [searchQuery, setSearchQuery] = (0, $5jV9H.useState)(()=>(0, $2c088e6e7f3e7a96$export$80b058555503f6da)());
    const [searchDraft, setSearchDraft] = (0, $5jV9H.useState)(()=>(0, $2c088e6e7f3e7a96$export$80b058555503f6da)());
    const [liveProducts, setLiveProducts] = (0, $5jV9H.useState)([]);
    const [isSearching, setIsSearching] = (0, $5jV9H.useState)(false);
    const [searchProgress, setSearchProgress] = (0, $5jV9H.useState)(0);
    const [searchError, setSearchError] = (0, $5jV9H.useState)(null);
    const [geoLoading, setGeoLoading] = (0, $5jV9H.useState)(false);
    const [geoError, setGeoError] = (0, $5jV9H.useState)(null);
    const [showGeoPermissionModal, setShowGeoPermissionModal] = (0, $5jV9H.useState)(false);
    const debouncedQuery = (0, $c1d2ccc0dc6c2950$export$21805fee57372823)(searchQuery, 600);
    const abortRef = (0, $5jV9H.useRef)(null);
    const geoReverseAbortRef = (0, $5jV9H.useRef)(null);
    (0, $5jV9H.useEffect)(()=>()=>geoReverseAbortRef.current?.abort(), []);
    (0, $5jV9H.useEffect)(()=>{
        (0, $2c088e6e7f3e7a96$export$94666d3983dc6b91)(cart);
    }, [
        cart
    ]);
    (0, $5jV9H.useEffect)(()=>{
        (0, $2c088e6e7f3e7a96$export$3b7c368697f35c3d)(searchQuery);
    }, [
        searchQuery
    ]);
    (0, $5jV9H.useEffect)(()=>{
        if (!(0, $f55e4a7d45f5f9a0$export$9853691218a43b6d)()) return;
        (0, $f55e4a7d45f5f9a0$export$8d2b6f129245731e)('/grocery', "Valyux \xb7 Grocery");
    }, []);
    const submitGrocerySearch = ()=>{
        setSearchQuery(searchDraft.trim());
    };
    const progressTimerRef = (0, $5jV9H.useRef)(null);
    const SIMILAR_NAME_THRESHOLD = 0.72;
    const MRP_MATCH_EPS = 2;
    (0, $5jV9H.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        if (!hasPincode) return;
        if (!('geolocation' in navigator)) return;
        const key = 'valyux-geo-permission-modal';
        if (sessionStorage.getItem(key) === '1') return;
        setShowGeoPermissionModal(true);
    }, [
        hasPincode
    ]);
    (0, $5jV9H.useEffect)(()=>{
        if (!hasPincode || !hasCoords || !debouncedQuery || debouncedQuery.length < 2) {
            setLiveProducts([]);
            setSearchError(null);
            setSearchProgress(0);
            return;
        }
        if (abortRef.current) abortRef.current.abort();
        abortRef.current = new AbortController();
        const fetchLive = async ()=>{
            setIsSearching(true);
            setSearchProgress(10);
            if (progressTimerRef.current) {
                window.clearInterval(progressTimerRef.current);
                progressTimerRef.current = null;
            }
            progressTimerRef.current = window.setInterval(()=>{
                setSearchProgress((p)=>Math.min(90, p + 6 + Math.random() * 10));
            }, 350);
            setSearchError(null);
            try {
                const result = await (0, $82a7fb16635378a2$export$a781579ca247470)(debouncedQuery, lat, lon, pincode);
                const products = (result.results || []).map((p)=>({
                        id: String(p.id ?? ''),
                        name: String(p.name ?? ''),
                        brand: String(p.brand ?? ''),
                        quantity: String(p.quantity ?? ''),
                        imageUrl: String(p.imageUrl ?? ''),
                        category: String(p.category ?? 'Other'),
                        platformPrices: (Array.isArray(p.platformPrices) ? p.platformPrices : []).map((pp)=>({
                                platform: pp.platform,
                                price: Number(pp.price) || 0,
                                originalPrice: Number(pp.originalPrice) || 0,
                                deliveryTime: String(pp.deliveryTime ?? "\u2014"),
                                productUrl: typeof pp.productUrl === 'string' ? pp.productUrl : undefined,
                                externalItemId: typeof pp.externalItemId === 'string' ? pp.externalItemId : undefined
                            }))
                    }));
                setLiveProducts(products);
            } catch (err) {
                if (err instanceof Error && err.name === 'AbortError') return;
                setSearchError(err instanceof Error ? err.message : 'Search failed');
                setLiveProducts([]);
            } finally{
                if (progressTimerRef.current) {
                    window.clearInterval(progressTimerRef.current);
                    progressTimerRef.current = null;
                }
                setSearchProgress(100);
                setIsSearching(false);
                window.setTimeout(()=>setSearchProgress(0), 350);
            }
        };
        fetchLive();
        return ()=>{
            abortRef.current?.abort();
            if (progressTimerRef.current) {
                window.clearInterval(progressTimerRef.current);
                progressTimerRef.current = null;
            }
            setSearchProgress(0);
        };
    }, [
        debouncedQuery,
        pincode,
        hasPincode,
        hasCoords,
        lat,
        lon
    ]);
    const handleUseCurrentLocation = ()=>{
        setGeoError(null);
        if (typeof navigator === 'undefined' || !navigator.geolocation) {
            setGeoError('Geolocation is not supported in this browser');
            return;
        }
        geoReverseAbortRef.current?.abort();
        geoReverseAbortRef.current = new AbortController();
        const signal = geoReverseAbortRef.current.signal;
        setGeoLoading(true);
        navigator.geolocation.getCurrentPosition(async (pos)=>{
            try {
                if (signal.aborted) return;
                const latNum = pos.coords.latitude;
                const lonNum = pos.coords.longitude;
                const geo = await (0, $549d80f1a40ce8cc$export$f4666fc7f52a0aa8)(latNum, lonNum, signal);
                if (signal.aborted) return;
                setDeliveryLocation({
                    pincode: geo.pincode,
                    addressLabel: geo.addressLabel || `Pincode ${geo.pincode}`,
                    lat: geo.lat,
                    lon: geo.lon
                });
            } catch (err) {
                const aborted = err instanceof DOMException && err.name === 'AbortError' || err instanceof Error && err.name === 'AbortError';
                if (aborted) return;
                setGeoError(err instanceof Error ? err.message : 'Could not fetch your current location');
            } finally{
                if (!signal.aborted) setGeoLoading(false);
            }
        }, (e)=>{
            setGeoLoading(false);
            const msg = e.code === e.PERMISSION_DENIED ? 'Location permission denied' : 'Could not access your location';
            setGeoError(msg);
        }, {
            enableHighAccuracy: true,
            timeout: 15000,
            maximumAge: 0
        });
    };
    const normalizeNameForCompare = (s)=>(s || '').toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
    const normalizeQtyForCompare = (q)=>(q || '').toLowerCase().replace(/\s+/g, '').replace(/\.0+(?=\D|$)/g, '').trim();
    const tokenSimilarity = (a, b)=>{
        const ta = a.split(' ').filter(Boolean);
        const tb = b.split(' ').filter(Boolean);
        if (ta.length === 0 || tb.length === 0) return 0;
        if (a === b) return 1;
        if (a.includes(b) || b.includes(a)) return 1;
        const setA = new Set(ta);
        const setB = new Set(tb);
        let inter = 0;
        for (const t of setA)if (setB.has(t)) inter += 1;
        return inter / Math.max(setA.size, setB.size);
    };
    const isQuantityCompatible = (a, b)=>{
        const qa = normalizeQtyForCompare(a);
        const qb = normalizeQtyForCompare(b);
        if (!qa || !qb) return true;
        return qa === qb;
    };
    const listingMrp = (p)=>Math.max(0, ...p.platformPrices.map((pp)=>Number(pp.originalPrice) || 0));
    const isMrpCompatible = (a, b)=>{
        const ma = listingMrp(a);
        const mb = listingMrp(b);
        if (ma <= 0 || mb <= 0) return true;
        return Math.abs(ma - mb) <= MRP_MATCH_EPS;
    };
    const groceryQueryMatchScore = (rawQuery, product)=>{
        const q = normalizeNameForCompare(rawQuery).trim();
        if (!q) return 0;
        const hay = normalizeNameForCompare(`${product.name} ${product.brand || ''}`);
        if (!hay) return 0;
        if (hay.includes(q)) return 1000;
        const qTokens = q.split(' ').filter((t)=>t.length >= 2);
        if (qTokens.length === 0) return 0;
        let matched = 0;
        for (const t of qTokens)if (hay.includes(t)) matched += 1;
        return Math.round(matched / qTokens.length * 500);
    };
    const displayProducts = (0, $5jV9H.useMemo)(()=>{
        if (debouncedQuery.length < 2) return [];
        const filtered = liveProducts.map((p)=>{
            const platformPrices = p.platformPrices.filter((pp)=>openByPlatform[pp.platform] !== false);
            return platformPrices.length > 0 ? {
                ...p,
                platformPrices: platformPrices
            } : null;
        }).filter((p)=>p !== null);
        const groups = [];
        for (const candidate of filtered){
            const candidateName = normalizeNameForCompare(candidate.name);
            const candidateBrand = normalizeNameForCompare(candidate.brand || '');
            const target = groups.find((existing)=>{
                const existingName = normalizeNameForCompare(existing.name);
                const similar = tokenSimilarity(existingName, candidateName) >= SIMILAR_NAME_THRESHOLD;
                if (!similar) return false;
                const existingBrand = normalizeNameForCompare(existing.brand || '');
                if (candidateBrand && existingBrand && candidateBrand !== existingBrand) return false;
                if (!isQuantityCompatible(existing.quantity, candidate.quantity)) return false;
                return isMrpCompatible(existing, candidate);
            });
            if (!target) {
                groups.push({
                    ...candidate,
                    platformPrices: [
                        ...candidate.platformPrices
                    ]
                });
                continue;
            }
            const byPlatform = new Map();
            for (const pp of target.platformPrices)byPlatform.set(pp.platform, pp);
            for (const pp of candidate.platformPrices){
                const existing = byPlatform.get(pp.platform);
                if (!existing || pp.price < existing.price) byPlatform.set(pp.platform, pp);
            }
            target.platformPrices = Array.from(byPlatform.values()).sort((a, b)=>a.price - b.price);
            if (!target.quantity && candidate.quantity) target.quantity = candidate.quantity;
            if (!target.brand && candidate.brand) target.brand = candidate.brand;
            if (!target.imageUrl && candidate.imageUrl) target.imageUrl = candidate.imageUrl;
        }
        const cheapest = (p)=>Math.min(...p.platformPrices.map((pp)=>pp.price || Infinity));
        return [
            ...groups
        ].sort((a, b)=>{
            const ra = groceryQueryMatchScore(debouncedQuery, a);
            const rb = groceryQueryMatchScore(debouncedQuery, b);
            if (rb !== ra) return rb - ra;
            const pa = a.platformPrices.length;
            const pb = b.platformPrices.length;
            if (pb !== pa) return pb - pa;
            return cheapest(a) - cheapest(b);
        });
    }, [
        liveProducts,
        debouncedQuery,
        openByPlatform
    ]);
    const handleAddToCart = (product, platform)=>{
        setCart((prev)=>{
            const newName = normalizeNameForCompare(product.name);
            const newBrand = normalizeNameForCompare(product.brand || '');
            const newQty = normalizeQtyForCompare(product.quantity);
            const existing = prev.find((item)=>{
                if (item.selectedPlatform !== platform) return false;
                if (normalizeQtyForCompare(item.product.quantity) !== newQty) return false;
                const itemName = normalizeNameForCompare(item.product.name);
                const sim = tokenSimilarity(itemName, newName);
                if (sim < 0.72) return false;
                const itemBrand = normalizeNameForCompare(item.product.brand || '');
                if (newBrand && itemBrand && itemBrand !== newBrand) return false;
                return true;
            });
            if (existing) return prev.map((item)=>item.product.id === existing.product.id && item.selectedPlatform === platform ? {
                    ...item,
                    quantity: item.quantity + 1
                } : item);
            return [
                ...prev,
                {
                    product: product,
                    selectedPlatform: platform,
                    quantity: 1
                }
            ];
        });
    };
    const handleUpdateQuantity = (productId, platform, delta)=>{
        setCart((prev)=>prev.map((item)=>{
                if (item.product.id === productId && item.selectedPlatform === platform) return {
                    ...item,
                    quantity: Math.max(0, item.quantity + delta)
                };
                return item;
            }).filter((item)=>item.quantity > 0));
    };
    const cartCount = cart.reduce((acc, item)=>acc + item.quantity, 0);
    const cartSubtotal = (0, $5jV9H.useMemo)(()=>cart.reduce((acc, item)=>{
            const price = item.product.platformPrices.find((pp)=>pp.platform === item.selectedPlatform)?.price ?? 0;
            return acc + price * item.quantity;
        }, 0), [
        cart
    ]);
    const showFloatingCartBar = cartCount > 0 && !isCartOpen;
    if (!hasPincode) return /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
        className: "min-h-screen flex flex-col bg-white dark:bg-neutral-950 transition-colors duration-300",
        children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)((0, $1dbff0aa5bfa1cb5$export$55d05cc2d01dc042), {
            onConfirm: setDeliveryLocation
        })
    });
    return /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
        className: "min-h-screen flex flex-col bg-white dark:bg-neutral-950 transition-colors duration-300",
        children: [
            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)((0, $b3f1cf32d4482287$export$2e2bcd8739ae039), {
                cartCount: cartCount,
                onCartClick: ()=>setIsCartOpen(true),
                searchQuery: searchDraft,
                onSearchChange: setSearchDraft,
                onSearchSubmit: submitGrocerySearch,
                onLogoClick: ()=>{
                    setIsCartOpen(false);
                    setSearchDraft('');
                    setSearchQuery('');
                    try {
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        });
                    } catch  {
                        window.scrollTo(0, 0);
                    }
                }
            }),
            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("main", {
                className: `flex-1 max-w-6xl mx-auto w-full px-4 py-6 ${showFloatingCartBar ? 'pb-24 sm:pb-28' : ''}`,
                onClick: (e)=>{
                    if (searchQuery.trim().length < 2) return;
                    const t = e.target;
                    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
                    const active = document.activeElement;
                    active?.blur?.();
                },
                children: [
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                        className: "mb-4 flex flex-col items-center text-center sm:mb-5",
                        children: [
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("h1", {
                                className: "text-xl sm:text-2xl font-bold text-neutral-900 dark:text-white tracking-tight",
                                children: "Compare & buy grocery at the best price"
                            }),
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                className: "mt-2 max-w-lg px-1",
                                children: [
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("p", {
                                        className: "text-sm text-neutral-600 dark:text-neutral-300",
                                        children: [
                                            addressLabel ? /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)((0, $c56b12d5022cecd0$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                                                        className: "font-medium",
                                                        children: addressLabel
                                                    }),
                                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                                                        className: "mx-1 text-neutral-400",
                                                        children: "\xb7"
                                                    })
                                                ]
                                            }) : null,
                                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                                                className: "text-neutral-500 dark:text-neutral-400",
                                                children: [
                                                    "Pincode ",
                                                    pincode
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                        className: "mt-2 flex flex-wrap items-center justify-center gap-x-6 gap-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setDeliveryLocation({
                                                        pincode: '',
                                                        addressLabel: ''
                                                    }),
                                                className: "text-xs font-medium text-yellow-700 hover:text-yellow-600 dark:text-yellow-400 dark:hover:text-yellow-300 underline underline-offset-2",
                                                children: "Change location"
                                            }),
                                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                                                type: "button",
                                                onClick: handleUseCurrentLocation,
                                                disabled: geoLoading,
                                                className: "text-xs font-medium text-neutral-700 hover:text-neutral-900 dark:text-neutral-200 dark:hover:text-white underline underline-offset-2 disabled:opacity-60",
                                                children: geoLoading ? "Getting location\u2026" : 'Use current location'
                                            })
                                        ]
                                    }),
                                    geoError && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                                        className: "text-xs text-amber-600 dark:text-amber-400 mt-1",
                                        children: geoError
                                    }),
                                    etaLoading && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                                        className: "text-xs text-neutral-500 mt-2",
                                        children: "Loading delivery times\u2026"
                                    }),
                                    etaError && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                                        className: "text-xs text-amber-600 dark:text-amber-400 mt-2",
                                        children: etaError
                                    }),
                                    !hasCoords && hasPincode && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                                        className: "text-xs text-amber-600 dark:text-amber-400 mt-2",
                                        children: "Locating your area for live prices\u2026"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)((0, $2b7ad95a2c11b3ea$export$2e2bcd8739ae039), {}),
                    searchQuery.trim().length === 0 && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)((0, $c56b12d5022cecd0$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)((0, $2d455e2b6085b916$export$2e2bcd8739ae039), {
                                onPickSearch: (q)=>{
                                    setSearchDraft(q);
                                    setSearchQuery(q);
                                }
                            }),
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)((0, $2b07605f7581d10b$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    searchQuery.length >= 2 && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-2 text-sm text-neutral-500",
                                children: [
                                    isSearching && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                                        children: "Searching..."
                                    }),
                                    !isSearching && liveProducts.length > 0 && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("span", {
                                        children: [
                                            displayProducts.length,
                                            " results"
                                        ]
                                    }),
                                    searchError && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("span", {
                                        className: "text-red-600 dark:text-red-400",
                                        children: searchError
                                    })
                                ]
                            }),
                            isSearching && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                                className: "mt-2 h-2 w-full rounded-full bg-neutral-100 overflow-hidden dark:bg-neutral-800",
                                children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                                    className: "h-full bg-yellow-400 transition-[width] duration-200",
                                    style: {
                                        width: `${searchProgress}%`
                                    }
                                })
                            })
                        ]
                    }),
                    searchQuery.length >= 2 && (isSearching || displayProducts.length > 0) && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                        className: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-6",
                        children: isSearching && displayProducts.length === 0 ? Array.from({
                            length: 10
                        }).map((_, i)=>/*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)((0, $e2f42211602dbfa6$export$f0fd42021896dce9), {}, `sk-${i}`)) : displayProducts.map((product)=>/*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)((0, $e2f42211602dbfa6$export$2e2bcd8739ae039), {
                                product: product,
                                onAddToCart: handleAddToCart
                            }, product.id))
                    }),
                    searchQuery.length >= 2 && !isSearching && displayProducts.length === 0 && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                        className: "py-16 text-center",
                        children: [
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                                className: "text-sm text-neutral-500 dark:text-neutral-400",
                                children: 'No results. Try "milk", "bread", or "rice".'
                            }),
                            /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    setSearchDraft('');
                                    setSearchQuery('');
                                },
                                className: "mt-3 text-sm font-medium text-yellow-600 dark:text-yellow-400",
                                children: "Clear"
                            })
                        ]
                    })
                ]
            }),
            showGeoPermissionModal && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("div", {
                className: "fixed inset-0 z-[1000] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4",
                children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                    className: "w-full max-w-sm rounded-2xl border border-neutral-200 bg-white dark:border-neutral-700 dark:bg-neutral-950 p-4 shadow-2xl",
                    children: [
                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("h3", {
                            className: "text-base font-bold text-neutral-900 dark:text-white",
                            children: "Allow current location?"
                        }),
                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                            className: "mt-2 text-sm text-neutral-600 dark:text-neutral-300",
                            children: "This helps Valyux show the best live grocery prices near you."
                        }),
                        geoError && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("p", {
                            className: "mt-2 text-xs text-amber-700 dark:text-amber-400",
                            children: geoError
                        }),
                        /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)("div", {
                            className: "mt-4 flex gap-2",
                            children: [
                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>{
                                        try {
                                            sessionStorage.setItem('valyux-geo-permission-modal', '1');
                                        } catch  {}
                                        setShowGeoPermissionModal(false);
                                        handleUseCurrentLocation();
                                    },
                                    disabled: geoLoading,
                                    className: "flex-1 py-3 rounded-xl font-semibold bg-yellow-400 hover:bg-yellow-500 text-neutral-900 disabled:opacity-60",
                                    children: geoLoading ? "Getting location\u2026" : 'Allow'
                                }),
                                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>{
                                        try {
                                            sessionStorage.setItem('valyux-geo-permission-modal', '1');
                                        } catch  {}
                                        setShowGeoPermissionModal(false);
                                    },
                                    className: "flex-1 py-3 rounded-xl font-semibold bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100",
                                    children: "Not now"
                                })
                            ]
                        })
                    ]
                })
            }),
            showFloatingCartBar && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)((0, $3b937c931ecf63d6$export$2e2bcd8739ae039), {
                itemCount: cartCount,
                totalRupee: cartSubtotal,
                onViewCart: ()=>setIsCartOpen(true)
            }),
            isCartOpen && /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)((0, $2a47d05e44508b29$export$2e2bcd8739ae039), {
                items: cart,
                onClose: ()=>setIsCartOpen(false),
                onUpdateQuantity: handleUpdateQuantity
            })
        ]
    });
};
const $bb0afab29a25db0d$var$App = ()=>/*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)((0, $aa236c764a6c6983$export$d8964aec282183a3), {
        children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsxs)((0, $24dcc62c2df3455e$export$7025bb4dd876b4d2), {
            children: [
                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)((0, $ac8f5c29a6884c31$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)($bb0afab29a25db0d$var$AppContent, {})
            ]
        })
    });
var $bb0afab29a25db0d$export$2e2bcd8739ae039 = $bb0afab29a25db0d$var$App;


const $251924100aa15a1e$var$rootElement = document.getElementById('root');
if (!$251924100aa15a1e$var$rootElement) throw new Error("Could not find root element to mount to");
const $251924100aa15a1e$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($35103ae6fb992fb0$exports))).createRoot($251924100aa15a1e$var$rootElement);
$251924100aa15a1e$var$root.render(/*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5jV9H))).StrictMode, {
    children: /*#__PURE__*/ (0, $c56b12d5022cecd0$exports.jsx)((0, $bb0afab29a25db0d$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=path0.0d7e972b.js.map
